export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
  Upload: any;
};

/** An Appcues account. */
export type Account = {
  __typename?: 'Account';
  accountIdentifiers: AccountIdentifiers;
  addonMessageLimit?: Maybe<Scalars['Int']>;
  aiAllowAutonomousAgents?: Maybe<Scalars['Boolean']>;
  aiAllowEndUserData?: Maybe<Scalars['Boolean']>;
  aiAllowMcpServer?: Maybe<Scalars['Boolean']>;
  buffer?: Maybe<Scalars['Int']>;
  clickstreamEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  flowsShown?: Maybe<Scalars['Int']>;
  flowsShownLimit?: Maybe<Scalars['Int']>;
  /** The attribute name designated for humanizing all group profiles (e.g. accountName, company etc) */
  groupProfileIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insertedAt: Scalars['DateTime'];
  isTrial?: Maybe<Scalars['Boolean']>;
  isTrialExpired?: Maybe<Scalars['Boolean']>;
  lastSeenTimestamp?: Maybe<Scalars['DateTime']>;
  logoUrl?: Maybe<Scalars['String']>;
  messageLimit?: Maybe<Scalars['Int']>;
  mtuLimit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plan: Plan;
  planId?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  sandboxSlug?: Maybe<Scalars['String']>;
  sandboxUrl?: Maybe<Scalars['String']>;
  selectedInstallFramework?: Maybe<Scalars['String']>;
  siteUrl?: Maybe<Scalars['String']>;
  ssoDiscoverabilityEnabled?: Maybe<Scalars['Boolean']>;
  stripeEmail?: Maybe<Scalars['String']>;
  stripePlanId?: Maybe<Scalars['String']>;
  stripeSubCreatedAt?: Maybe<Scalars['DateTime']>;
  stripeSubEndedAt?: Maybe<Scalars['DateTime']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  stripeUrl?: Maybe<Scalars['String']>;
  testPassword?: Maybe<Scalars['String']>;
  testUrl?: Maybe<Scalars['String']>;
  testUsername?: Maybe<Scalars['String']>;
  throttleContentLimit?: Maybe<Scalars['Int']>;
  throttleContentTimespan?: Maybe<Scalars['Int']>;
  throttleContentTimespanMs?: Maybe<Scalars['Int']>;
  throttleEnabled?: Maybe<Scalars['Boolean']>;
  tier?: Maybe<Scalars['String']>;
  trialLengthDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  userCreatedAtField?: Maybe<Scalars['String']>;
  /** Field for designating which user profile attribute corresponds to email. Only used by NPS */
  userEmailField?: Maybe<Scalars['String']>;
  /** Legacy field for humanizing user profiles */
  userNameField?: Maybe<Scalars['String']>;
  /** The attribute name designated for humanizing all user profiles (e.g. name, email, userName, etc) */
  userProfileIdentifier?: Maybe<Scalars['String']>;
  /** Also known as the legacy API key */
  uuid: Scalars['String'];
};

/** Admin settings input object */
export type AccountAdminSettingsInput = {
  /** Allow autonomous agents to run for this account */
  aiAllowAutonomousAgents?: InputMaybe<Scalars['Boolean']>;
  /** Allow end user data to be used for AI features */
  aiAllowEndUserData?: InputMaybe<Scalars['Boolean']>;
  /** Allow MCP server access */
  aiAllowMcpServer?: InputMaybe<Scalars['Boolean']>;
  /** Enable or disable clickstream tracking */
  clickstreamEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type AccountDomain = {
  __typename?: 'AccountDomain';
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** Represents an account entitlement */
export type AccountEntitlement = {
  __typename?: 'AccountEntitlement';
  allowedUnits: Scalars['Int'];
  label: Scalars['String'];
  name: Scalars['String'];
  usedUnits: Scalars['Int'];
};

/** Account identifier configuration for user and group attributes */
export type AccountIdentifiers = {
  __typename?: 'AccountIdentifiers';
  /** The attribute name for identifying groups/accounts */
  accountIdentifier: Scalars['String'];
  /** The attribute name for user email addresses, if configured */
  emailProperty?: Maybe<Scalars['String']>;
  /** The attribute name for identifying users */
  userIdentifier: Scalars['String'];
};

/** Available roles for an account */
export enum AccountRole {
  /** Account admin */
  AccountAdmin = 'ACCOUNT_ADMIN',
  /** Account editor role */
  AccountEditor = 'ACCOUNT_EDITOR',
  /** Account publisher role */
  AccountPublisher = 'ACCOUNT_PUBLISHER',
  /** Account readonly role */
  AccountReadonly = 'ACCOUNT_READONLY',
  /** Mobile SDK role */
  MobileSdk = 'MOBILE_SDK'
}

/** Account setting input object */
export type AccountSettingsInput = {
  /** Frequency capping value */
  buffer?: InputMaybe<Scalars['Int']>;
  /** Available domain list */
  domains?: InputMaybe<Array<Scalars['String']>>;
  /** the primary identifier (attribute name) for group profile attributes */
  groupProfileIdentifier?: InputMaybe<Scalars['String']>;
  /** Company name */
  name?: InputMaybe<Scalars['String']>;
  /** Main site url */
  siteUrl?: InputMaybe<Scalars['String']>;
  /** SSO discoverability */
  ssoDiscoverabilityEnabled?: InputMaybe<Scalars['Boolean']>;
  /** the primary identifier (attribute name) for user profile attributes */
  userProfileIdentifier?: InputMaybe<Scalars['String']>;
};

/** Represents an account user with preloaded user and account (when requested) */
export type AccountUser = {
  __typename?: 'AccountUser';
  account?: Maybe<Account>;
  enabled?: Maybe<Scalars['Boolean']>;
  enabledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  insertedAt: Scalars['DateTime'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  roleId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userIntent: Array<Maybe<Scalars['String']>>;
  userUsageIntent: Array<Maybe<Scalars['String']>>;
};

/**
 * Represents an account user change containing the reason and the record's
 * latest related state.
 */
export type AccountUserChange = {
  __typename?: 'AccountUserChange';
  accountUser: AccountUser;
  reason: ChangeType;
};

/** Represents a set of AND conditions that an account user should match */
export type AccountUserFilter = {
  /** Decides to skip or include hidden users */
  skipHiddenUsers?: InputMaybe<Scalars['Boolean']>;
};

export type Action = {
  __typename?: 'Action';
  actionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
};

export type AddChartToDashboardInput = {
  dashboardId: Scalars['ID'];
  endTime?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<Array<Scalars['Json']>>;
  mode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  segmentId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  trailingDays?: InputMaybe<Scalars['Int']>;
  type: ChartType;
};

export type AddFunnelToDashboardInput = {
  conversionWindow?: InputMaybe<Scalars['Int']>;
  conversionWindowUnit?: InputMaybe<ConversionWindowUnit>;
  dashboardId: Scalars['ID'];
  name: Scalars['String'];
};

/** Input for adding a branch to an existing multipath task */
export type AddWorkflowTaskMultipathBranchInput = {
  multipathId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type AgentMemory = {
  __typename?: 'AgentMemory';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  insertedAt?: Maybe<Scalars['DateTime']>;
  ownerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Analytics timeframe input arguments */
export type AnalyticsTimeframe = {
  term: TimeframeTermValues;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** Annotation Node */
export type AnnotationNode = {
  __typename?: 'AnnotationNode';
  color?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  journeyCanvasId?: Maybe<Scalars['String']>;
  position?: Maybe<NodePosition>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an annotation node change containing the reason */
export type AnnotationNodeChange = {
  __typename?: 'AnnotationNodeChange';
  annotationNode?: Maybe<AnnotationNode>;
  reason: ChangeType;
};

/** Represents an App object */
export type App = {
  __typename?: 'App';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  platform: Scalars['String'];
  state: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

/** Represents an App change containing the reason */
export type AppChange = {
  __typename?: 'AppChange';
  app?: Maybe<App>;
  reason: ChangeType;
};

/** App push configuration */
export type AppPushConfig = {
  __typename?: 'AppPushConfig';
  android?: Maybe<Scalars['Boolean']>;
  appId?: Maybe<Scalars['String']>;
  ios?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an App push configuration change, containing the reason */
export type AppPushConfigChange = {
  __typename?: 'AppPushConfigChange';
  appPushConfig?: Maybe<AppPushConfig>;
  reason: ChangeType;
};

/** App push configuration platform status */
export type AppPushConfigPlatformStatus = {
  __typename?: 'AppPushConfigPlatformStatus';
  configured?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
};

/** App push configuration test result */
export type AppPushConfigTestResult = {
  __typename?: 'AppPushConfigTestResult';
  android?: Maybe<AppPushConfigPlatformStatus>;
  ios?: Maybe<AppPushConfigPlatformStatus>;
};

/** The outcome of a workflow archive attempt */
export type ArchiveWorkflowResult = {
  __typename?: 'ArchiveWorkflowResult';
  archived: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  workflow?: Maybe<Workflow>;
};

/** Assistant account agent access */
export type AssistantAccountAgent = {
  __typename?: 'AssistantAccountAgent';
  accountId?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Assistant account agent access change */
export type AssistantAccountAgentChange = {
  __typename?: 'AssistantAccountAgentChange';
  assistantAccountAgent?: Maybe<AssistantAccountAgent>;
  reason: ChangeType;
};

/** Assistant account rule */
export type AssistantAccountRule = {
  __typename?: 'AssistantAccountRule';
  accountId?: Maybe<Scalars['String']>;
  agent?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  overrideSystemRuleId?: Maybe<Scalars['ID']>;
  rule?: Maybe<Scalars['String']>;
  type?: Maybe<AssistantAccountRuleType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Assistant account rule change */
export type AssistantAccountRuleChange = {
  __typename?: 'AssistantAccountRuleChange';
  assistantAccountRule?: Maybe<AssistantAccountRule>;
  reason: ChangeType;
};

/** Create assistant account rule input object */
export type AssistantAccountRuleInput = {
  agent?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  overrideSystemRuleId?: InputMaybe<Scalars['ID']>;
  rule: Scalars['String'];
  type: AssistantAccountRuleType;
};

/** Assistant account rule type */
export enum AssistantAccountRuleType {
  /** Agent Requested */
  AgentRequested = 'AGENT_REQUESTED',
  /** Always */
  Always = 'ALWAYS',
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL'
}

/** Represents an assistant message */
export type AssistantMessage = {
  __typename?: 'AssistantMessage';
  id: Scalars['ID'];
  internal?: Maybe<Scalars['Boolean']>;
  message: Scalars['Json'];
  rating?: Maybe<AssistantMessageRating>;
  sessionId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

/** Assistant message rating values */
export enum AssistantMessageRating {
  /** Negative rating */
  ThumbsDown = 'THUMBS_DOWN',
  /** Positive rating */
  ThumbsUp = 'THUMBS_UP'
}

/** Represents an AssistantSession object */
export type AssistantSession = {
  __typename?: 'AssistantSession';
  accountId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messages?: Maybe<Array<AssistantMessage>>;
  rating?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents a AssistantSession change object with a reason */
export type AssistantSessionChange = {
  __typename?: 'AssistantSessionChange';
  assistantSession?: Maybe<AssistantSession>;
  reason: ChangeType;
};

/** Represents filter conditions that an assistant session should match */
export type AssistantSessionFilter = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  maxRating?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AssistantSessionListResult = {
  __typename?: 'AssistantSessionListResult';
  page?: Maybe<PaginationInfo>;
  sessions: Array<AssistantSession>;
};

/** Valid assistant session sort keys */
export enum AssistantSessionSortKey {
  /** When the session was created */
  CreatedAt = 'CREATED_AT',
  /** session rating */
  Rating = 'RATING',
  /** session title */
  Title = 'TITLE',
  /** Last time the session got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting sessions */
export type AssistantSessionSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: AssistantSessionSortKey;
};

export type BannerDayMetric = {
  __typename?: 'BannerDayMetric';
  /** Date of the event */
  day?: Maybe<Scalars['DateTime']>;
  /** Name of the event */
  event?: Maybe<Scalars['String']>;
  /** Total count of the event */
  events?: Maybe<Scalars['Int']>;
};

export type BannerMetricDeltas = {
  __typename?: 'BannerMetricDeltas';
  /** Absolute delta of click through percentage */
  uniqueClickThroughs?: Maybe<Scalars['Float']>;
  /** Percent delta of users who dismissed the banner */
  uniqueDismissed?: Maybe<Scalars['Float']>;
  /** Percent delta of users who started the banner */
  uniqueUsers?: Maybe<Scalars['Float']>;
};

export type BannerMetrics = {
  __typename?: 'BannerMetrics';
  /** Total times a banner was completed */
  bannerCompleted?: Maybe<Scalars['Int']>;
  /** Unique users who completed the banner (experience_completed) */
  bannerCompletedUsers?: Maybe<Scalars['Int']>;
  /** Percent changes of banner metrics */
  bannerMetricDeltas?: Maybe<BannerMetricDeltas>;
  /** Total times a banner was started */
  bannerStarted?: Maybe<Scalars['Int']>;
  /** Unique users who have started the banner (experience_started) */
  bannerUsers?: Maybe<Scalars['Int']>;
  /** Total step interactions / total steps seen */
  clickThroughPercentage?: Maybe<Scalars['Float']>;
  /** List of event total by day */
  dayMetrics?: Maybe<Array<Maybe<BannerDayMetric>>>;
  /** Total times the step was interacted with (step_interaction) */
  stepInteractionEvents?: Maybe<Scalars['Int']>;
  /** Unique users who interacted with the step (step_interaction) */
  stepInteractionUsers?: Maybe<Scalars['Int']>;
  /** List of step interaction events */
  stepInteractions?: Maybe<Array<Maybe<ExperienceStepInteractionMetric>>>;
  /** Total times the step was seen (step_seen) */
  stepSeenEvents?: Maybe<Scalars['Int']>;
  /** Unique users who saw the step (step_seen) */
  stepSeenUsers?: Maybe<Scalars['Int']>;
  /** Total times a banner was dismissed */
  totalDismissed?: Maybe<Scalars['Int']>;
  /** Unique users who have dismissed a banner */
  totalDismissedUsers?: Maybe<Scalars['Int']>;
};

/** Result of a bulk insight operation */
export type BulkInsightResult = {
  __typename?: 'BulkInsightResult';
  count: Scalars['Int'];
};

/** Input for bulk-setting the dismissed state of insights */
export type BulkSetInsightDismissedInput = {
  dismissed: Scalars['Boolean'];
  ids: Array<Scalars['ID']>;
};

/** Input for bulk-setting the read state of insights */
export type BulkSetInsightReadInput = {
  ids: Array<Scalars['ID']>;
  read: Scalars['Boolean'];
};

/**
 * Delivery cadence for a workflow. `IMMEDIATE` delivers per-event;
 * `DAILY`/`WEEKLY`/`MONTHLY` route through Knock's batch step to
 * accumulate events and deliver one digest per window.
 */
export enum Cadence {
  Daily = 'DAILY',
  Immediate = 'IMMEDIATE',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type Campaign = {
  __typename?: 'Campaign';
  brief?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /** Count of tactics that have at least one published experience */
  liveTacticsCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** Derived state: LIVE (any tactic is live), ARCHIVED (all archived), or DRAFT */
  state?: Maybe<Scalars['String']>;
  /** Tactics belonging to this campaign (batched to avoid N+1) */
  tactics: Array<Tactic>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type CampaignFilter = {
  /** Filter campaigns created on or after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Filter campaigns created on or before this date */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** Filter by creator user IDs */
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by derived states (DRAFT, LIVE, ARCHIVED). Defaults to [DRAFT, LIVE] */
  states?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by tag IDs */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Search by campaign name */
  term?: InputMaybe<Scalars['String']>;
  /** Filter by who last updated */
  updatedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Campaign list result with pagination info */
export type CampaignList = {
  __typename?: 'CampaignList';
  campaigns: Array<Campaign>;
  pageInfo?: Maybe<PageInfo>;
};

/** Valid campaign sort keys */
export enum CampaignSortKey {
  /** When the campaign was created */
  CreatedAt = 'CREATED_AT',
  /** Campaign name */
  Name = 'NAME',
  /** Last time the campaign was updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting campaigns */
export type CampaignSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: CampaignSortKey;
};

/** List of possible reasons an item changed within the system */
export enum ChangeType {
  /** Item archived */
  Archived = 'ARCHIVED',
  /** Item cloned */
  Cloned = 'CLONED',
  /** Item created */
  Created = 'CREATED',
  /** Item deleted */
  Deleted = 'DELETED',
  /** Item published */
  Published = 'PUBLISHED',
  /** Item unarchived */
  Unarchived = 'UNARCHIVED',
  /** Item unpublished */
  Unpublished = 'UNPUBLISHED',
  /** Item updated */
  Updated = 'UPDATED'
}

export type Chart = {
  __typename?: 'Chart';
  accountId: Scalars['String'];
  columns?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  dashboard?: Maybe<Dashboard>;
  dimensions?: Maybe<Array<Scalars['String']>>;
  endTime?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use selected_events instead */
  events?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  metrics?: Maybe<Array<Scalars['String']>>;
  mode: Scalars['String'];
  name: Scalars['String'];
  segmentId?: Maybe<Scalars['String']>;
  selectedEvents?: Maybe<Scalars['Json']>;
  startTime?: Maybe<Scalars['DateTime']>;
  timeDimension?: Maybe<TimeDimension>;
  trailingDays?: Maybe<Scalars['Int']>;
  type: ChartType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type ChartEventInput = {
  attributes: Scalars['Json'];
  name: Scalars['String'];
};

export enum ChartType {
  Area = 'AREA',
  Areaspline = 'AREASPLINE',
  Bar = 'BAR',
  BigValue = 'BIG_VALUE',
  Column = 'COLUMN',
  Line = 'LINE',
  Pie = 'PIE',
  Scatter = 'SCATTER',
  Spline = 'SPLINE',
  Table = 'TABLE'
}

/** Checklist */
export type Checklist = {
  __typename?: 'Checklist';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['UUID4']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  isSequential?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  name?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAndDirty?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<Scalars['String']>;
  rule?: Maybe<Rule>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents a set of AND conditions that a checklist should match */
export type ChecklistFilter = {
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<ChecklistState>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  checklistId?: Maybe<Scalars['String']>;
  checklistItemId?: Maybe<Scalars['String']>;
  conditionsJson?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

export type ChecklistItemMetric = {
  __typename?: 'ChecklistItemMetric';
  /** ID of the checklist */
  checklistId?: Maybe<Scalars['String']>;
  /** Unique checklist_item_completed */
  checklistItemCompletedUsers?: Maybe<Scalars['Int']>;
  /** Unique checklist_item_started */
  checklistItemStartedUsers?: Maybe<Scalars['Int']>;
  /** ID of the checklist item */
  itemId?: Maybe<Scalars['String']>;
};

export type ChecklistMetrics = {
  __typename?: 'ChecklistMetrics';
  /** Unique checklist_completed */
  checklistCompletedUsers?: Maybe<Scalars['Int']>;
  /** Unique checklist_dismissed */
  checklistDismissedUsers?: Maybe<Scalars['Int']>;
  /** Unique checklist_shown */
  checklistShownUsers?: Maybe<Scalars['Int']>;
  /** Unique checklist_skipped */
  checklistSkippedUsers?: Maybe<Scalars['Int']>;
  /** Unique completed / unique shown */
  completionPercentage?: Maybe<Scalars['Float']>;
  /** List of checklist item metrics */
  items?: Maybe<Array<Maybe<ChecklistItemMetric>>>;
};

/** Valid checklist sort keys */
export enum ChecklistSortKey {
  /** When the checklist was created */
  CreatedAt = 'CREATED_AT',
  /** Last time the checklist got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting checklists */
export type ChecklistSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: ChecklistSortKey;
};

/** Valid checklist states */
export enum ChecklistState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Draft state */
  Draft = 'DRAFT',
  /** Published state */
  Published = 'PUBLISHED'
}

/** Input for cloning a workflow */
export type CloneWorkflowInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** The outcome of a workflow clone attempt */
export type CloneWorkflowResult = {
  __typename?: 'CloneWorkflowResult';
  reason?: Maybe<Scalars['String']>;
  workflow?: Maybe<Workflow>;
};

export type ConditionUserCount = {
  __typename?: 'ConditionUserCount';
  totalUsers: Scalars['Int'];
  users: Scalars['Int'];
};

/** Represents a Rule conditions_flat_map object */
export type ConditionsFlatMap = {
  __typename?: 'ConditionsFlatMap';
  app?: Maybe<Array<Maybe<Scalars['String']>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklists?: Maybe<Array<Maybe<Scalars['String']>>>;
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  event?: Maybe<Array<Maybe<Scalars['String']>>>;
  experience?: Maybe<Array<Maybe<Scalars['String']>>>;
  experienceStep?: Maybe<Array<Maybe<Scalars['String']>>>;
  groups?: Maybe<Array<Maybe<Scalars['String']>>>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  properties?: Maybe<Array<Maybe<Scalars['String']>>>;
  screen?: Maybe<Array<Maybe<Scalars['String']>>>;
  segments?: Maybe<Array<Maybe<Scalars['String']>>>;
  trigger?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Content = {
  __typename?: 'Content';
  accountId: Scalars['String'];
  app?: Maybe<ContentApp>;
  campaign?: Maybe<ContentCampaign>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  experiment?: Maybe<ContentExperiment>;
  folder?: Maybe<Folder>;
  id: Scalars['String'];
  name: Scalars['String'];
  published: Scalars['Boolean'];
  publishedAndDirty?: Maybe<Scalars['Boolean']>;
  rule?: Maybe<ContentRule>;
  screenshotQueryParams?: Maybe<Scalars['String']>;
  /**
   * Sortable state is derived from the state and published columns. It is used to
   * correctly sort between published, draft and archived states when requesting only
   * draft and archived flows.
   */
  sortableState?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  tacticId?: Maybe<Scalars['String']>;
  tacticName?: Maybe<Scalars['String']>;
  tagIds: Array<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type ContentApp = {
  __typename?: 'ContentApp';
  id: Scalars['String'];
  name: Scalars['String'];
  platform: Scalars['String'];
  state: Scalars['String'];
};

export type ContentCampaign = {
  __typename?: 'ContentCampaign';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ContentExperiment = {
  __typename?: 'ContentExperiment';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

/** Represents a set of AND conditions that a content should match */
export type ContentFilter = {
  /** Filter by campaign id (content → tactic_content → tactic → campaign) */
  campaignId?: InputMaybe<Scalars['UUID4']>;
  /** Content types you want included in the result */
  contentTypes?: InputMaybe<Array<HighLevelContentType>>;
  /** Filter content created on or after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Filter content created on or before this date */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** User id to filter by the content's creator */
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Folder Id used to filter the content. When nil, get the root folder contents */
  folderId?: InputMaybe<Scalars['String']>;
  /** Filter by content frequency */
  frequency?: InputMaybe<ContentFrequency>;
  /** Filter by content that has an associated experiment */
  hasExperiment?: InputMaybe<Scalars['Boolean']>;
  /** Filter by content that has an associated goal */
  hasGoal?: InputMaybe<Scalars['Boolean']>;
  /** Filter by whether content has any tactic association */
  hasTactic?: InputMaybe<Scalars['Boolean']>;
  /** Filter by whether content belongs to a workflow */
  hasWorkflow?: InputMaybe<Scalars['Boolean']>;
  /** Optional list of content ids */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Segment ids to filter by */
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of states to filter by. When empty get the draft and published ones */
  states?: InputMaybe<Array<ContentState>>;
  /** Filter by tactic id */
  tacticId?: InputMaybe<Scalars['UUID4']>;
  /** Tags to filter by */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** String used to search a content by name. The term is used as a substring to match */
  term?: InputMaybe<Scalars['String']>;
  /** Filter by who last updated the content */
  updatedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Widget filter to filter by */
  widgetFilter?: InputMaybe<WidgetFilter>;
};

/** Valid content frequency */
export enum ContentFrequency {
  /** Show every time */
  EveryTime = 'EVERY_TIME',
  /** Show once */
  Once = 'ONCE'
}

/** Content Graph */
export type ContentGraph = {
  __typename?: 'ContentGraph';
  id?: Maybe<Scalars['ID']>;
  journeyCanvasId?: Maybe<Scalars['String']>;
  seed?: Maybe<Scalars['String']>;
  seedType?: Maybe<Scalars['String']>;
};

/** Represents an content graph change containing the reason */
export type ContentGraphChange = {
  __typename?: 'ContentGraphChange';
  contentGraph?: Maybe<ContentGraph>;
  reason: ChangeType;
};

/** Content list result with pagination info */
export type ContentList = {
  __typename?: 'ContentList';
  content: Array<Content>;
  pageInfo?: Maybe<PageInfo>;
};

export type ContentRule = {
  __typename?: 'ContentRule';
  domains: Array<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  goalIds: Array<Maybe<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  internalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  segments: Array<Scalars['String']>;
  widgetFilter?: Maybe<Scalars['String']>;
};

/** Valid content sort keys */
export enum ContentSortKey {
  /** When the content was created */
  CreatedAt = 'CREATED_AT',
  /** Folder's name */
  FolderName = 'FOLDER_NAME',
  /** content name */
  Name = 'NAME',
  /**
   * Derived column that has:
   * - value 'published' when state is draft and published is true
   * - value 'draft' when state is draft and published is false
   * - value 'archived' when state is archived
   * - null otherwise
   *
   * It will work correctly when only content in draft (and optionally, archived) states are requested.
   */
  SortableState = 'SORTABLE_STATE',
  /** Last time the content got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting contents */
export type ContentSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: ContentSortKey;
};

/** Valid content states */
export enum ContentState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Draft state */
  Draft = 'DRAFT',
  /** Published state */
  Published = 'PUBLISHED',
  /** Has a pending publish schedule */
  Scheduled = 'SCHEDULED',
  /** Was published, now in draft */
  Unpublished = 'UNPUBLISHED',
  /** Versioned state */
  Versioned = 'VERSIONED'
}

export type ContentStatus = {
  __typename?: 'ContentStatus';
  publishedAndDirty: Scalars['Boolean'];
  publishedAndDirtyUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** The set of content types that can be used to ensure data integrity for content_id filtering */
export enum ContentType {
  Banners = 'BANNERS',
  Checklists = 'CHECKLISTS',
  MobileFlows = 'MOBILE_FLOWS',
  Nps = 'NPS',
  Pins = 'PINS',
  WebFlows = 'WEB_FLOWS'
}

/** Represents a mapping from :webhook_event_name_allowlist to :content_type to the applicable event names for that content type, */
export type ContentTypeMap = {
  __typename?: 'ContentTypeMap';
  contentType: ContentType;
  eventNames: Array<Maybe<WebhookEventNameAllowlist>>;
};

/** Unit for the conversion window (value is stored in this unit) */
export enum ConversionWindowUnit {
  /** Days */
  Day = 'day',
  /** Hours */
  Hour = 'hour',
  /** Minutes */
  Minute = 'minute',
  /** Seconds */
  Second = 'second'
}

export type ConvertDashboardItemInput = {
  chartOverrides?: InputMaybe<ConvertToChartOverridesInput>;
  dashboardItemId: Scalars['ID'];
  funnelOverrides?: InputMaybe<ConvertToFunnelOverridesInput>;
  toType: DashboardItemType;
};

/** Optional overrides applied when converting a dashboard item to a chart */
export type ConvertToChartOverridesInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ChartType>;
};

/** Optional overrides applied when converting a dashboard item to a funnel */
export type ConvertToFunnelOverridesInput = {
  conversionWindow?: InputMaybe<Scalars['Int']>;
  conversionWindowUnit?: InputMaybe<ConversionWindowUnit>;
  name?: InputMaybe<Scalars['String']>;
};

/** Input for copying workflow task content steps */
export type CopyWorkflowTaskContentStepsInput = {
  /** The source content (e.g. flow) ID to copy from */
  contentId: Scalars['String'];
  /** The content task ID within the workflow */
  taskId: Scalars['String'];
  /** The workflow draft ID */
  workflowId: Scalars['String'];
};

/** Input for copying a multipath branch */
export type CopyWorkflowTaskMultipathBranchInput = {
  sourceBranchId: Scalars['String'];
  workflowId: Scalars['String'];
};

/** Create annotation node input object */
export type CreateAnnotationNodeInput = {
  color?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  journeyCanvasId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<JourneyCanvasNodePosition>;
};

/** Create app input object */
export type CreateAppInput = {
  name: Scalars['String'];
  platform: Scalars['String'];
};

/** Create app push config input object */
export type CreateAppPushConfigInput = {
  apnsBundleId?: InputMaybe<Scalars['String']>;
  apnsKey?: InputMaybe<Scalars['String']>;
  apnsKeyId?: InputMaybe<Scalars['String']>;
  apnsTeamId?: InputMaybe<Scalars['String']>;
  appId: Scalars['String'];
  fcmKey?: InputMaybe<Scalars['String']>;
};

export type CreateCampaignInput = {
  brief?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Create journey canvas input object */
export type CreateContentGraphInput = {
  journeyCanvasId?: InputMaybe<Scalars['String']>;
  seed?: InputMaybe<Scalars['String']>;
  seedType?: InputMaybe<Scalars['String']>;
};

export type CreateDashboardInput = {
  name: Scalars['String'];
};

/** Create doc site integration input object */
export type CreateDocSiteIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<DocSiteIntegrationType>;
};

/** Create email config input object */
export type CreateEmailConfigInput = {
  domain: Scalars['String'];
  emailProperty: Scalars['String'];
  physicalAddress?: InputMaybe<Scalars['String']>;
  suppressionConditions?: InputMaybe<Scalars['Json']>;
  throttleEnabled?: Scalars['Boolean'];
  throttleLimit?: InputMaybe<Scalars['Int']>;
  throttleTimespanMs?: InputMaybe<Scalars['Int']>;
  type: EmailDomainRequestType;
  windowConditions?: InputMaybe<Scalars['Json']>;
};

/** Create email input object */
export type CreateEmailInput = {
  fromId?: InputMaybe<Scalars['String']>;
  jsonBody?: InputMaybe<Scalars['Json']>;
  mimeBody?: InputMaybe<Scalars['Json']>;
  name?: Scalars['String'];
  previewText?: InputMaybe<Scalars['String']>;
  replyToId?: InputMaybe<Scalars['String']>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  subject?: Scalars['String'];
  themeId?: InputMaybe<Scalars['String']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Create email sender input object */
export type CreateEmailSenderInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  forwardingAddress?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
};

export type CreateEmailSuppressionsInput = {
  items: Array<EmailSuppressionInput>;
  type: SuppressionType;
};

/** Create email template input object */
export type CreateEmailTemplateInput = {
  jsonBody?: InputMaybe<Scalars['Json']>;
  mimeBody?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  previewText?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Create experiment input object */
export type CreateExperimentInput = {
  baselineConversionRate?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  contentId: Scalars['String'];
  controlMinimumSampleSize?: InputMaybe<Scalars['Int']>;
  controlSize: Scalars['Float'];
  endTime?: InputMaybe<Scalars['DateTime']>;
  estimatedDurationInDays?: InputMaybe<Scalars['Int']>;
  estimatedUsersPerDay?: InputMaybe<Scalars['Int']>;
  exposedMinimumSampleSize?: InputMaybe<Scalars['Int']>;
  finalCalculatedTestValue?: InputMaybe<Scalars['Float']>;
  minimumDetectableEffect?: InputMaybe<Scalars['Int']>;
  minimumDetectableEffectRelative?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pausedAt?: InputMaybe<Scalars['DateTime']>;
  powerLevel?: InputMaybe<Scalars['Int']>;
  requiredSampleSize?: InputMaybe<Scalars['Int']>;
  significanceLevel?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<ExperimentState>;
  testSides?: InputMaybe<ExperimentTestSides>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Create folder input object */
export type CreateFolderInput = {
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['UUID4']>;
};

/** Input for creating a standalone funnel */
export type CreateFunnelInput = {
  /** Conversion window value in the given unit (defaults to 7) */
  conversionWindow?: Scalars['Int'];
  /** Unit for the conversion window (second, minute, hour, day) */
  conversionWindowUnit?: InputMaybe<ConversionWindowUnit>;
  /** User-facing funnel name */
  name: Scalars['String'];
  /** Ordered list of funnel steps (position in array determines step_index) */
  steps?: Array<FunnelStepInput>;
};

/** Create goal input object */
export type CreateGoalInput = {
  conditions?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<TriggerConfigInput>;
};

/** Create journey canvas input object */
export type CreateJourneyCanvasInput = {
  name?: InputMaybe<Scalars['String']>;
  savedOptions?: InputMaybe<JourneyOptions>;
};

/** Create push notification input object */
export type CreatePushNotificationInput = {
  appIds?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  personalizationProperties?: InputMaybe<Array<Scalars['String']>>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Create push notification template input object */
export type CreatePushNotificationTemplateInput = {
  content?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateSavedViewInput = {
  filters?: InputMaybe<Scalars['Json']>;
  name: Scalars['String'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['Json']>>>;
  type: SavedViewType;
  viewType: SavedViewScope;
};

/** Input object for creating a new SDK Key. */
export type CreateSdkKeyInput = {
  tag?: InputMaybe<Scalars['String']>;
};

/** Segment create input */
export type CreateSegmentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Create survey entity input object */
export type CreateSurveyEntityInput = {
  name?: InputMaybe<Scalars['String']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

/** Create survey field input object */
export type CreateSurveyFieldInput = {
  name?: InputMaybe<Scalars['String']>;
  surveyFieldTypeId?: InputMaybe<Scalars['Int']>;
  surveyId?: InputMaybe<Scalars['ID']>;
};

export type CreateTacticInput = {
  brief?: InputMaybe<Scalars['Json']>;
  campaignId: Scalars['UUID4'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Create tag input object */
export type CreateTagInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Webhook input for creating a new webhook */
export type CreateWebhookInput = {
  /**
   * The content ids that the webhook is should trigger on.
   * All content_ids should be of the same experience_type as each other and the same as all event_names supplied"
   */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * The content type that the webhook is associated with.
   * If this is supplied, then all content_ids must be of the same content type and all event_names must be applicable to that content type.
   * if this is null, then content_ids must be empty, and there are no restrictions on event_names.
   */
  contentType?: InputMaybe<ContentType>;
  /** A description of the use case for the webhook */
  description?: InputMaybe<Scalars['String']>;
  /** The events that will trigger the webhook */
  eventNames: Array<InputMaybe<WebhookEventNameAllowlist>>;
  /** The webhook name */
  name: Scalars['String'];
  /** An optional secret */
  signingSecret?: InputMaybe<Scalars['String']>;
  /** The status of the webhook, defaults to disabled */
  status?: InputMaybe<UserSettableWebhookStatus>;
  /** The url endpoint the payload will be sent to */
  url: Scalars['String'];
};

/** Input for creating a new workflow */
export type CreateWorkflowInput = {
  /** Entry condition as a json string */
  entryConditions?: InputMaybe<WorkflowEntryConditionsInput>;
  /** Exit condition as a json string */
  exitConditions?: InputMaybe<WorkflowExitConditionsInput>;
  /** Workflow frequency */
  frequency?: InputMaybe<WorkflowFrequencyInput>;
  /** The workflow name */
  name: Scalars['String'];
  /** Require continuous segment enrollment? */
  requireContinuousSegmentEnrollment?: InputMaybe<Scalars['Boolean']>;
  /** Tag ids to associate with the workflow */
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  /** Workflow timeout */
  timeout?: InputMaybe<WorkflowTimeoutInput>;
};

export type CreateWorkflowTaskBranchInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  conditions?: InputMaybe<Scalars['String']>;
  entryConditions?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type content */
export type CreateWorkflowTaskContentInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  contentType: WorkflowTaskContentType;
  entryConditions?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  previewUrl: Scalars['String'];
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

export type CreateWorkflowTaskDelayDurationInput = {
  unit: WorkflowTaskDurationUnit;
  value: Scalars['Int'];
};

/** Input for creating a new workflow task of type delay */
export type CreateWorkflowTaskDelayInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  duration?: InputMaybe<CreateWorkflowTaskDelayDurationInput>;
  entryConditions?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type email */
export type CreateWorkflowTaskEmailInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  fromId?: InputMaybe<Scalars['String']>;
  jsonBody?: InputMaybe<Scalars['Json']>;
  mimeBody?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  previewText?: InputMaybe<Scalars['String']>;
  replyToId?: InputMaybe<Scalars['String']>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  themeId?: InputMaybe<Scalars['String']>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type event */
export type CreateWorkflowTaskEventInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type multipath */
export type CreateWorkflowTaskMultipathInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type poll */
export type CreateWorkflowTaskPollInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  conditions: Scalars['String'];
  entryConditions?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type push_notification */
export type CreateWorkflowTaskPushNotificationInput = {
  appIds?: InputMaybe<Array<Scalars['String']>>;
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  content?: InputMaybe<Scalars['Json']>;
  entryConditions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  personalizationProperties?: InputMaybe<Array<Scalars['String']>>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type user_property */
export type CreateWorkflowTaskUserPropertyInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['Json']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for creating a new workflow task of type wait */
export type CreateWorkflowTaskWaitInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  eventConditions: Scalars['String'];
  eventName: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

export type DailyMetric = {
  __typename?: 'DailyMetric';
  date: Scalars['Date'];
  metricValue: Scalars['Float'];
  trendline: Scalars['Float'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  accountId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  filter?: Maybe<DashboardFilter>;
  gridConfig?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  items: Array<DashboardItem>;
  layout?: Maybe<Scalars['Json']>;
  name: Scalars['String'];
  timeDimension?: Maybe<DashboardTimeDimension>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type DashboardFilter = {
  __typename?: 'DashboardFilter';
  groupIds: Array<Scalars['String']>;
  platforms: Array<Scalars['String']>;
  segmentIds: Array<Scalars['String']>;
};

export type DashboardFilterInput = {
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Scalars['String']>>;
  segmentIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum DashboardGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type DashboardItem = {
  __typename?: 'DashboardItem';
  content?: Maybe<DashboardItemContent>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  dashboardId: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type DashboardItemContent = Chart | Funnel;

/** The content type backing a dashboard item */
export enum DashboardItemType {
  Chart = 'CHART',
  Funnel = 'FUNNEL',
  Widget = 'WIDGET'
}

export type DashboardTimeDimension = {
  __typename?: 'DashboardTimeDimension';
  granularity?: Maybe<DashboardGranularity>;
};

export type DashboardTimeDimensionInput = {
  granularity?: InputMaybe<DashboardGranularity>;
};

export type Data = Action | App | Checklist | ChecklistItem | Experience | ExperienceStep | Flow | FlowStep | Generic | Goal | Hotspot | ModalStep | Nps | Rule | Segment;

/** Delete journey canvas node positions input object */
export type DeleteJourneyCanvasNodePositionsInput = {
  id: Scalars['String'];
  nodeIds: Array<InputMaybe<Scalars['String']>>;
};

/** Delete a webhook */
export type DeleteWebhookInput = {
  /** The webhook id to delete */
  id: Scalars['String'];
};

export type DocSiteIntegration = {
  __typename?: 'DocSiteIntegration';
  active?: Maybe<Scalars['Boolean']>;
  apiKey: Scalars['String'];
  connected?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: DocSiteIntegrationType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an DocSiteIntegration change with a reason */
export type DocSiteIntegrationChange = {
  __typename?: 'DocSiteIntegrationChange';
  docSiteIntegration?: Maybe<DocSiteIntegration>;
  reason: ChangeType;
};

/** Valid doc side integration names */
export enum DocSiteIntegrationType {
  /** freshdesk integration */
  Freshdesk = 'FRESHDESK',
  /** helpjuice integration */
  Helpjuice = 'HELPJUICE',
  /** zendesk integration */
  Zendesk = 'ZENDESK'
}

export type Edge = {
  __typename?: 'Edge';
  child?: Maybe<Scalars['Boolean']>;
  direct?: Maybe<Scalars['Boolean']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** Input for editing a single funnel step */
export type EditFunnelStepInput = {
  /** List of events for this step (OR'd together) */
  events: Array<FunnelStepEventInput>;
};

/** Represents an Email object */
export type Email = {
  __typename?: 'Email';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dirty: Scalars['Boolean'];
  from?: Maybe<EmailSender>;
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  jsonBody: Scalars['Json'];
  mimeBody: Scalars['Json'];
  name: Scalars['String'];
  personalizationProperties?: Maybe<Array<Scalars['String']>>;
  previewText?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  replyTo?: Maybe<EmailSender>;
  revertedAt?: Maybe<Scalars['DateTime']>;
  revertedTo?: Maybe<Scalars['Int']>;
  sourceTemplateId?: Maybe<Scalars['String']>;
  state: EmailState;
  subject: Scalars['String'];
  themeId?: Maybe<Scalars['String']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  userArchivedBy?: Maybe<User>;
  userCreatedBy?: Maybe<User>;
  userPublishedBy?: Maybe<User>;
  userUnpublishedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
  workflowId?: Maybe<Scalars['String']>;
};

/** Represents an Email change with a reason */
export type EmailChange = {
  __typename?: 'EmailChange';
  email?: Maybe<Email>;
  reason: ChangeType;
};

export type EmailConfigDnsRecord = {
  __typename?: 'EmailConfigDnsRecord';
  hostname?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type EmailConfigDomain = {
  __typename?: 'EmailConfigDomain';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sendingReceivingRecords?: Maybe<Array<Maybe<EmailConfigDnsRecord>>>;
  trackingRecords?: Maybe<Array<Maybe<EmailConfigDnsRecord>>>;
  type?: Maybe<EmailDomainRequestType>;
};

/** Represents an email configuration object */
export type EmailConfigResult = {
  __typename?: 'EmailConfigResult';
  domains?: Maybe<Array<EmailConfigDomain>>;
  emailProperty?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  suppressionConditions?: Maybe<Scalars['Json']>;
  throttleEnabled: Scalars['Boolean'];
  throttleLimit?: Maybe<Scalars['Int']>;
  throttleTimespanMs?: Maybe<Scalars['Int']>;
  windowConditions?: Maybe<Scalars['Json']>;
};

/** Valid email domain request types */
export enum EmailDomainRequestType {
  Custom = 'CUSTOM',
  Subdomain = 'SUBDOMAIN'
}

export type EmailDomainVerificationResult = {
  __typename?: 'EmailDomainVerificationResult';
  sendingReceivingRecords?: Maybe<Array<Maybe<EmailConfigDnsRecord>>>;
  trackingRecords?: Maybe<Array<Maybe<EmailConfigDnsRecord>>>;
};

/** Represents a set of AND conditions that an email should match */
export type EmailFilter = {
  /** List of ids to filter emails by */
  ids?: Array<Scalars['String']>;
  /** EmailSender id to match with the email from_id or reply_to_id field */
  senderId?: InputMaybe<Scalars['String']>;
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<EmailState>;
  /** String used to search for an email by name */
  term?: Scalars['String'];
  /** Workflow to filter emails by */
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Represents email limits usage information for an account */
export type EmailLimitsUsage = {
  __typename?: 'EmailLimitsUsage';
  accountId?: Maybe<Scalars['String']>;
  allowed?: Maybe<Scalars['Int']>;
  paused?: Maybe<Scalars['Boolean']>;
  ttl?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

/** Represents an EmailSender object */
export type EmailSender = {
  __typename?: 'EmailSender';
  bcc?: Maybe<Array<Maybe<Scalars['String']>>>;
  cc?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emails?: Maybe<Array<Email>>;
  enabled: Scalars['Boolean'];
  forwardingAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner: User;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  verified: Scalars['Boolean'];
};


/** Represents an EmailSender object */
export type EmailSenderEmailsArgs = {
  filter?: InputMaybe<EmailFilter>;
};

/** Represents a EmailSender change object with a reason */
export type EmailSenderChange = {
  __typename?: 'EmailSenderChange';
  emailSender?: Maybe<EmailSender>;
  reason: ChangeType;
};

/** Represents a set of AND conditions that an email sender should match */
export type EmailSenderFilter = {
  /** ID of a user used to filter email senders */
  ownerId?: InputMaybe<Scalars['String']>;
};

/** Valid email sender sort keys */
export enum EmailSenderSortKey {
  /** When the email sender was created */
  CreatedAt = 'CREATED_AT',
  /** Email */
  Email = 'EMAIL',
  /** When the email sender was last updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting email senders */
export type EmailSenderSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: EmailSenderSortKey;
};

/** Valid email sort keys */
export enum EmailSortKey {
  /** When the email was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** When the email was last updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting email */
export type EmailSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: EmailSortKey;
};

/** Valid email states */
export enum EmailState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Draft state */
  Draft = 'DRAFT',
  /** Published state */
  Published = 'PUBLISHED'
}

export type EmailSuppression = {
  __typename?: 'EmailSuppression';
  address: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type EmailSuppressionInput = {
  address: Scalars['String'];
  error?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export enum EmailSuppressionPage {
  Last = 'LAST',
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type EmailSuppressionPaging = {
  __typename?: 'EmailSuppressionPaging';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  nextAddress?: Maybe<Scalars['String']>;
  previousAddress?: Maybe<Scalars['String']>;
};

export type EmailSuppressions = {
  __typename?: 'EmailSuppressions';
  items: Array<EmailSuppression>;
  paging: EmailSuppressionPaging;
};

/** Represents an EmailTemplate object */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  createdAt: Scalars['DateTime'];
  emails?: Maybe<Array<Maybe<Email>>>;
  id: Scalars['ID'];
  jsonBody: Scalars['Json'];
  mimeBody: Scalars['Json'];
  name: Scalars['String'];
  previewText: Scalars['String'];
  subject: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an EmailTemplate change with a reason */
export type EmailTemplateChange = {
  __typename?: 'EmailTemplateChange';
  emailTemplate?: Maybe<EmailTemplate>;
  reason: ChangeType;
};

/** Represents a set of AND conditions that an email template should match */
export type EmailTemplateFilter = {
  /** List of ids to filter email templates by */
  ids?: Array<Scalars['String']>;
  /** String used to search for an email template by name */
  term?: Scalars['String'];
};

/** Valid email template sort keys */
export enum EmailTemplateSortKey {
  /** When the email template was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** When the email template was last updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting email templates */
export type EmailTemplateSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: EmailTemplateSortKey;
};

/** Parameters required for sending an email test */
export type EmailTestParams = {
  /** The ID of the end user whose properties are used to render the email */
  asUserId?: InputMaybe<Scalars['String']>;
  /** The ID of the email to send */
  emailId: Scalars['String'];
  /** The email address to send the test email to */
  to: Scalars['String'];
};

/** Represents the result of sending a test email */
export type EmailTestSendResult = {
  __typename?: 'EmailTestSendResult';
  sendId?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['Boolean']>;
};

/** An event with its last time seen datetime. */
export type Event = {
  __typename?: 'Event';
  description?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  showInUi?: Maybe<Scalars['Boolean']>;
};

export type EventFunnelResult = {
  __typename?: 'EventFunnelResult';
  conversionWindowDays: Scalars['Int'];
  steps: Array<EventFunnelStepResult>;
};

export type EventFunnelStepResult = {
  __typename?: 'EventFunnelStepResult';
  stepIndex: Scalars['Int'];
  usersCount: Scalars['Int'];
};

/** Input for filtering event names */
export type EventNameFilter = {
  /** When true, returns event names with true & unconfigured labels */
  showInUi?: InputMaybe<Scalars['Boolean']>;
};

/** Represents an Event Qualification Filtering Rule object */
export type EventQualificationFilteringRule = {
  __typename?: 'EventQualificationFilteringRule';
  createdBy?: Maybe<Scalars['String']>;
  eventRules?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  insertedAt: Scalars['DateTime'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an Event Qualification Filtering Rule change containing the reason */
export type EventQualificationFilteringRuleChange = {
  __typename?: 'EventQualificationFilteringRuleChange';
  eventQualificationFilteringRule?: Maybe<EventQualificationFilteringRule>;
  reason: ChangeType;
};

/** Upsert event qualification filtering rule input object */
export type EventQualificationFilteringRuleInput = {
  eventRules?: InputMaybe<Array<Scalars['String']>>;
};

export type EventUserProfile = {
  __typename?: 'EventUserProfile';
  /** Account the user belongs to. Can be null for anonymous users */
  accountId?: Maybe<Scalars['String']>;
  event: EventUserProfileEvent;
  /** The user profile property values requested in the query */
  profile: Scalars['Json'];
  /** User ID */
  userId: Scalars['String'];
};

export type EventUserProfileEvent = {
  __typename?: 'EventUserProfileEvent';
  /** Name of the user created content */
  contentName?: Maybe<Scalars['String']>;
  /** Name of the appcues event type that was triggered */
  name: Scalars['String'];
  stepId?: Maybe<Scalars['String']>;
  stepName?: Maybe<Scalars['String']>;
  stepType?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  /** The URL where the event was triggered. This is populated for track events. */
  url?: Maybe<Scalars['String']>;
};

/** Input for executing an insight action */
export type ExecuteInsightActionInput = {
  id: Scalars['ID'];
};

/**
 * Represents an Experience object which is the successor
 * of Flow.
 */
export type Experience = {
  __typename?: 'Experience';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<Scalars['String']>;
  clonedFrom?: Maybe<Scalars['String']>;
  clonedFromAccountId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  experiment?: Maybe<Experiment>;
  /** Returns the query string needed for requesting the screenshot of the experience's first step */
  firstStepScreenshotUrl?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['UUID4']>;
  id: Scalars['ID'];
  internalId: Scalars['String'];
  lockedForLocalization?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  publicName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<Scalars['String']>;
  revertedAt?: Maybe<Scalars['DateTime']>;
  revertedTo?: Maybe<Scalars['String']>;
  rule?: Maybe<Rule>;
  ruleInternalId: Scalars['String'];
  state: Scalars['String'];
  steps?: Maybe<Array<Maybe<ExperienceStep>>>;
  summary?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  theme?: Maybe<Scalars['String']>;
  themes?: Maybe<Scalars['String']>;
  traitsJson?: Maybe<Scalars['String']>;
  type?: Maybe<ExperienceType>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userArchivedBy?: Maybe<User>;
  userCreatedBy?: Maybe<User>;
  userPublishedBy?: Maybe<User>;
  userUnpublishedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
};

/** Valid experience except conditions */
export enum ExperienceExceptionState {
  /** Exclude experiences without goals */
  WithoutGoal = 'WITHOUT_GOAL',
  /** Exclude experiences associated with experiments */
  WithExperiments = 'WITH_EXPERIMENTS'
}

/** Represents a set of AND conditions that a experience should match */
export type ExperienceFilter = {
  /** Optional list of application ids */
  appIds?: Array<Scalars['String']>;
  /** Provide a list of exception conditions */
  except?: Array<ExperienceExceptionState>;
  /** Provide a flow frequency */
  frequency?: InputMaybe<ContentFrequency>;
  /** Optional list of experience ids */
  ids?: Array<Scalars['String']>;
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<ExperienceState>;
  /** String used to search a experience by name. The term is used as a substring to match */
  term?: Scalars['String'];
  /** Provide a list of types */
  types?: Array<ExperienceType>;
};

export type ExperienceMetricDeltas = {
  __typename?: 'ExperienceMetricDeltas';
  /** Absolute delta of goal completion */
  goalCompletions?: Maybe<Scalars['Float']>;
  /** Absolute delta of completion percentages */
  overallCompletion?: Maybe<Scalars['Float']>;
  /** Percent delta of unique users who started a experience */
  uniqueUsers?: Maybe<Scalars['Float']>;
};

export type ExperienceMetrics = {
  __typename?: 'ExperienceMetrics';
  /** Times a experience was completed (experience_completed) */
  completion?: Maybe<Scalars['Int']>;
  /** Total completed / total started */
  completionPercentage?: Maybe<Scalars['Float']>;
  /** Percentage changes of experience metrics */
  experienceMetricDeltas?: Maybe<ExperienceMetricDeltas>;
  /** Total times experience's goal was achieved */
  goalAchievements?: Maybe<Scalars['Int']>;
  /** Unique users who achieved experience's goal */
  goalExperienceUsers?: Maybe<Scalars['Int']>;
  /** Total goal completion / total unique users who started experience */
  goalPercentage?: Maybe<Scalars['Float']>;
  /** Times experience was started (experience_started) */
  started?: Maybe<Scalars['Int']>;
  /** List of metrics for a experience's steps */
  steps?: Maybe<Array<Maybe<ExperienceStepMetric>>>;
  /** Distinct users who completed the experience (experience_completed) */
  uniqueCompletion?: Maybe<Scalars['Int']>;
  /** Distinct users who started the experience (experience_started) */
  uniqueUsers?: Maybe<Scalars['Int']>;
};

/** Valid experience sort keys */
export enum ExperienceSortKey {
  /** When the experience was created */
  CreatedAt = 'CREATED_AT',
  /** experience name */
  Name = 'NAME',
  /** Last time the experience got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting experiences */
export type ExperienceSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: ExperienceSortKey;
};

/** Valid experience states */
export enum ExperienceState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Draft state */
  Draft = 'DRAFT',
  /** Published state */
  Published = 'PUBLISHED'
}

export type ExperienceStep = {
  __typename?: 'ExperienceStep';
  children?: Maybe<Array<Maybe<ExperienceStep>>>;
  contentType?: Maybe<Scalars['String']>;
  experienceInternalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  internalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ExperienceStepInteractionMetric = {
  __typename?: 'ExperienceStepInteractionMetric';
  /** The step ID */
  stepId?: Maybe<Scalars['String']>;
  /** Timestamp of the event */
  timestamp?: Maybe<Scalars['DateTime']>;
  /** User ID */
  userId?: Maybe<Scalars['String']>;
};

export type ExperienceStepMetric = {
  __typename?: 'ExperienceStepMetric';
  /** Unique users who completed a step */
  completed?: Maybe<Scalars['Int']>;
  /** Unique users who have seen a step */
  shown?: Maybe<Scalars['Int']>;
  /** The id of the step */
  stepId?: Maybe<Scalars['String']>;
};

/** Valid Experience types */
export enum ExperienceType {
  /** Banners */
  Banner = 'BANNER',
  /** Embeds */
  Embed = 'EMBED',
  /** Flows 2.0 */
  Flow = 'FLOW',
  /** Launchpads */
  Launchpad = 'LAUNCHPAD',
  /** Mobile flows */
  Mobile = 'MOBILE',
  /** Mobile Embed flows */
  MobileEmbed = 'MOBILE_EMBED',
  /** NPS 2.0 */
  Nps = 'NPS',
  /** Pins */
  Persistent = 'PERSISTENT'
}

/** Represents an Experiment object without the linked content (flow or experience) */
export type Experiment = {
  __typename?: 'Experiment';
  baselineConversionRate?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  contentId: Scalars['String'];
  controlMinimumSampleSize?: Maybe<Scalars['Int']>;
  controlSize: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  endTime?: Maybe<Scalars['DateTime']>;
  estimatedDurationInDays?: Maybe<Scalars['Int']>;
  estimatedUsersPerDay?: Maybe<Scalars['Int']>;
  exposedMinimumSampleSize?: Maybe<Scalars['Int']>;
  finalCalculatedTestValue?: Maybe<Scalars['Float']>;
  goal?: Maybe<Goal>;
  goalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  minimumDetectableEffect?: Maybe<Scalars['Int']>;
  minimumDetectableEffectRelative?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pausedAt?: Maybe<Scalars['DateTime']>;
  powerLevel?: Maybe<Scalars['Int']>;
  requiredSampleSize?: Maybe<Scalars['Int']>;
  significanceLevel?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['DateTime']>;
  state: ExperimentState;
  testSides?: Maybe<ExperimentTestSides>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
};

/**
 * Represents an experiment change containing the reason and the experiment's
 * latest related state.
 */
export type ExperimentChange = {
  __typename?: 'ExperimentChange';
  experiment: Experiment;
  reason: ChangeType;
};

/** Represents a set of AND conditions that an experiment should match */
export type ExperimentFilter = {
  /** List of states to filter by. When empty, it's ignored */
  states?: Array<ExperimentState>;
};

/** Valid experiment sort keys */
export enum ExperimentSortKey {
  /** When the flow was created */
  CreatedAt = 'CREATED_AT',
  /** Experiment state */
  State = 'STATE',
  /** Last time the flow got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting experiments */
export type ExperimentSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: ExperimentSortKey;
};

/** Valid experiment states */
export enum ExperimentState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Completed state */
  Completed = 'COMPLETED',
  /** Final state */
  Ended = 'ENDED',
  /** Live state */
  Live = 'LIVE',
  /** Initial state */
  NotStarted = 'NOT_STARTED',
  /** Paused state */
  Paused = 'PAUSED'
}

/** Test side configuration for the experiments */
export enum ExperimentTestSides {
  /** One side experiment */
  OneSided = 'ONE_SIDED',
  /** Two side experiment */
  TwoSided = 'TWO_SIDED'
}

/** Represents an Experiment object with the linked content (flow or experience) */
export type ExperimentWithContent = {
  __typename?: 'ExperimentWithContent';
  baselineConversionRate?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  content?: Maybe<Content>;
  contentId: Scalars['String'];
  controlMinimumSampleSize?: Maybe<Scalars['Int']>;
  controlSize: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  endTime?: Maybe<Scalars['DateTime']>;
  estimatedDurationInDays?: Maybe<Scalars['Int']>;
  estimatedUsersPerDay?: Maybe<Scalars['Int']>;
  exposedMinimumSampleSize?: Maybe<Scalars['Int']>;
  finalCalculatedTestValue?: Maybe<Scalars['Float']>;
  goal?: Maybe<Goal>;
  goalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  minimumDetectableEffect?: Maybe<Scalars['Int']>;
  minimumDetectableEffectRelative?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pausedAt?: Maybe<Scalars['DateTime']>;
  powerLevel?: Maybe<Scalars['Int']>;
  requiredSampleSize?: Maybe<Scalars['Int']>;
  significanceLevel?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['DateTime']>;
  state: ExperimentState;
  testSides?: Maybe<ExperimentTestSides>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
};

/**
 * Since exports are asynchronous operations, we just want to know if the
 * enqueue process worked
 */
export type ExportOutput = {
  __typename?: 'ExportOutput';
  enqueued: Scalars['Boolean'];
};

export type ExportWorkflowUsersInput = {
  emailTo: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  event: Scalars['String'];
  propertyNames?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
  workflowTaskId?: Scalars['String'];
};

/** Result of triggering a workflow users export */
export type ExportWorkflowUsersResult = {
  __typename?: 'ExportWorkflowUsersResult';
  success: Scalars['Boolean'];
};

/** Represents a webhook error object */
export type FailedWebhookDetails = {
  __typename?: 'FailedWebhookDetails';
  endpointUrl: Scalars['String'];
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  httpResponse?: Maybe<FailedWebhookHttpResponse>;
  httpResponseTime: Scalars['Int'];
  payload?: Maybe<Scalars['String']>;
  timestamp: Scalars['Int'];
  webhookId: Scalars['String'];
};

/** Represents the http response from a failed webhook */
export type FailedWebhookHttpResponse = {
  __typename?: 'FailedWebhookHttpResponse';
  body: Scalars['String'];
  bodySize: Scalars['Int'];
  bodyTruncated: Scalars['Boolean'];
  headers: Scalars['String'];
  statusCode: Scalars['Int'];
};

/** Represents an Answer object */
export type FieldAnswer = {
  __typename?: 'FieldAnswer';
  fieldId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/**
 * An object representing legacy (pre-Experience) Appcues content.
 * Formerly called a "journey" internally.
 */
export type Flow = {
  __typename?: 'Flow';
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<Scalars['String']>;
  clonedFrom?: Maybe<Scalars['String']>;
  clonedFromAccountId?: Maybe<Scalars['String']>;
  /** The current content status of the flow */
  contentStatus?: Maybe<ContentStatus>;
  /** A string that identifies this flow */
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  experiment?: Maybe<Experiment>;
  /** Returns the query string needed for requesting the screenshot of the flow's first step */
  firstStepScreenshotUrl?: Maybe<Scalars['String']>;
  folderId?: Maybe<Scalars['UUID4']>;
  formatVersion: Scalars['Int'];
  formatVersionUpdatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  internalId: Scalars['String'];
  lockedForLocalization?: Maybe<Scalars['Boolean']>;
  migratedFromStepId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  publicName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<Scalars['String']>;
  revertedAt?: Maybe<Scalars['DateTime']>;
  revertedTo?: Maybe<Scalars['String']>;
  rule?: Maybe<Rule>;
  ruleInternalId?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  steps?: Maybe<Array<Maybe<FlowStep>>>;
  summary?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  testFlowCreatedAt?: Maybe<Scalars['DateTime']>;
  testFlowId?: Maybe<Scalars['String']>;
  testVersionOf?: Maybe<Scalars['String']>;
  type?: Maybe<FlowType>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userArchivedBy?: Maybe<User>;
  userCreatedBy?: Maybe<User>;
  userPublishedBy?: Maybe<User>;
  userUnpublishedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
  workflowId?: Maybe<Scalars['String']>;
  workflowTaskId?: Maybe<Scalars['String']>;
};

/**
 * Represents a flow change containing the reason and the flow's
 * latest related state.
 */
export type FlowChange = {
  __typename?: 'FlowChange';
  flow: Flow;
  reason: ChangeType;
};

/** Valid flow except conditions */
export enum FlowExceptionState {
  /** Exclude flows without goals */
  WithoutGoal = 'WITHOUT_GOAL',
  /** Exclude flows associated with experiments */
  WithExperiments = 'WITH_EXPERIMENTS'
}

/** Represents a set of AND conditions that a flow should match */
export type FlowFilter = {
  /** Provide a list of exception conditions */
  except?: Array<FlowExceptionState>;
  /** Provide an experience frequency */
  frequency?: InputMaybe<ContentFrequency>;
  /** Filter flows that have workflows associated with them */
  hasWorkflow?: InputMaybe<Scalars['Boolean']>;
  /** Optional list of flow ids */
  ids?: Array<Scalars['String']>;
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<FlowState>;
  /** String used to search a flow by name. The term is used as a substring to match */
  term?: Scalars['String'];
  /** Provide a list of types */
  types?: Array<FlowType>;
  /** Filters flows that can appear on the launchpad */
  widgetFilter?: InputMaybe<Array<WidgetFilter>>;
};

/** Input for funnel results query */
export type FlowFunnelResultsInput = {
  /** End time for the analysis period (ISO 8601 format) */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The flow ID to get funnel results for */
  flowId: Scalars['String'];
  /** Optional segment ID to filter users */
  segmentId?: InputMaybe<Scalars['String']>;
  /** Start time for the analysis period (ISO 8601 format) */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Flow create input object */
export type FlowInput = {
  /** Name of the flow */
  name: Scalars['String'];
  previewUrl?: InputMaybe<Scalars['String']>;
  /** Public name of the flow. this is used to be displayed for users */
  publicName?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** A flow with metrics from the analytics API. */
export type FlowMetric = {
  __typename?: 'FlowMetric';
  /** Number of times flow was completed during the time period of start_time -> end_time */
  completed: Scalars['Int'];
  /** Rate of completion from start_time -> end_time, completed / shown */
  completedRate: Scalars['Float'];
  /** Diff of completion rates, completed_rate - prev_completed_rate */
  completedRateDelta: Scalars['Float'];
  /** Rate of errors from start_time -> end_time, errors / shown */
  errorRate: Scalars['Float'];
  /** Diff of error rates, error_rate - prev_error_rate */
  errorRateDelta: Scalars['Float'];
  /** Number of times flow errored during the time period of start_time -> end_time */
  errors: Scalars['Int'];
  flowId: Scalars['String'];
  name: Scalars['String'];
  /** Number of times flow was completed during the time period of prev_start_time -> prev_end_time */
  prevCompleted: Scalars['Int'];
  /** Rate of completion from prev_start_time -> prev_end_time, prev_completed / prev_shown */
  prevCompletedRate: Scalars['Float'];
  /** Rate of errors from prev_start_time -> prev_end_time, prev_errors / prev_shown */
  prevErrorRate: Scalars['Float'];
  /** Number of times flow errored during the time period of prev_start_time -> prev_end_time */
  prevErrors: Scalars['Int'];
  /** Number of times flow was shown during the time period of prev_start_time -> prev_end_time */
  prevShown: Scalars['Int'];
  /** Number of times flow was skipped during the time period of prev_start_time -> prev_end_time */
  prevSkipped: Scalars['Int'];
  /** Rate of skipped from prev_start_time -> prev_end_time, prev_skipped / prev_shown */
  prevSkippedRate: Scalars['Float'];
  /** Number of times flow was shown during the time period of start_time -> end_time */
  shown: Scalars['Int'];
  /** Number of times flow was skipped during the time period of start_time -> end_time */
  skipped: Scalars['Int'];
  /** Rate of skipped from start_time -> end_time, skipped / shown */
  skippedRate: Scalars['Float'];
  /** Diff of skipped rates, skipped_rate - prev_skipped_rate */
  skippedRateDelta: Scalars['Float'];
};

export type FlowMetricDeltas = {
  __typename?: 'FlowMetricDeltas';
  /** Absolute delta of goal completion */
  goalCompletions?: Maybe<Scalars['Float']>;
  /** Absolute delta of total issues */
  issues?: Maybe<Scalars['Float']>;
  /** Absolute delta of completion percentages */
  overallCompletion?: Maybe<Scalars['Float']>;
  /** Percent delta of unique users who started a flow */
  uniqueUsers?: Maybe<Scalars['Float']>;
};

export type FlowMetrics = {
  __typename?: 'FlowMetrics';
  /** Times a flow was completed (flow_completed) */
  completion?: Maybe<Scalars['Int']>;
  /** Total completed / total started */
  completionPercentage?: Maybe<Scalars['Float']>;
  /** Percentage changes of flow metrics */
  flowMetricDeltas?: Maybe<FlowMetricDeltas>;
  /** Total times flow's goal was achieved */
  goalAchievements?: Maybe<Scalars['Int']>;
  /** Unique users who achieved flow's goal */
  goalFlowUsers?: Maybe<Scalars['Int']>;
  /** Total goal completion / total unique users who started flow */
  goalPercentage?: Maybe<Scalars['Float']>;
  /** TODO */
  issues?: Maybe<Scalars['Int']>;
  /** Times flow was started (flow_started) */
  started?: Maybe<Scalars['Int']>;
  /** List of metrics for a flow's steps */
  steps?: Maybe<Array<Maybe<FlowStepMetric>>>;
  /** Distinct users who completed the flow (flow_completed) */
  uniqueCompletion?: Maybe<Scalars['Int']>;
  /** TODO */
  uniqueIssues?: Maybe<Scalars['Int']>;
  /** Distinct users who started the flow (flow_started) */
  uniqueUsers?: Maybe<Scalars['Int']>;
};

export type FlowMetricsWithMeta = {
  __typename?: 'FlowMetricsWithMeta';
  /** Flow metrics, limited to the specified limit and offset */
  flowMetrics?: Maybe<Array<Maybe<FlowMetric>>>;
  /** Total number of flow metrics for account in that state, useful for determining total # of pages */
  totalResults: Scalars['Int'];
};

/** Used to tell the flow metrics query how to sort the result data set */
export enum FlowPerformanceSortKey {
  /** number of times flow was completed */
  Completed = 'COMPLETED',
  /** rate a flow was completed / shown */
  CompletedRate = 'COMPLETED_RATE',
  /** the difference between completed_rate - prev_completed_rate */
  CompletedRateDelta = 'COMPLETED_RATE_DELTA',
  /** number of times flow errored */
  Errors = 'ERRORS',
  /** rate a flow was error / shown */
  ErrorRate = 'ERROR_RATE',
  /** the difference between error_rate - prev_error_rate */
  ErrorRateDelta = 'ERROR_RATE_DELTA',
  /** flow name */
  Name = 'NAME',
  /** number of times flow was shown */
  Shown = 'SHOWN',
  /** number of times flow was skipped */
  Skipped = 'SKIPPED',
  /** rate a flow was skipped / shown */
  SkippedRate = 'SKIPPED_RATE',
  /** the difference between skipped_rate - prev_skipped_rate */
  SkippedRateDelta = 'SKIPPED_RATE_DELTA'
}

export type FlowPerformanceSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: FlowPerformanceSortKey;
};

/** Valid flow sort keys */
export enum FlowSortKey {
  /** When the flow was created */
  CreatedAt = 'CREATED_AT',
  /** Flow name */
  Name = 'NAME',
  /** Last time the flow got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting flows */
export type FlowSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: FlowSortKey;
};

/** Valid flow states */
export enum FlowState {
  /** Archived state */
  Archived = 'ARCHIVED',
  /** Draft state */
  Draft = 'DRAFT',
  /** Published state */
  Published = 'PUBLISHED'
}

export type FlowStep = {
  __typename?: 'FlowStep';
  action?: Maybe<Action>;
  flowInternalId?: Maybe<Scalars['String']>;
  hotspot?: Maybe<Hotspot>;
  hotspotGroup?: Maybe<HotspotGroup>;
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  modal?: Maybe<Modal>;
  modalStep?: Maybe<ModalStep>;
  stepType?: Maybe<Scalars['String']>;
};

export type FlowStepMetric = {
  __typename?: 'FlowStepMetric';
  /** Unique users who completed a step */
  completed?: Maybe<Scalars['Int']>;
  /** TODO */
  issues?: Maybe<Scalars['Int']>;
  /** Unique users who have seen a step */
  shown?: Maybe<Scalars['Int']>;
  /** The id of the step */
  stepId?: Maybe<Scalars['String']>;
};

/** Valid Flow types */
export enum FlowType {
  /** Journey */
  Journey = 'JOURNEY',
  /** Mobile Journey */
  MobileJourney = 'MOBILE_JOURNEY'
}

/** An object representing a folder. */
export type Folder = {
  __typename?: 'Folder';
  accountId: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  contentsCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['UUID4']>;
  position?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type FolderHierarchy = {
  __typename?: 'FolderHierarchy';
  children?: Maybe<Array<Scalars['Json']>>;
  color?: Maybe<Scalars['String']>;
  contentsCount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['UUID4']>;
  position?: Maybe<Scalars['Int']>;
};

/** A funnel definition built from a flow and its goal */
export type Funnel = {
  __typename?: 'Funnel';
  accountId: Scalars['String'];
  /** Conversion window value in the unit given by conversion_window_unit */
  conversionWindow: Scalars['Int'];
  /** Unit for the conversion window (second, minute, hour, day) */
  conversionWindowUnit: ConversionWindowUnit;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  /** The dashboard this funnel belongs to, if any */
  dashboard?: Maybe<Dashboard>;
  /** The flow associated with this funnel (via its rule), if any */
  flow?: Maybe<Flow>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  /** Internal ID of the rule (DRAFT content) this funnel is associated with (persistent funnels only) */
  ruleInternalId?: Maybe<Scalars['String']>;
  source: FunnelSource;
  steps: Array<FunnelStep>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** An event that must occur for a funnel step to be completed */
export type FunnelEvent = {
  __typename?: 'FunnelEvent';
  attributes: Scalars['Json'];
  name: Scalars['String'];
};

/** Represents a set of AND conditions that a funnel should match */
export type FunnelFilter = {
  /** When true, exclude funnels that are attached to a dashboard */
  excludeDashboardFunnels?: InputMaybe<Scalars['Boolean']>;
  /** When true, exclude funnels that are attached to flows (i.e. have a rule_internal_id) */
  excludeFlowFunnels?: InputMaybe<Scalars['Boolean']>;
};

/** Funnel analytics results */
export type FunnelResults = {
  __typename?: 'FunnelResults';
  /** Conversion window value in the unit given by conversion_window_unit */
  conversionWindow: Scalars['Int'];
  /** Unit for the conversion window (second, minute, hour, day) */
  conversionWindowUnit?: Maybe<ConversionWindowUnit>;
  /** ID of the funnel */
  id: Scalars['UUID4'];
  /** Name of the funnel */
  name: Scalars['String'];
  /** Whether the funnel is transient (auto-generated from a flow) or persistent (user-created) */
  source?: Maybe<FunnelSource>;
  /** Funnel steps with analytics data */
  steps: Array<FunnelStepWithAnalytics>;
};

/** Input for funnel results query */
export type FunnelResultsInput = {
  /** End time for the analysis period (ISO 8601 format) */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The funnel ID to get results for */
  funnelId: Scalars['UUID4'];
  /** Optional segment ID to filter users */
  segmentId?: InputMaybe<Scalars['String']>;
  /** Start time for the analysis period (ISO 8601 format) */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Valid funnel sort keys */
export enum FunnelSortKey {
  /** Funnel's creation date */
  CreatedAt = 'CREATED_AT',
  /** Funnel's name */
  Name = 'NAME',
  /** Funnel's last updated date */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting funnels */
export type FunnelSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: FunnelSortKey;
};

/** Valid funnel sources */
export enum FunnelSource {
  /** Persistent source */
  Persistent = 'persistent',
  /** Transient source */
  Transient = 'transient'
}

/** A single step in a funnel */
export type FunnelStep = {
  __typename?: 'FunnelStep';
  createdAt?: Maybe<Scalars['DateTime']>;
  events: Array<FunnelEvent>;
  funnelId?: Maybe<Scalars['UUID4']>;
  id?: Maybe<Scalars['UUID4']>;
  stepIndex: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Input for a funnel step event */
export type FunnelStepEventInput = {
  /** Event attributes as a JSON object */
  attributes: Scalars['Json'];
  /** Event name (e.g., 'appcues:flow_started', 'appcues:goal_reached') */
  name: Scalars['String'];
};

/** Input for a funnel step */
export type FunnelStepInput = {
  /** List of events for this step (OR'd together) */
  events: Array<FunnelStepEventInput>;
};

/** Input for querying users at a specific funnel step */
export type FunnelStepUsersInput = {
  /** End time for the analysis period (ISO 8601 format) */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The funnel ID */
  funnelId: Scalars['UUID4'];
  /** Pagination parameters */
  page?: InputMaybe<PageInput>;
  /** Whether to return users who reached or missed this step */
  queryType: FunnelStepUsersQueryType;
  /** Optional segment ID to filter users */
  segmentId?: InputMaybe<Scalars['String']>;
  /** Sort order (key + direction). Key can be user_id, timestamp, or a profile attribute name. */
  sortOrder?: InputMaybe<FunnelStepUsersSortOrder>;
  /** Start time for the analysis period (ISO 8601 format) */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The step number to query (1-indexed) */
  stepNumber: Scalars['Int'];
  /** Optional search term to filter users by profile attributes */
  term?: InputMaybe<Scalars['String']>;
};

/** Query type for funnel step users */
export enum FunnelStepUsersQueryType {
  /** Users who entered the funnel but did not reach this step */
  Missed = 'MISSED',
  /** Users who reached at least this step */
  Reached = 'REACHED'
}

/** Paginated list of users at a funnel step with profile attributes */
export type FunnelStepUsersResult = {
  __typename?: 'FunnelStepUsersResult';
  pageInfo: PageInfo;
  settings?: Maybe<UserProfileSettings>;
  sortOrder?: Maybe<FunnelStepUsersSortOrderResult>;
  users: Array<UserWithAttributes>;
};

/** Sort order for funnel step users */
export type FunnelStepUsersSortOrder = {
  /** Sort direction */
  direction?: InputMaybe<SortDirection>;
  /** Column to sort by: user_id, timestamp, or any profile attribute name */
  key: Scalars['String'];
};

/** The effective sort order applied to the results */
export type FunnelStepUsersSortOrderResult = {
  __typename?: 'FunnelStepUsersSortOrderResult';
  direction: SortDirection;
  key: Scalars['String'];
};

/** A funnel step with analytics data */
export type FunnelStepWithAnalytics = {
  __typename?: 'FunnelStepWithAnalytics';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Number of distinct users who reached this step */
  distinctUsers: Scalars['Int'];
  events: Array<FunnelEvent>;
  funnelId?: Maybe<Scalars['UUID4']>;
  id?: Maybe<Scalars['UUID4']>;
  stepIndex: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Paginated list of funnels */
export type FunnelsResponse = {
  __typename?: 'FunnelsResponse';
  funnels: Array<Funnel>;
  pageInfo?: Maybe<PageInfo>;
};

export type Generic = {
  __typename?: 'Generic';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Represents a Goal object */
export type Goal = {
  __typename?: 'Goal';
  accountId?: Maybe<Scalars['String']>;
  /** Returns the number of goal achievers (users) in the last week */
  activeUsers?: Maybe<Scalars['Int']>;
  conditionsFlatMapJson?: Maybe<Scalars['String']>;
  conditionsJson?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  defaultGoal?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledLastUpdated?: Maybe<Scalars['DateTime']>;
  goalFormatVersion?: Maybe<Scalars['Int']>;
  goalVersion?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  metaJson?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Returns the count of content that references this goal. A list of content states can
   * be passed as an argument so that only content in the specified states are counted.
   */
  referenceCount: Scalars['Int'];
  /**
   * Returns the content that references this goal. A list of content states can
   * be passed as an argument. This allows archived flows and experiences to be returned,
   * for example.
   */
  references: References;
  slug?: Maybe<Scalars['String']>;
  triggerConfig?: Maybe<TriggerConfig>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};


/** Represents a Goal object */
export type GoalReferenceCountArgs = {
  states?: Array<ContentState>;
};


/** Represents a Goal object */
export type GoalReferencesArgs = {
  states?: Array<ContentState>;
};

/** Goal filter input object */
export type GoalFilter = {
  goalFormatVersion?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
};

/** Represents goal metrics for goals first reached this week */
export type GoalFirstReachedMetrics = {
  __typename?: 'GoalFirstReachedMetrics';
  goalId: Scalars['String'];
  numActiveUsers: Scalars['Int'];
  numFirstAchievers: Scalars['Int'];
  pctFirstAchievers: Scalars['Float'];
};

export type GoalResult = {
  __typename?: 'GoalResult';
  pageInfo?: Maybe<PageInfo>;
  results: Array<Goal>;
};

/** Valid goal sort keys */
export enum GoalSortKey {
  /** Goal's creation date */
  CreatedAt = 'CREATED_AT',
  /** Goal's name */
  Name = 'NAME',
  /** Goal's status */
  Status = 'STATUS'
}

/** Combination of a column and a sort direction used when sorting goals */
export type GoalSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: GoalSortKey;
};

export type GroupDailyMetrics = {
  __typename?: 'GroupDailyMetrics';
  metrics: Array<DailyMetric>;
};

/**
 * A list of all properties and profiles for a given group or account.
 * Both can be paginated separately using different arguments.
 */
export type GroupProfileList = {
  __typename?: 'GroupProfileList';
  profiles: Array<Scalars['Json']>;
  profilesPageInfo?: Maybe<GroupProfilesPageInfo>;
  /** @deprecated Please use profileAttributes from the root type instead */
  properties: Array<ProfilePropertyDefinition>;
};

export type GroupProfilesPageInfo = {
  __typename?: 'GroupProfilesPageInfo';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
  totalGroups?: Maybe<Scalars['Int']>;
  totalSearch: Scalars['Int'];
};

export type GroupSeenMetrics = {
  __typename?: 'GroupSeenMetrics';
  firstSeenAt?: Maybe<Scalars['DateTime']>;
  firstSeenTimeAgo?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  lastSeenTimeAgo?: Maybe<Scalars['String']>;
};

export type GroupToplineMetrics = {
  __typename?: 'GroupToplineMetrics';
  actualPeriod?: Maybe<ToplineMetrics>;
  previousPeriod?: Maybe<ToplineMetrics>;
};

export type GroupUsageToplineMetrics = {
  __typename?: 'GroupUsageToplineMetrics';
  actualPeriod?: Maybe<UsageToplineMetrics>;
  previousPeriod?: Maybe<UsageToplineMetrics>;
};

/** Represents the type of content */
export enum HighLevelContentType {
  /** Represents a banner */
  Banner = 'BANNER',
  /** Represents a campaign */
  Campaign = 'CAMPAIGN',
  /** Represents a checklist */
  Checklist = 'CHECKLIST',
  /** Represents a web embed experience */
  Embed = 'EMBED',
  /** Represents a flow 2.0 */
  Flow = 'FLOW',
  /** Represents a goal */
  Goal = 'GOAL',
  /** Represents a flow */
  Journey = 'JOURNEY',
  /** Represents a launchpad */
  Launchpad = 'LAUNCHPAD',
  /** Represents a mobile experience */
  Mobile = 'MOBILE',
  /** Represents a mobile embed experience */
  MobileEmbed = 'MOBILE_EMBED',
  /** Represents an NPS 2.0 experience */
  Nps = 'NPS',
  /** Represents a persistent experience */
  Persistent = 'PERSISTENT',
  /** Represents a segment */
  Segment = 'SEGMENT',
  /** Represents a tactic */
  Tactic = 'TACTIC',
  /** Represents a workflow */
  Workflow = 'WORKFLOW'
}

export type Hotspot = {
  __typename?: 'Hotspot';
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
};

export type HotspotGroup = {
  __typename?: 'HotspotGroup';
  hotspots?: Maybe<Array<Maybe<Hotspot>>>;
  id?: Maybe<Scalars['String']>;
  sequential?: Maybe<Scalars['Boolean']>;
};

export type HydratedContentGraph = {
  __typename?: 'HydratedContentGraph';
  id?: Maybe<Scalars['ID']>;
  journey?: Maybe<Journey>;
  journeyCanvasId?: Maybe<Scalars['String']>;
  seed?: Maybe<Scalars['String']>;
  seedType?: Maybe<Scalars['String']>;
};

export type HydratedJourneyCanvas = {
  __typename?: 'HydratedJourneyCanvas';
  annotationNodes?: Maybe<Array<Maybe<AnnotationNode>>>;
  contentGraphs?: Maybe<Array<Maybe<HydratedContentGraph>>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  journey?: Maybe<Journey>;
  name?: Maybe<Scalars['String']>;
  savedOptions?: Maybe<OutputJourneyOptions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/**
 * The identity implied by an API client's auth token:
 * a user acting within a single account.
 */
export type Identity = {
  __typename?: 'Identity';
  account: Account;
  /** The account user for the current session (includes spoofing users) */
  accountUser?: Maybe<AccountUser>;
  user: User;
};

/** Represents an insight generated by a proactive insight agent */
export type Insight = {
  __typename?: 'Insight';
  accountId: Scalars['String'];
  actionPlan?: Maybe<Scalars['String']>;
  actions: Array<InsightAction>;
  agent?: Maybe<InsightAgent>;
  ctaText?: Maybe<Scalars['String']>;
  dismissed: Scalars['Boolean'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  expectedImpact?: Maybe<Scalars['String']>;
  finding?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insertedAt: Scalars['DateTime'];
  outcomes: Array<Scalars['String']>;
  priority: InsightPriority;
  read: Scalars['Boolean'];
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedBy?: Maybe<Scalars['String']>;
  status: InsightStatus;
  title: Scalars['String'];
  type: InsightType;
  updatedBy?: Maybe<Scalars['String']>;
};

/** An immediate one-shot action associated with an insight */
export type InsightAction = {
  __typename?: 'InsightAction';
  canUndo: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<Scalars['String']>;
  cta: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  executing: Scalars['Boolean'];
  id: Scalars['ID'];
  insertedAt: Scalars['DateTime'];
  lastError?: Maybe<InsightActionError>;
  lastErrorAt?: Maybe<Scalars['DateTime']>;
  retryable: Scalars['Boolean'];
  status: InsightActionStatus;
  title: Scalars['String'];
  undoneAt?: Maybe<Scalars['DateTime']>;
  undoneBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

/** Valid insight action error types */
export enum InsightActionError {
  /** Execution attempt failed */
  CompleteFailed = 'COMPLETE_FAILED',
  /** Undo attempt failed */
  UndoFailed = 'UNDO_FAILED'
}

/** Valid insight action statuses */
export enum InsightActionStatus {
  /** Successfully executed */
  Completed = 'COMPLETED',
  /** Ready to execute */
  Pending = 'PENDING',
  /** Successfully reversed */
  Undone = 'UNDONE'
}

/** Represents the agent that generated an insight */
export type InsightAgent = {
  __typename?: 'InsightAgent';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Paginated list of insights */
export type InsightConnection = {
  __typename?: 'InsightConnection';
  data: Array<Insight>;
  pageInfo: PageInfo;
};

/** Filter criteria for listing insights */
export type InsightFilter = {
  /** Filter by dismissed state */
  dismissed?: InputMaybe<Scalars['Boolean']>;
  /** Filter by one or more priority levels */
  priorities?: InputMaybe<Array<InsightPriority>>;
  /** Filter by read state */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Filter by one or more insight types */
  types?: InputMaybe<Array<InsightType>>;
};

/** Valid insight priorities */
export enum InsightPriority {
  /** High priority */
  High = 'HIGH',
  /** Low priority */
  Low = 'LOW',
  /** Medium priority */
  Medium = 'MEDIUM'
}

/** Valid sort keys for insights */
export enum InsightSortKey {
  /** When the insight was created */
  InsertedAt = 'INSERTED_AT',
  /** Insight priority level */
  Priority = 'PRIORITY',
  /** Insight type */
  Type = 'TYPE'
}

/** Combination of a column and a sort direction used when sorting insights */
export type InsightSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: InsightSortKey;
};

/** Valid insight statuses */
export enum InsightStatus {
  /** Reviewed and approved by Appcues staff */
  Approved = 'APPROVED',
  /** Awaiting review by Appcues staff */
  Pending = 'PENDING'
}

/** Valid insight types */
export enum InsightType {
  /** A negative finding or problem that needs attention */
  Issue = 'ISSUE',
  /** A positive finding or something to improve or pursue */
  Opportunity = 'OPPORTUNITY'
}

/** An account invite */
export type Invite = {
  __typename?: 'Invite';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  redeemedAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

/** Represents a set of AND conditions that an invite should match */
export type InviteFilter = {
  /** State to filter by. When empty, it's ignored */
  state?: InputMaybe<InviteStatus>;
};

/** Represents an object to send an invite to a new teammate */
export type InviteInput = {
  email: Scalars['String'];
  job?: InputMaybe<Scalars['String']>;
  role: AccountRole;
};

/** Status to filter out the invites */
export enum InviteStatus {
  /** Invites that have not been accepted */
  Pending = 'PENDING',
  /** Redeemed invites */
  Redeemed = 'REDEEMED'
}

export enum JobState {
  /** Job completed sucessfully */
  Completed = 'COMPLETED',
  /** Job unsuccessful */
  Error = 'ERROR',
  /** Job executing */
  Executing = 'EXECUTING'
}

/** Journey Map */
export type Journey = {
  __typename?: 'Journey';
  edges?: Maybe<Array<Maybe<Edge>>>;
  id?: Maybe<Scalars['String']>;
  journeyCanvasId?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<Node>>>;
};

export type JourneyCanvas = {
  __typename?: 'JourneyCanvas';
  annotationNodes?: Maybe<Array<Maybe<AnnotationNode>>>;
  contentGraphs?: Maybe<Array<Maybe<ContentGraph>>>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  savedOptions?: Maybe<OutputJourneyOptions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents an journey canvas change containing the reason */
export type JourneyCanvasChange = {
  __typename?: 'JourneyCanvasChange';
  journeyCanvas?: Maybe<JourneyCanvas>;
  reason: ChangeType;
};

/** Represents a set of AND conditions that a journey canvas should match */
export type JourneyCanvasFilter = {
  /** String used to serach for a journey canvas by name */
  term?: InputMaybe<Scalars['String']>;
};

export type JourneyCanvasNodePosition = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** Node position input for a node on a journey canvas */
export type JourneyCanvasNodePositionsInput = {
  nodeId: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** Valid journey_canvas sort keys */
export enum JourneyCanvasSortKey {
  /** When the journey canvas was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** Last time the journey canvas got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting journey_canvases */
export type JourneyCanvasSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: JourneyCanvasSortKey;
};

export type JourneyFilter = {
  published?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
};

export type JourneyOptions = {
  filter?: InputMaybe<JourneyFilter>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  user?: InputMaybe<Scalars['String']>;
};

/** A signed Knock user token for frontend SDK auth */
export type KnockUserToken = {
  __typename?: 'KnockUserToken';
  token: Scalars['String'];
};

export type LaunchpadActivity = {
  __typename?: 'LaunchpadActivity';
  /** Number of articles opned */
  articlesOpened?: Maybe<Scalars['Int']>;
  /** Date of the events */
  date?: Maybe<Scalars['Date']>;
  /** Launched flows */
  launchedFlows?: Maybe<Scalars['Int']>;
  /** Links clicked */
  linksClicked?: Maybe<Scalars['Int']>;
  /** Number of search requests */
  searches?: Maybe<Scalars['Int']>;
};

/** launchpad event analytics summary */
export type LaunchpadEventSummary = {
  __typename?: 'LaunchpadEventSummary';
  flowDisplayName?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  flowName?: Maybe<Scalars['String']>;
  flowState?: Maybe<Scalars['String']>;
  lastEventTimestamp?: Maybe<Scalars['DateTime']>;
  linkName?: Maybe<Scalars['String']>;
  linkStatus?: Maybe<LinkStatus>;
  linkUrl?: Maybe<Scalars['String']>;
  totalEvents?: Maybe<Scalars['Int']>;
  uniqueEvents?: Maybe<Scalars['Int']>;
};

export type LaunchpadMetrics = {
  __typename?: 'LaunchpadMetrics';
  /** A list of events grouped and sorted by the date range */
  activity?: Maybe<Array<Maybe<LaunchpadActivity>>>;
  /** AVG events per open */
  avgEventsPerOpen?: Maybe<Scalars['Float']>;
  /** Total impressions */
  totalImpressions?: Maybe<Scalars['Int']>;
  /** Total sum of events */
  totalOpens?: Maybe<Scalars['Int']>;
  /** Total step errors */
  totalStepError?: Maybe<Scalars['Int']>;
  /** Total sum of a single event per user */
  uniqueOpens?: Maybe<Scalars['Int']>;
};

export type LaunchpadRecentUser = {
  __typename?: 'LaunchpadRecentUser';
  /** Event count */
  eventCount?: Maybe<Scalars['Int']>;
  /** Last event timestamp */
  lastEventTimestamp: Scalars['DateTime'];
  /** The user profile property values requested in the query */
  profile: Scalars['Json'];
  /** User identifier */
  userId?: Maybe<Scalars['String']>;
};

export type LaunchpadRecentUsers = {
  __typename?: 'LaunchpadRecentUsers';
  pageInfo?: Maybe<PageInfo>;
  /** A list of events grouped by user */
  results?: Maybe<Array<Maybe<LaunchpadRecentUser>>>;
};

/**
 * Filter object for retrieving a list of property names or a searchable string
 * of property names from account users that have triggered a given event.
 */
export type LaunchpadRecentUsersFilter = {
  /** The list of profile property names to return for each user profile. */
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter for profiles where one of the property values includes the search string. */
  searchString?: InputMaybe<Scalars['String']>;
};

/** link liveness status */
export enum LinkStatus {
  /** When an a link is still live in an experience */
  Live = 'LIVE',
  /** When an a link has been removed from an experience */
  Removed = 'REMOVED'
}

export type MauMetrics = {
  __typename?: 'MauMetrics';
  emailSentCount?: Maybe<Scalars['Int']>;
  mau?: Maybe<Scalars['Int']>;
};

export type MetricsInput = {
  endTime: Scalars['DateTime'];
  segmentId?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};

export type MetricsInputV2 = {
  endTime: Scalars['DateTime'];
  npsId: Scalars['String'];
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};

export type Modal = {
  __typename?: 'Modal';
  id?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<Maybe<ModalStep>>>;
};

export type ModalStep = {
  __typename?: 'ModalStep';
  id?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
};

/** Input for moving a workflow task to a new position */
export type MoveWorkflowTaskInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  id: Scalars['String'];
  prevTaskId?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['String'];
};

/** Input for reordering a multipath branch */
export type MoveWorkflowTaskMultipathBranchInput = {
  branchId: Scalars['String'];
  multipathId: Scalars['String'];
  preBranchId?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['String'];
};

export type MtuMessagesMetrics = {
  __typename?: 'MtuMessagesMetrics';
  bannerCount?: Maybe<Scalars['Int']>;
  checklistShownCount?: Maybe<Scalars['Int']>;
  emailSentCount?: Maybe<Scalars['Int']>;
  flowExperienceCount?: Maybe<Scalars['Int']>;
  flowStartedCount?: Maybe<Scalars['Int']>;
  launchpadCount?: Maybe<Scalars['Int']>;
  messagesTotal?: Maybe<Scalars['Int']>;
  mobileCount?: Maybe<Scalars['Int']>;
  mobileEmbedCount?: Maybe<Scalars['Int']>;
  mtuTotal?: Maybe<Scalars['Int']>;
  npsSurveyStartedCount?: Maybe<Scalars['Int']>;
  pageViewCount?: Maybe<Scalars['Int']>;
  persistentCount?: Maybe<Scalars['Int']>;
  pushSentCount?: Maybe<Scalars['Int']>;
  screenViewCount?: Maybe<Scalars['Int']>;
  sessionStartedCount?: Maybe<Scalars['Int']>;
  workflowEnteredCount?: Maybe<Scalars['Int']>;
};

export type Node = {
  __typename?: 'Node';
  data?: Maybe<Data>;
  id?: Maybe<Scalars['String']>;
  position?: Maybe<NodePosition>;
  type?: Maybe<Scalars['String']>;
};

export type NodePosition = {
  __typename?: 'NodePosition';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

/** Per-workflow channel type preferences */
export type NotificationChannelTypes = {
  __typename?: 'NotificationChannelTypes';
  chat?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
};

/** Account-level notification settings */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  workflows: Array<NotificationWorkflowPreference>;
};

/** A notification workflow definition */
export type NotificationWorkflow = {
  __typename?: 'NotificationWorkflow';
  key: Scalars['String'];
  title: Scalars['String'];
};

/** A single notification workflow with its current preference state */
export type NotificationWorkflowPreference = {
  __typename?: 'NotificationWorkflowPreference';
  cadence: Cadence;
  channelTypes: NotificationChannelTypes;
  email?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  title: Scalars['String'];
};

/** Defines an nps */
export type Nps = {
  __typename?: 'Nps';
  accountId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legacyStepType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  patternType?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  rule?: Maybe<Rule>;
  ruleInternalId?: Maybe<Scalars['String']>;
  skippable?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  stepType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

export type NpsSurveyEventItem = {
  __typename?: 'NpsSurveyEventItem';
  /** NPS feedback text if provided */
  npsFeedback?: Maybe<Scalars['String']>;
  /** NPS score (e.g. 0-10) if provided */
  npsScore?: Maybe<Scalars['Int']>;
  /** When the event was submitted */
  timestamp?: Maybe<Scalars['NaiveDateTime']>;
  /** User who submitted the event */
  userId?: Maybe<Scalars['String']>;
  /** Requested user profile attributes */
  userProfileAttributes?: Maybe<Scalars['Json']>;
};

export type OutputJourneyFilter = {
  __typename?: 'OutputJourneyFilter';
  published?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
};

export type OutputJourneyOptions = {
  __typename?: 'OutputJourneyOptions';
  filter?: Maybe<OutputJourneyFilter>;
  segments?: Maybe<Array<Maybe<Scalars['String']>>>;
  user?: Maybe<Scalars['String']>;
};

export type OverviewMetricsV2 = {
  __typename?: 'OverviewMetricsV2';
  activeUsers?: Maybe<Scalars['Int']>;
  checklists?: Maybe<Scalars['Int']>;
  flowFrequency?: Maybe<Scalars['Float']>;
  flows?: Maybe<Scalars['Int']>;
  flowsShown?: Maybe<Scalars['Float']>;
  npsScore?: Maybe<Scalars['Float']>;
  pins?: Maybe<Scalars['Int']>;
  recentFlows?: Maybe<Array<Maybe<Flow>>>;
  usersReached?: Maybe<Scalars['Float']>;
};

/**
 * Deprecated Pagination parameters
 * Nate Note: this should not be used anymore, in favor of using
 * the page_input and page_info objects, below.
 */
export type Page = {
  /** 1-based page number */
  number?: InputMaybe<Scalars['Int']>;
  /** number of items per page */
  size?: InputMaybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

/** Pagination parameters as input. Uses for query args */
export type PageInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * Provides information for the UI to determine the total number of pages, as
 *     well as what page a given table is on.
 */
export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  number: Scalars['Int'];
  size: Scalars['Int'];
  total: Scalars['Int'];
};

export type PinDayMetric = {
  __typename?: 'PinDayMetric';
  /** Date */
  day?: Maybe<Scalars['DateTime']>;
  /** Experience ID */
  experienceId?: Maybe<Scalars['String']>;
  /** Step ID */
  stepId?: Maybe<Scalars['String']>;
  /** Unique users who performed step_seen or step_interaction */
  users?: Maybe<Scalars['Int']>;
};

export type PinEventsUsersMetric = {
  __typename?: 'PinEventsUsersMetric';
  /** Total count of the event */
  events?: Maybe<Scalars['Int']>;
  /** Experience ID */
  experienceId?: Maybe<Scalars['String']>;
  /** Most recent timestamp for the event */
  mostRecentTimestamp?: Maybe<Scalars['DateTime']>;
  /** Name of the event */
  name?: Maybe<Scalars['String']>;
  /** Step ID */
  stepId?: Maybe<Scalars['String']>;
  /** Unique users who performed the event */
  users?: Maybe<Scalars['Int']>;
};

export type PinMetricDeltas = {
  __typename?: 'PinMetricDeltas';
  /** Percent delta of button_pin_seen */
  buttonImpressions?: Maybe<Scalars['Float']>;
  /** Percent delta of icon_seen */
  iconImpressions?: Maybe<Scalars['Float']>;
  /** Percent delta of step_seen */
  impressions?: Maybe<Scalars['Float']>;
  /** Percent delta of step_error - step_recovered */
  issues?: Maybe<Scalars['Float']>;
  /** Perecent delta of unique button_pin_seen */
  uniqueButtonEvents?: Maybe<Scalars['Float']>;
  /** Perecent delta of unique step_seen */
  uniqueEvents?: Maybe<Scalars['Float']>;
  /** Perecent delta of unique icon_seen */
  uniqueIconEvents?: Maybe<Scalars['Float']>;
};

export type PinMetrics = {
  __typename?: 'PinMetrics';
  /** List of pin events by day */
  dayMetrics?: Maybe<Array<Maybe<PinDayMetric>>>;
  /** List of events grouped by step and event */
  eventsUsers?: Maybe<Array<Maybe<PinEventsUsersMetric>>>;
  /** Percent changes of pin metrics */
  pinMetricDeltas?: Maybe<PinMetricDeltas>;
  /** List of step interaction events */
  stepInteractions?: Maybe<Array<Maybe<ExperienceStepInteractionMetric>>>;
};

export type Plan = {
  __typename?: 'Plan';
  basePrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** An entire user or group profile. */
export type Profile = {
  __typename?: 'Profile';
  pageInfo?: Maybe<PageInfo>;
  properties: Array<ProfilePropertyValue>;
};

/** Input for filtering profile attributes */
export type ProfileAttributeFilter = {
  /** When true, returns profile attributes with true & unconfigured labels */
  showInUi?: InputMaybe<Scalars['Boolean']>;
  /** Search term for profile attributes */
  term?: InputMaybe<Scalars['String']>;
};

/**
 * Represents the definition of a profile attribute. This is the
 * abstract definition of a property belonging to either a group or user
 * profile, as opposed to an instance of a profile.
 */
export type ProfileAttributeList = {
  __typename?: 'ProfileAttributeList';
  attributes: Array<ProfilePropertyDefinition>;
  pageInfo?: Maybe<ProfileAttributePageInfo>;
};

export type ProfileAttributeMetadata = {
  description?: InputMaybe<Scalars['String']>;
  isStarred?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  showInUi?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PropertyType>;
};

export type ProfileAttributePageInfo = {
  __typename?: 'ProfileAttributePageInfo';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
  totalAttributes: Scalars['Int'];
};

/** Valid profile attribute sort keys */
export enum ProfileAttributeSortKey {
  /** Last seen timestamp of the profile attribute */
  LastSeenTs = 'LAST_SEEN_TS',
  /** Name of the profile attribute */
  Name = 'NAME',
  /** Property type of the profile attribute */
  Type = 'TYPE'
}

/** Combination of a column and a sort direction used when sorting profile attributes */
export type ProfileAttributeSortOrder = {
  direction?: InputMaybe<SortDirection>;
  sortKey: ProfileAttributeSortKey;
};

/** A list of profile attribute values */
export type ProfileAttributeValues = {
  __typename?: 'ProfileAttributeValues';
  values: Array<Scalars['String']>;
};

/**
 * Filter object for choosing a list of property names or a searchable
 * string of property names.
 */
export type ProfileFilter = {
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchString?: InputMaybe<Scalars['String']>;
};

/**
 * Filter object for retrieving a list of property names or a searchable
 * string of property names from accounts that have triggered a given event.
 */
export type ProfileForEventFilter = {
  /**
   * The flow or experience ID, depending on the content type. This field is not required for
   * application events and track event.
   */
  contentId?: InputMaybe<Scalars['String']>;
  /**
   * A list of flow or experience IDs to filter on. When provided, it is treated
   * as an independent filter and combined with `content_id` (if present).
   */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The content type determines which column on the events table contains the content ID.
   * This field is not required for application events and track event.
   */
  contentType?: InputMaybe<ProfileForEventFilterContentType>;
  /**
   * A list of content types to filter on. This field is independent from
   * `content_type` and is passed through to the underlying query for
   * backwards-compatible multi-type filtering.
   */
  contentTypes?: InputMaybe<Array<InputMaybe<ProfileForEventFilterContentType>>>;
  /** UTC Date value to filter until */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The event names to include in the query */
  eventNames: Array<Scalars['String']>;
  /** The list of profile property names to return for each user profile. */
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter for profiles where one of the property values includes the search string. */
  searchString?: InputMaybe<Scalars['String']>;
  /** UTC Date value to start filtering from. */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** Pass this value to select a specific step of a flow or experience. */
  stepId?: InputMaybe<Scalars['String']>;
  /** When true, count unique users instead of total events. Defaults to false. */
  uniqueUsers?: InputMaybe<Scalars['Boolean']>;
};

/** The set of content types that we can query for recent user profiles */
export enum ProfileForEventFilterContentType {
  Banner = 'BANNER',
  Checklist = 'CHECKLIST',
  ExperienceFlow = 'EXPERIENCE_FLOW',
  Goal = 'GOAL',
  MobileFlow = 'MOBILE_FLOW',
  Pin = 'PIN',
  WebFlow = 'WEB_FLOW'
}

/** Event users are always sorted on the event timestamp, so only the sort direction can be changed. */
export type ProfileForEventListSort = {
  direction?: SortDirection;
};

/**
 * A list of all properties and profiles for a given group or account.
 * Both can be paginated separately using different arguments.
 */
export type ProfileList = {
  __typename?: 'ProfileList';
  profiles: Array<Scalars['Json']>;
  profilesPageInfo?: Maybe<PageInfo>;
  /** @deprecated Please use profileAttributes from the root type instead */
  properties: Array<ProfilePropertyDefinition>;
};

/** A list of all profiles that have triggered a given event type */
export type ProfileListForEvent = {
  __typename?: 'ProfileListForEvent';
  pageInfo?: Maybe<PageInfo>;
  results: Array<EventUserProfile>;
};

/** Sort profile lists by a given sort key on an arbitrary attribute name. */
export type ProfileListSort = {
  direction?: SortDirection;
  sortKey: Scalars['String'];
  sortType?: InputMaybe<ProfileSortType>;
};

/**
 * Represents the definition of a profile property. This is the
 * abstract definition of a property belonging to either a group or user
 * profile, as opposed to an instance of a profile. For instance if I
 * have a user profile of key value pairs like:
 *
 * {
 *   "prop1": "true",
 *   "propJoe": "a proposition then"
 * }
 *
 * Then there would be at least two property definitions for that account,
 * both of type string and named "prop1" and "propJoe".
 */
export type ProfilePropertyDefinition = {
  __typename?: 'ProfilePropertyDefinition';
  description?: Maybe<Scalars['String']>;
  isAuto?: Maybe<Scalars['Boolean']>;
  isStarred?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  lastSeenTs?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  showInUi?: Maybe<Scalars['Boolean']>;
  type: PropertyType;
};

/**
 * Represents an actual value on either a group or user's profile. Builds
 * on the abstract definition to also include the value itself, and a last
 * seen timestamp. Using the above example profile of:
 *
 * {
 *   "prop1": "true",
 *   "propJoe": "a proposition then"
 * }
 *
 * There would be two profile property values, one named "prop1" with a value of
 * "true" and additional metadata for a label for the name and a last seen timestamp.
 * The other would of course be a name of "propJoe" and value of "a proposition then".
 */
export type ProfilePropertyValue = {
  __typename?: 'ProfilePropertyValue';
  label?: Maybe<Scalars['String']>;
  lastSeen?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: PropertyType;
  value?: Maybe<Scalars['String']>;
};

/** Sort one profile on one of three columns: name, value, and last seen. */
export type ProfileSort = {
  direction?: SortDirection;
  sortKey: ProfileSortKey;
  sortType?: InputMaybe<ProfileSortType>;
};

export enum ProfileSortKey {
  AttributeName = 'ATTRIBUTE_NAME',
  AttributeValue = 'ATTRIBUTE_VALUE',
  LastSeen = 'LAST_SEEN'
}

export enum ProfileSortType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  String = 'STRING'
}

/**
 * An enumerable aspirationally representing the type of a property.
 * For now, all values are treated as strings but in the future the
 * backend could provide more coercion information (though they are
 * still all fundamentally stored as strings).
 */
export enum PropertyType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  /** all properties are typed as strings by default */
  String = 'STRING'
}

/** The outcome of a email publish attempt */
export type PublishEmailResult = {
  __typename?: 'PublishEmailResult';
  email?: Maybe<Email>;
  published: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

/** The outcome of a push notification publish attempt */
export type PublishPushNotificationResult = {
  __typename?: 'PublishPushNotificationResult';
  published: Scalars['Boolean'];
  pushNotification?: Maybe<PushNotification>;
  reason?: Maybe<Scalars['String']>;
};

/** The outcome of a workflow publish attempt */
export type PublishWorkflowResult = {
  __typename?: 'PublishWorkflowResult';
  published: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  workflow?: Maybe<Workflow>;
};

/** Represents an PushNotification object */
export type PushNotification = {
  __typename?: 'PushNotification';
  appIds?: Maybe<Array<Scalars['String']>>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<Scalars['String']>;
  clonedFrom?: Maybe<Scalars['String']>;
  clonedFromAccountId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  dirty: Scalars['Boolean'];
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  personalizationProperties?: Maybe<Array<Scalars['String']>>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<Scalars['String']>;
  revertedAt?: Maybe<Scalars['DateTime']>;
  revertedTo?: Maybe<Scalars['Int']>;
  sourceTemplateId?: Maybe<Scalars['String']>;
  state: PushNotificationState;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userArchivedBy?: Maybe<User>;
  userCreatedBy?: Maybe<User>;
  userPublishedBy?: Maybe<User>;
  userUnpublishedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
  version: Scalars['Int'];
  workflowId?: Maybe<Scalars['String']>;
};

/** Represents a PushNotification change containing the reason */
export type PushNotificationChange = {
  __typename?: 'PushNotificationChange';
  pushNotification?: Maybe<PushNotification>;
  reason: ChangeType;
};

/** Represents a set of AND conditions that a push notification should match */
export type PushNotificationFilter = {
  /** List of ids to filter push notifications by */
  ids?: Array<Scalars['ID']>;
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<PushNotificationState>;
  /** String used to search for a push notification by name */
  term?: Scalars['String'];
  /** Workflow to filter push notifications by */
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Valid push_notification sort keys */
export enum PushNotificationSortKey {
  /** When the push notification was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** Last time the push notification got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting push_notification */
export type PushNotificationSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: PushNotificationSortKey;
};

/** Valid push notification statuses */
export enum PushNotificationState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Versioned = 'VERSIONED'
}

/** Represents an PushNotificationTemplate object */
export type PushNotificationTemplate = {
  __typename?: 'PushNotificationTemplate';
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents a PushNotificationTemplate change containing the reason */
export type PushNotificationTemplateChange = {
  __typename?: 'PushNotificationTemplateChange';
  pushNotificationTemplate?: Maybe<PushNotificationTemplate>;
  reason: ChangeType;
};

/** Represents a set of AND conditions that a push notification template should match */
export type PushNotificationTemplateFilter = {
  /** String used to search for a push notification template by name */
  term?: InputMaybe<Scalars['String']>;
};

/** Valid push_notification_template sort keys */
export enum PushNotificationTemplateSortKey {
  /** When the push notification template was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** Last time the push notification template got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting push_notification_templates */
export type PushNotificationTemplateSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: PushNotificationTemplateSortKey;
};

export type References = {
  __typename?: 'References';
  checklists: Array<Checklist>;
  experiences: Array<Experience>;
  flows: Array<Flow>;
  nps: Array<Nps>;
  segments: Array<Segment>;
  workflows: Array<Workflow>;
};

/** Represents a general result operation */
export type Result = {
  __typename?: 'Result';
  /** An optional message string with details about the result */
  message?: Maybe<Scalars['String']>;
  /** Whether the result succeeded or not */
  success: Scalars['Boolean'];
};

/** The outcome of a push notification revert attempt */
export type RevertPushNotificationResult = {
  __typename?: 'RevertPushNotificationResult';
  pushNotification?: Maybe<PushNotification>;
  reason?: Maybe<Scalars['String']>;
  reverted: Scalars['Boolean'];
};

/** A user's role within an Appcues account (e.g., admin, publisher, editor, etc.). */
export type Role = {
  __typename?: 'Role';
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /**
   * Adds a workflow to the account's notification settings. Object existence
   * in `notification-target/<account>:<workflow>` is the "added" signal —
   * the read path filters to existing objects only. Toggles default off.
   * Admin-only — authorization enforced by appcues.yml policies.
   */
  addAccountNotification?: Maybe<Result>;
  addChartToDashboard: DashboardItem;
  addFunnelToDashboard: DashboardItem;
  addTacticContent?: Maybe<Result>;
  addWorkflowTaskMultipathBranch: WorkflowTaskResult;
  /** Append a step to an existing funnel. The step is added at the next position. */
  appendFunnelStep: Funnel;
  /**
   * Append multiple steps to an existing funnel in a single transaction. Steps are added in
   * order after the funnel's current last step. The whole operation fails (and adds nothing) if
   * any step is invalid. Passing an empty list is a no-op that returns the funnel unchanged.
   * Returns the updated funnel with all steps.
   */
  appendFunnelSteps: Funnel;
  archiveWorkflow: ArchiveWorkflowResult;
  /** Bulk-set the dismissed state for multiple insights */
  bulkSetInsightDismissed?: Maybe<BulkInsightResult>;
  /** Bulk-set the read state for multiple insights */
  bulkSetInsightRead?: Maybe<BulkInsightResult>;
  cancelInvite?: Maybe<Invite>;
  /** Clear the current user's AI assistant memory */
  clearAgentMemory?: Maybe<Result>;
  cloneContent: Content;
  cloneExperiment: ExperimentChange;
  cloneJourneyCanvas: JourneyCanvasChange;
  cloneSegment: Scalars['ID'];
  cloneWorkflow: CloneWorkflowResult;
  convertDashboardItem: DashboardItem;
  copyWorkflowTaskContentSteps: WorkflowTaskResult;
  copyWorkflowTaskMultipathBranch: WorkflowTaskResult;
  createAnnotationNode?: Maybe<AnnotationNodeChange>;
  createApp?: Maybe<AppChange>;
  /** create a new app push config */
  createAppPushConfig?: Maybe<AppPushConfigChange>;
  createAssistantAccountRule?: Maybe<AssistantAccountRuleChange>;
  createCampaign?: Maybe<Campaign>;
  createContentGraph?: Maybe<ContentGraphChange>;
  createDashboard: Dashboard;
  createDocSiteIntegration?: Maybe<DocSiteIntegrationChange>;
  createEmail?: Maybe<EmailChange>;
  createEmailConfig?: Maybe<EmailConfigResult>;
  createEmailSender?: Maybe<EmailSenderChange>;
  createEmailSuppressions?: Maybe<Result>;
  createEmailTemplate?: Maybe<EmailTemplateChange>;
  createExperiment?: Maybe<ExperimentChange>;
  createFlow?: Maybe<FlowChange>;
  createFolder?: Maybe<Folder>;
  /** Create a standalone funnel with its steps. */
  createFunnel: Funnel;
  createGoal?: Maybe<Goal>;
  createJourneyCanvas?: Maybe<JourneyCanvasChange>;
  createPushNotification?: Maybe<PushNotificationChange>;
  createPushNotificationTemplate?: Maybe<PushNotificationTemplateChange>;
  createSavedView?: Maybe<SavedView>;
  createSchedule?: Maybe<Schedule>;
  /** Create a new SDK key */
  createSdkKey?: Maybe<SdkKey>;
  createSegment: Segment;
  /** Create a new survey */
  createSurveyEntity: SurveyEntityChange;
  createSurveyField?: Maybe<SurveyFieldChange>;
  createTactic?: Maybe<Tactic>;
  createTag: TagChange;
  createWebhook: Webhook;
  createWorkflow: Workflow;
  createWorkflowTaskBranch: WorkflowTaskResult;
  createWorkflowTaskContent: WorkflowTaskResult;
  createWorkflowTaskDelay: WorkflowTaskResult;
  createWorkflowTaskEmail: WorkflowTaskResult;
  createWorkflowTaskEvent: WorkflowTaskResult;
  createWorkflowTaskMultipath: WorkflowTaskResult;
  createWorkflowTaskPoll: WorkflowTaskResult;
  createWorkflowTaskPushNotification: WorkflowTaskResult;
  createWorkflowTaskUserProperty: WorkflowTaskResult;
  createWorkflowTaskWait: WorkflowTaskResult;
  deleteAccountUser: Scalars['Boolean'];
  deleteAnnotationNode?: Maybe<Result>;
  /** delete an app push config */
  deleteAppPushConfig?: Maybe<Result>;
  deleteArchivedExperiment: ExperimentChange;
  deleteAssistantAccountRule?: Maybe<AssistantAccountRuleChange>;
  deleteAssistantSession?: Maybe<Result>;
  deleteCampaign?: Maybe<Result>;
  deleteContentGraph?: Maybe<Result>;
  deleteDashboard: Result;
  deleteDashboardItem: Result;
  deleteDocSiteIntegration?: Maybe<Result>;
  deleteEmail?: Maybe<Result>;
  deleteEmailSender?: Maybe<Result>;
  deleteEmailSuppression?: Maybe<Result>;
  deleteEmailTemplate?: Maybe<Result>;
  deleteFlow?: Maybe<Result>;
  deleteFolder?: Maybe<Result>;
  /**
   * Delete a persistent funnel by ID.
   * Returns success when the funnel was deleted, or not_found when it doesn't exist.
   */
  deleteFunnel: Result;
  /**
   * Delete a single step from a funnel. Remaining steps are re-indexed.
   * Returns the parent funnel with updated steps.
   */
  deleteFunnelStep: Funnel;
  /**
   * Delete multiple steps from a single funnel in one transaction. Every step_id must belong to
   * the given funnel_id (which must be owned by the account); if any step_id is not part of that
   * funnel the whole operation fails. This prevents bulk-deleting steps across multiple funnels in
   * one call. Remaining steps are re-indexed. Passing an empty list is a no-op that returns the
   * funnel unchanged. Returns the parent funnel with updated steps.
   */
  deleteFunnelSteps: Funnel;
  deleteGoal: Result;
  deleteJourneyCanvas?: Maybe<Result>;
  deleteJourneyCanvasNodePositions: JourneyCanvasChange;
  deletePushNotification?: Maybe<Result>;
  deletePushNotificationTemplate?: Maybe<Result>;
  deleteSavedView?: Maybe<Result>;
  deleteSchedule?: Maybe<Result>;
  /** Delete an SDK key */
  deleteSdkKey?: Maybe<SdkKey>;
  deleteSegment: Scalars['ID'];
  /** Delete a survey */
  deleteSurveyEntity?: Maybe<Result>;
  deleteSurveyField?: Maybe<Result>;
  deleteTactic?: Maybe<Result>;
  deleteTag?: Maybe<Result>;
  deleteWebhook?: Maybe<Result>;
  deleteWorkflow?: Maybe<Result>;
  deleteWorkflowTask: WorkflowTaskResult;
  /** Edit a single funnel step's events. Returns the parent funnel with all steps. */
  editFunnelStep: Funnel;
  /** Execute an insight action via the AI agent system */
  executeInsightAction?: Maybe<InsightAction>;
  exportGroupProfile: ExportOutput;
  exportSegment: Scalars['ID'];
  exportUserProfile: ExportOutput;
  exportWorkflowUsers: ExportWorkflowUsersResult;
  generateExperienceSummary?: Maybe<Result>;
  moveFolder?: Maybe<Folder>;
  /**
   * Move a funnel step to a new position. Pass prev_step_id as nil to move the step
   * to the beginning, or provide a step ID to place it immediately after that step.
   * Returns the parent funnel with all steps in their new order.
   */
  moveFunnelStep: Funnel;
  moveSavedView?: Maybe<SavedView>;
  moveWorkflowTask: WorkflowTaskResult;
  moveWorkflowTaskMultipathBranch: WorkflowTaskMultipath;
  publishContent?: Maybe<Result>;
  publishEmail?: Maybe<PublishEmailResult>;
  publishFlow?: Maybe<FlowChange>;
  publishPushNotification: PublishPushNotificationResult;
  publishWorkflow: PublishWorkflowResult;
  purgeWorkflowTaskEmailQueue?: Maybe<Result>;
  /**
   * Removes a workflow from the account's notification settings by deleting
   * the per-workflow target object. Wipes saved preferences, custom email,
   * and Slack channel selection for that workflow.
   * Admin-only — authorization enforced by appcues.yml policies.
   */
  removeAccountNotification?: Maybe<Result>;
  removeTacticContent?: Maybe<Result>;
  requestEmailSenderVerification?: Maybe<Result>;
  resetEmail?: Maybe<EmailChange>;
  /**
   * Resets the persistent funnel from the given flow (must be in DRAFT state) by clearing its rule association.
   * Returns the updated funnel, or not_found when the flow does not exist or has no persistent funnel.
   */
  resetFlowFunnel: Funnel;
  resetPushNotification: PushNotificationChange;
  resetUserFlowHistory?: Maybe<Result>;
  resetUserProfile?: Maybe<Result>;
  revertEmail?: Maybe<EmailChange>;
  revertPushNotification: RevertPushNotificationResult;
  sendInvite?: Maybe<Scalars['Boolean']>;
  sendTestEmail?: Maybe<EmailTestSendResult>;
  /** NOTE: This query is deprecated. Use set_folder_for_ids instead. */
  setFolder?: Maybe<Result>;
  setFolderForIds?: Maybe<Result>;
  /** Set the dismissed state of an insight (true to hide, false to un-dismiss) */
  setInsightDismissed?: Maybe<Insight>;
  /** Set the read state of an insight (true to mark read, false to mark unread) */
  setInsightRead?: Maybe<Insight>;
  /**
   * Subscribes the current user to the account's tenant fan-out so they
   * receive workflows that publish to `$tenants/<account_id>`. Per-user
   * handshake invoked from the Personal tab on first enable. Idempotent.
   */
  subscribeToAccountTenant?: Maybe<Result>;
  truncateFlowSteps?: Maybe<FlowChange>;
  unarchiveWorkflow: UnarchiveWorkflowResult;
  /** Undo a previously completed insight action via the AI agent system */
  undoInsightAction?: Maybe<InsightAction>;
  unpublishContent?: Maybe<Result>;
  unpublishEmail?: Maybe<PublishEmailResult>;
  unpublishFlow?: Maybe<FlowChange>;
  unpublishPushNotification: PublishPushNotificationResult;
  unpublishWorkflow: UnpublishWorkflowResult;
  updateAccountAdminSettings: Account;
  updateAccountAiAllowEndUserData: Account;
  updateAccountSettings: Account;
  updateAccountUser: AccountUserChange;
  updateAgentAccess?: Maybe<AssistantAccountAgentChange>;
  updateAnnotationNode: AnnotationNodeChange;
  updateApp: AppChange;
  /** update an existing app push config */
  updateAppPushConfig: AppPushConfigChange;
  updateAssistantAccountRule?: Maybe<AssistantAccountRuleChange>;
  updateAssistantSession: AssistantSessionChange;
  updateCampaign?: Maybe<Campaign>;
  updateChart: Chart;
  updateContentGraph: ContentGraphChange;
  updateDashboard: Dashboard;
  updateDocSiteIntegration: DocSiteIntegrationChange;
  updateEmail: EmailChange;
  updateEmailConfig?: Maybe<EmailConfigResult>;
  updateEmailSender: EmailSenderChange;
  updateEmailTemplate: EmailTemplateChange;
  updateExperiment: ExperimentChange;
  updateFlow?: Maybe<FlowChange>;
  updateFolder?: Maybe<Folder>;
  /**
   * Update a persistent funnel's name and/or conversion window.
   * Only the provided fields are updated.
   */
  updateFunnel: Funnel;
  updateGoal: Goal;
  updateGroupAttributeLabel?: Maybe<ProfilePropertyDefinition>;
  updateJourneyCanvas: JourneyCanvasChange;
  updateJourneyCanvasNodePositions: JourneyCanvasChange;
  /**
   * Updates one or more account-level notification settings for a single
   * workflow in a single call. Provide at least one of `emailEnabled`,
   * `chatEnabled`, `email`, or `cadence` alongside `workflowKey`. Slack
   * channel selection is FE-direct via Knock SDK, not this mutation.
   * Admin-only — authorization enforced by appcues.yml policies.
   */
  updateNotificationSetting?: Maybe<Result>;
  updateProfileAttributeLabel?: Maybe<ProfilePropertyDefinition>;
  updatePushNotification: PushNotificationChange;
  updatePushNotificationTemplate: PushNotificationTemplateChange;
  updateSavedView?: Maybe<SavedView>;
  /** Update an existing SDK key's tag */
  updateSdkKeyTag?: Maybe<SdkKey>;
  updateSegment: Segment;
  /** Trigger job to update the user count for all segments on the account */
  updateSegmentUserCounts?: Maybe<Result>;
  /** Update an existing survey */
  updateSurveyEntity: SurveyEntityChange;
  updateSurveyField: SurveyFieldChange;
  updateTactic?: Maybe<Tactic>;
  updateTacticContent?: Maybe<TacticContent>;
  updateTag: TagChange;
  /**
   * Sets the current user's delivery cadence for a single workflow on the
   * Personal tab. Writes the cadence label and the corresponding batch
   * window rule to the user's Knock properties in a single call. User
   * properties in Knock are not scoped per-account, so this setting is
   * shared across the accounts the user belongs to.
   */
  updateUserNotificationCadence?: Maybe<Result>;
  updateUserProfile: User;
  updateWebhook: Webhook;
  updateWorkflow: Workflow;
  updateWorkflowTaskBranch: WorkflowTaskBranch;
  updateWorkflowTaskContent: WorkflowTaskContent;
  updateWorkflowTaskDelay: WorkflowTaskDelay;
  updateWorkflowTaskEmail: WorkflowTaskEmail;
  updateWorkflowTaskEvent: WorkflowTaskEvent;
  updateWorkflowTaskMultipath: WorkflowTaskMultipath;
  updateWorkflowTaskMultipathBranch: WorkflowTaskMultipathBranch;
  updateWorkflowTaskPushNotification: WorkflowTaskPushNotification;
  updateWorkflowTaskUserProperty: WorkflowTaskUserProperty;
  uploadEmailSuppressions?: Maybe<Result>;
  upsertEventQualificationFilteringRule?: Maybe<EventQualificationFilteringRuleChange>;
  /** Upsert (insert or update) a funnel with its steps. */
  upsertFunnel: Funnel;
  upsertSchedule?: Maybe<Schedule>;
  verifyEmailDomain?: Maybe<EmailDomainVerificationResult>;
};


export type RootMutationTypeAddAccountNotificationArgs = {
  workflowKey: Scalars['String'];
};


export type RootMutationTypeAddChartToDashboardArgs = {
  input: AddChartToDashboardInput;
};


export type RootMutationTypeAddFunnelToDashboardArgs = {
  input: AddFunnelToDashboardInput;
};


export type RootMutationTypeAddTacticContentArgs = {
  brief?: InputMaybe<Scalars['Json']>;
  contentId: Scalars['String'];
  tacticId: Scalars['UUID4'];
};


export type RootMutationTypeAddWorkflowTaskMultipathBranchArgs = {
  input: AddWorkflowTaskMultipathBranchInput;
};


export type RootMutationTypeAppendFunnelStepArgs = {
  funnelId: Scalars['UUID4'];
  input: FunnelStepInput;
};


export type RootMutationTypeAppendFunnelStepsArgs = {
  funnelId: Scalars['UUID4'];
  input: Array<FunnelStepInput>;
};


export type RootMutationTypeArchiveWorkflowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeBulkSetInsightDismissedArgs = {
  input: BulkSetInsightDismissedInput;
};


export type RootMutationTypeBulkSetInsightReadArgs = {
  input: BulkSetInsightReadInput;
};


export type RootMutationTypeCancelInviteArgs = {
  inviteId: Scalars['String'];
};


export type RootMutationTypeCloneContentArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeCloneExperimentArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeCloneJourneyCanvasArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeCloneSegmentArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeCloneWorkflowArgs = {
  input: CloneWorkflowInput;
};


export type RootMutationTypeConvertDashboardItemArgs = {
  input: ConvertDashboardItemInput;
};


export type RootMutationTypeCopyWorkflowTaskContentStepsArgs = {
  input: CopyWorkflowTaskContentStepsInput;
};


export type RootMutationTypeCopyWorkflowTaskMultipathBranchArgs = {
  input: CopyWorkflowTaskMultipathBranchInput;
};


export type RootMutationTypeCreateAnnotationNodeArgs = {
  input: CreateAnnotationNodeInput;
};


export type RootMutationTypeCreateAppArgs = {
  input: CreateAppInput;
};


export type RootMutationTypeCreateAppPushConfigArgs = {
  input: CreateAppPushConfigInput;
};


export type RootMutationTypeCreateAssistantAccountRuleArgs = {
  input: AssistantAccountRuleInput;
};


export type RootMutationTypeCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type RootMutationTypeCreateContentGraphArgs = {
  input: CreateContentGraphInput;
};


export type RootMutationTypeCreateDashboardArgs = {
  input: CreateDashboardInput;
};


export type RootMutationTypeCreateDocSiteIntegrationArgs = {
  input: CreateDocSiteIntegrationInput;
};


export type RootMutationTypeCreateEmailArgs = {
  input: CreateEmailInput;
};


export type RootMutationTypeCreateEmailConfigArgs = {
  input: CreateEmailConfigInput;
};


export type RootMutationTypeCreateEmailSenderArgs = {
  input: CreateEmailSenderInput;
};


export type RootMutationTypeCreateEmailSuppressionsArgs = {
  input: CreateEmailSuppressionsInput;
};


export type RootMutationTypeCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};


export type RootMutationTypeCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type RootMutationTypeCreateFlowArgs = {
  input: FlowInput;
};


export type RootMutationTypeCreateFolderArgs = {
  input: CreateFolderInput;
};


export type RootMutationTypeCreateFunnelArgs = {
  input: CreateFunnelInput;
};


export type RootMutationTypeCreateGoalArgs = {
  input: CreateGoalInput;
};


export type RootMutationTypeCreateJourneyCanvasArgs = {
  input: CreateJourneyCanvasInput;
};


export type RootMutationTypeCreatePushNotificationArgs = {
  input: CreatePushNotificationInput;
};


export type RootMutationTypeCreatePushNotificationTemplateArgs = {
  input: CreatePushNotificationTemplateInput;
};


export type RootMutationTypeCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


export type RootMutationTypeCreateScheduleArgs = {
  input: ScheduleInput;
};


export type RootMutationTypeCreateSdkKeyArgs = {
  input: CreateSdkKeyInput;
};


export type RootMutationTypeCreateSegmentArgs = {
  input: CreateSegmentInput;
};


export type RootMutationTypeCreateSurveyEntityArgs = {
  input: CreateSurveyEntityInput;
};


export type RootMutationTypeCreateSurveyFieldArgs = {
  input: CreateSurveyFieldInput;
};


export type RootMutationTypeCreateTacticArgs = {
  input: CreateTacticInput;
};


export type RootMutationTypeCreateTagArgs = {
  input: CreateTagInput;
};


export type RootMutationTypeCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type RootMutationTypeCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


export type RootMutationTypeCreateWorkflowTaskBranchArgs = {
  input: CreateWorkflowTaskBranchInput;
};


export type RootMutationTypeCreateWorkflowTaskContentArgs = {
  input: CreateWorkflowTaskContentInput;
};


export type RootMutationTypeCreateWorkflowTaskDelayArgs = {
  input: CreateWorkflowTaskDelayInput;
};


export type RootMutationTypeCreateWorkflowTaskEmailArgs = {
  input: CreateWorkflowTaskEmailInput;
};


export type RootMutationTypeCreateWorkflowTaskEventArgs = {
  input: CreateWorkflowTaskEventInput;
};


export type RootMutationTypeCreateWorkflowTaskMultipathArgs = {
  input: CreateWorkflowTaskMultipathInput;
};


export type RootMutationTypeCreateWorkflowTaskPollArgs = {
  input: CreateWorkflowTaskPollInput;
};


export type RootMutationTypeCreateWorkflowTaskPushNotificationArgs = {
  input: CreateWorkflowTaskPushNotificationInput;
};


export type RootMutationTypeCreateWorkflowTaskUserPropertyArgs = {
  input: CreateWorkflowTaskUserPropertyInput;
};


export type RootMutationTypeCreateWorkflowTaskWaitArgs = {
  input: CreateWorkflowTaskWaitInput;
};


export type RootMutationTypeDeleteAccountUserArgs = {
  invitedUserId: Scalars['String'];
};


export type RootMutationTypeDeleteAnnotationNodeArgs = {
  id: Scalars['String'];
  journeyCanvasId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteAppPushConfigArgs = {
  appId: Scalars['String'];
};


export type RootMutationTypeDeleteArchivedExperimentArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteAssistantAccountRuleArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteAssistantSessionArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteCampaignArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDeleteContentGraphArgs = {
  id: Scalars['String'];
  journeyCanvasId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteDashboardArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteDashboardItemArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteDocSiteIntegrationArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteEmailArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteEmailSenderArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteEmailSuppressionArgs = {
  address: Scalars['String'];
  type: SuppressionType;
};


export type RootMutationTypeDeleteEmailTemplateArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteFlowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteFolderArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDeleteFunnelArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDeleteFunnelStepArgs = {
  stepId: Scalars['UUID4'];
};


export type RootMutationTypeDeleteFunnelStepsArgs = {
  funnelId: Scalars['UUID4'];
  stepIds: Array<Scalars['UUID4']>;
};


export type RootMutationTypeDeleteGoalArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteJourneyCanvasArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteJourneyCanvasNodePositionsArgs = {
  input: DeleteJourneyCanvasNodePositionsInput;
};


export type RootMutationTypeDeletePushNotificationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeletePushNotificationTemplateArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteSavedViewArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDeleteScheduleArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteSdkKeyArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteSegmentArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteSurveyEntityArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteSurveyFieldArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteTacticArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeDeleteTagArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteWebhookArgs = {
  input: DeleteWebhookInput;
};


export type RootMutationTypeDeleteWorkflowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteWorkflowTaskArgs = {
  id: Scalars['String'];
  workflowId: Scalars['String'];
};


export type RootMutationTypeEditFunnelStepArgs = {
  input: EditFunnelStepInput;
  stepId: Scalars['UUID4'];
};


export type RootMutationTypeExecuteInsightActionArgs = {
  input: ExecuteInsightActionInput;
};


export type RootMutationTypeExportGroupProfileArgs = {
  emailTo: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationTypeExportSegmentArgs = {
  email: Scalars['String'];
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  segmentId: Scalars['String'];
};


export type RootMutationTypeExportUserProfileArgs = {
  emailTo: Scalars['String'];
  groupId: Scalars['ID'];
  propertyNames: Array<InputMaybe<Scalars['String']>>;
  sortBy: Scalars['String'];
};


export type RootMutationTypeExportWorkflowUsersArgs = {
  input: ExportWorkflowUsersInput;
};


export type RootMutationTypeGenerateExperienceSummaryArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeMoveFolderArgs = {
  from?: InputMaybe<Scalars['UUID4']>;
  id: Scalars['UUID4'];
  newPosition: Scalars['Int'];
  to?: InputMaybe<Scalars['UUID4']>;
};


export type RootMutationTypeMoveFunnelStepArgs = {
  prevStepId?: InputMaybe<Scalars['UUID4']>;
  stepId: Scalars['UUID4'];
};


export type RootMutationTypeMoveSavedViewArgs = {
  id: Scalars['UUID4'];
  position: Scalars['Int'];
};


export type RootMutationTypeMoveWorkflowTaskArgs = {
  input: MoveWorkflowTaskInput;
};


export type RootMutationTypeMoveWorkflowTaskMultipathBranchArgs = {
  input: MoveWorkflowTaskMultipathBranchInput;
};


export type RootMutationTypePublishContentArgs = {
  id: Scalars['String'];
};


export type RootMutationTypePublishEmailArgs = {
  id: Scalars['String'];
};


export type RootMutationTypePublishFlowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypePublishPushNotificationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypePublishWorkflowArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type RootMutationTypePurgeWorkflowTaskEmailQueueArgs = {
  emailId: Scalars['String'];
};


export type RootMutationTypeRemoveAccountNotificationArgs = {
  workflowKey: Scalars['String'];
};


export type RootMutationTypeRemoveTacticContentArgs = {
  contentId: Scalars['String'];
  tacticId: Scalars['UUID4'];
};


export type RootMutationTypeRequestEmailSenderVerificationArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeResetEmailArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeResetFlowFunnelArgs = {
  flowId: Scalars['String'];
};


export type RootMutationTypeResetPushNotificationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeResetUserFlowHistoryArgs = {
  endUserId: Scalars['ID'];
};


export type RootMutationTypeResetUserProfileArgs = {
  endUserId: Scalars['ID'];
};


export type RootMutationTypeRevertEmailArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeRevertPushNotificationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeSendInviteArgs = {
  input: InviteInput;
};


export type RootMutationTypeSendTestEmailArgs = {
  input: EmailTestParams;
};


export type RootMutationTypeSetFolderArgs = {
  folderId?: InputMaybe<Scalars['UUID4']>;
  id: Scalars['String'];
};


export type RootMutationTypeSetFolderForIdsArgs = {
  folderId?: InputMaybe<Scalars['UUID4']>;
  ids: Array<Scalars['String']>;
};


export type RootMutationTypeSetInsightDismissedArgs = {
  input: SetInsightDismissedInput;
};


export type RootMutationTypeSetInsightReadArgs = {
  input: SetInsightReadInput;
};


export type RootMutationTypeTruncateFlowStepsArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUnarchiveWorkflowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUndoInsightActionArgs = {
  input: UndoInsightActionInput;
};


export type RootMutationTypeUnpublishContentArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUnpublishEmailArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUnpublishFlowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUnpublishPushNotificationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeUnpublishWorkflowArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeUpdateAccountAdminSettingsArgs = {
  input: AccountAdminSettingsInput;
};


export type RootMutationTypeUpdateAccountAiAllowEndUserDataArgs = {
  enabled: Scalars['Boolean'];
};


export type RootMutationTypeUpdateAccountSettingsArgs = {
  input: AccountSettingsInput;
};


export type RootMutationTypeUpdateAccountUserArgs = {
  input: UpdateAccountUserInput;
};


export type RootMutationTypeUpdateAgentAccessArgs = {
  input: UpdateAgentAccessInput;
};


export type RootMutationTypeUpdateAnnotationNodeArgs = {
  input: UpdateAnnotationNodeInput;
};


export type RootMutationTypeUpdateAppArgs = {
  input: UpdateAppInput;
};


export type RootMutationTypeUpdateAppPushConfigArgs = {
  input: UpdateAppPushConfigInput;
};


export type RootMutationTypeUpdateAssistantAccountRuleArgs = {
  input: UpdateAssistantAccountRuleInput;
};


export type RootMutationTypeUpdateAssistantSessionArgs = {
  input: UpdateAssistantSessionInput;
};


export type RootMutationTypeUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type RootMutationTypeUpdateChartArgs = {
  input: UpdateChartInput;
};


export type RootMutationTypeUpdateContentGraphArgs = {
  input: UpdateContentGraphInput;
};


export type RootMutationTypeUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};


export type RootMutationTypeUpdateDocSiteIntegrationArgs = {
  input: UpdateDocSiteIntegrationInput;
};


export type RootMutationTypeUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type RootMutationTypeUpdateEmailConfigArgs = {
  input: UpdateEmailConfigInput;
};


export type RootMutationTypeUpdateEmailSenderArgs = {
  input: UpdateEmailSenderInput;
};


export type RootMutationTypeUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
};


export type RootMutationTypeUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type RootMutationTypeUpdateFlowArgs = {
  input: UpdateFlowInput;
};


export type RootMutationTypeUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type RootMutationTypeUpdateFunnelArgs = {
  input: UpdateFunnelInput;
};


export type RootMutationTypeUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type RootMutationTypeUpdateGroupAttributeLabelArgs = {
  input: UpdateProfileAttributeLabelInput;
};


export type RootMutationTypeUpdateJourneyCanvasArgs = {
  input: UpdateJourneyCanvasInput;
};


export type RootMutationTypeUpdateJourneyCanvasNodePositionsArgs = {
  input: UpdateJourneyCanvasNodePositionsInput;
};


export type RootMutationTypeUpdateNotificationSettingArgs = {
  cadence?: InputMaybe<Cadence>;
  chatEnabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']>;
  workflowKey: Scalars['String'];
};


export type RootMutationTypeUpdateProfileAttributeLabelArgs = {
  input: UpdateProfileAttributeLabelInput;
};


export type RootMutationTypeUpdatePushNotificationArgs = {
  input: UpdatePushNotificationInput;
};


export type RootMutationTypeUpdatePushNotificationTemplateArgs = {
  input: UpdatePushNotificationTemplateInput;
};


export type RootMutationTypeUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


export type RootMutationTypeUpdateSdkKeyTagArgs = {
  id: Scalars['ID'];
  tag: Scalars['String'];
};


export type RootMutationTypeUpdateSegmentArgs = {
  input: UpdateSegmentInput;
};


export type RootMutationTypeUpdateSegmentUserCountsArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateSurveyEntityArgs = {
  input: UpdateSurveyEntityInput;
};


export type RootMutationTypeUpdateSurveyFieldArgs = {
  input: UpdateSurveyFieldInput;
};


export type RootMutationTypeUpdateTacticArgs = {
  input: UpdateTacticInput;
};


export type RootMutationTypeUpdateTacticContentArgs = {
  input: UpdateTacticContentInput;
};


export type RootMutationTypeUpdateTagArgs = {
  input: UpdateTagInput;
};


export type RootMutationTypeUpdateUserNotificationCadenceArgs = {
  cadence: Cadence;
  workflowKey: Scalars['String'];
};


export type RootMutationTypeUpdateUserProfileArgs = {
  input: UserProfileInput;
};


export type RootMutationTypeUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type RootMutationTypeUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


export type RootMutationTypeUpdateWorkflowTaskBranchArgs = {
  input: UpdateWorkflowTaskBranchInput;
};


export type RootMutationTypeUpdateWorkflowTaskContentArgs = {
  input: UpdateWorkflowTaskContentInput;
};


export type RootMutationTypeUpdateWorkflowTaskDelayArgs = {
  input: UpdateWorkflowTaskDelayInput;
};


export type RootMutationTypeUpdateWorkflowTaskEmailArgs = {
  input: UpdateWorkflowTaskEmailInput;
};


export type RootMutationTypeUpdateWorkflowTaskEventArgs = {
  input: UpdateWorkflowTaskEventInput;
};


export type RootMutationTypeUpdateWorkflowTaskMultipathArgs = {
  input: UpdateWorkflowTaskMultipathInput;
};


export type RootMutationTypeUpdateWorkflowTaskMultipathBranchArgs = {
  input: UpdateWorkflowTaskMultipathBranchInput;
};


export type RootMutationTypeUpdateWorkflowTaskPushNotificationArgs = {
  input: UpdateWorkflowTaskPushNotificationInput;
};


export type RootMutationTypeUpdateWorkflowTaskUserPropertyArgs = {
  input: UpdateWorkflowTaskUserPropertyInput;
};


export type RootMutationTypeUploadEmailSuppressionsArgs = {
  file: Scalars['Upload'];
  type: SuppressionType;
};


export type RootMutationTypeUpsertEventQualificationFilteringRuleArgs = {
  input: EventQualificationFilteringRuleInput;
};


export type RootMutationTypeUpsertFunnelArgs = {
  input: UpsertFunnelInput;
};


export type RootMutationTypeUpsertScheduleArgs = {
  input: ScheduleInput;
};


export type RootMutationTypeVerifyEmailDomainArgs = {
  domainName: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Return the account's information */
  account: Account;
  accountDomains: Array<AccountDomain>;
  /**
   * Return the list of all account entitlements that belong to the current account.
   * This query does not preload the account.
   */
  accountEntitlements?: Maybe<Array<AccountEntitlement>>;
  /**
   * Return the list of all account users that belong to the current account.
   *   This query does not preload the account.
   */
  accountUsers?: Maybe<Array<AccountUser>>;
  /** Get assistant account agent access by agent name */
  agentAccess?: Maybe<AssistantAccountAgent>;
  /** Get the current user's AI assistant memory */
  agentMemory?: Maybe<AgentMemory>;
  /** Get a single annotation node by id */
  annotationNode: AnnotationNode;
  /** Get a single app by id */
  app: App;
  /** Get app push config status by app id */
  appPushConfig: AppPushConfig;
  /** Get push config validation check results */
  appPushConfigTestResult: AppPushConfigTestResult;
  /** Get list of app push configs in an account */
  appPushConfigs: Array<AppPushConfig>;
  /** Get a list of apps */
  apps: Array<App>;
  /** Get a single assistant account rule by id */
  assistantAccountRule?: Maybe<AssistantAccountRule>;
  /** List all assistant account rules for the current account */
  assistantAccountRules: Array<AssistantAccountRule>;
  /** Get a single assistant session by id */
  assistantSession: AssistantSession;
  /** Get a list of assistant sessions. The list can be paginated. */
  assistantSessions?: Maybe<AssistantSessionListResult>;
  /** Get banner summary metrics */
  bannerMetrics: BannerMetrics;
  campaign?: Maybe<Campaign>;
  campaigns?: Maybe<CampaignList>;
  /** Get a chart by ID */
  chart?: Maybe<Chart>;
  /** Get all standalone charts for the current account */
  charts: Array<Chart>;
  /** Get a single checklist by id */
  checklist: Checklist;
  /** Get checklist summary metrics */
  checklistMetrics: ChecklistMetrics;
  /** Provide a list of checklists. The list can be filtered, paginated and sorted. */
  checklists: Array<Checklist>;
  /** Returns a list of users that match the given conditions */
  conditionsUsers?: Maybe<SegmentUsers>;
  /** Get a single content graph by id */
  contentGraph: ContentGraph;
  /**
   * Returns a list of Content elements using a combination of optional
   * pagination, sorting and filtering parameters.
   */
  contents?: Maybe<ContentList>;
  /** Get a dashboard by ID */
  dashboard: Dashboard;
  /** Get all dashboards for the current account */
  dashboards: Array<Dashboard>;
  /** Get a single doc site by id */
  docSiteIntegration: DocSiteIntegration;
  /** Get a list of doc site integrations. */
  docSiteIntegrations?: Maybe<Array<DocSiteIntegration>>;
  /** Get a single email by id */
  email: Email;
  /** Get email configuration. */
  emailConfig: EmailConfigResult;
  /** Get email limits usage for the account. */
  emailLimitsUsage: EmailLimitsUsage;
  /** Get a single email sender by id */
  emailSender: EmailSender;
  /** Get a list of emails. The list can be paginated. */
  emailSenders?: Maybe<Array<EmailSender>>;
  emailSuppressions?: Maybe<EmailSuppressions>;
  /** Get a single email template by id */
  emailTemplate: EmailTemplate;
  /** Get a list of email templates. The list can be paginated. */
  emailTemplates?: Maybe<Array<EmailTemplate>>;
  /** Get a list of emails. The list can be paginated. */
  emails?: Maybe<Array<Email>>;
  endUserProfile?: Maybe<Profile>;
  endUserProfileList?: Maybe<ProfileList>;
  endUserProfileListForEvent?: Maybe<ProfileListForEvent>;
  /** List of event names for the current account. */
  eventNames?: Maybe<Array<Maybe<Event>>>;
  /** Get the event qualification filtering rule for the current account */
  eventQualificationFilteringRule?: Maybe<EventQualificationFilteringRule>;
  /**
   * Fetch launchpad events summary by category e.g events from Go to a URL or Launch a Flow.
   * refresh works by clearing redis cache for the current account + given event_name
   */
  eventsByCategory?: Maybe<Array<Maybe<LaunchpadEventSummary>>>;
  /** Get a single experience by id */
  experience: Experience;
  /** Get all experience summary metrics */
  experienceMetrics: ExperienceMetrics;
  /** Provide a list of experiences. The list can be filtered, paginated and sorted. */
  experiences: Array<Experience>;
  /** Get a single experiment by id */
  experimentV2: ExperimentWithContent;
  /** Provide a list of experiments. The list can be paginated. */
  experimentsV2: Array<ExperimentWithContent>;
  /** Receives a qualified conditions map and sends it to an AI model to explain why the user qualified or not. */
  explainConditions?: Maybe<Scalars['String']>;
  exportEmailSuppressions?: Maybe<Result>;
  /** Get a single flow by id */
  flow: Flow;
  /** Get a funnel for a flow */
  flowFunnel: Funnel;
  /**
   * Get funnel analytics results for a flow.
   *
   * Returns step-by-step user counts and conversion rates for the flow's funnel
   * (flow_started -> goal_reached if a goal is configured).
   */
  flowFunnelResults: FunnelResults;
  /** Get all flow summary metrics */
  flowMetrics: FlowMetrics;
  flowPerformanceMetricsWithMeta: FlowMetricsWithMeta;
  /** Get the published version of single flow by id */
  flowPublished: Flow;
  /** Get a single flow by id and version */
  flowVersioned: Flow;
  /** Provide a list of flows. The list can be filtered, paginated and sorted. */
  flows: Array<Flow>;
  /** Returns the content of a single folder */
  folder: Folder;
  /** Returns the content of a list of folders */
  folders?: Maybe<Array<FolderHierarchy>>;
  /** Get a funnel by ID */
  funnel: Funnel;
  /**
   * Get funnel analytics results for a funnel by ID.
   *
   * Returns step-by-step user counts and conversion rates for any persistent funnel.
   */
  funnelResults: FunnelResults;
  /**
   * Get users who reached or missed a specific step in a funnel.
   *
   * Returns a paginated list of users with profile attributes.
   */
  funnelStepUsers: FunnelStepUsersResult;
  /** Get all funnels for the current account */
  funnels: FunnelsResponse;
  /** Analyze a funnel with 2-10 sequential event steps, returning user counts at each step */
  getEventFunnel: EventFunnelResult;
  /** Get a single goal by id */
  goal?: Maybe<Goal>;
  /** Provide a list of goals */
  goals: Array<Goal>;
  /** Get goals first reached this week metrics */
  goalsFirstReachedThisWeek: Array<GoalFirstReachedMetrics>;
  /** Provide a list of goals */
  goalsV2?: Maybe<GoalResult>;
  /** Returns an unordered sample of profile attribute values for the current account. */
  groupAttributeValues?: Maybe<ProfileAttributeValues>;
  /** List of group attributes for the current account. */
  groupAttributes?: Maybe<Array<Maybe<ProfilePropertyDefinition>>>;
  /** Returns the daily metrics for active users */
  groupDailyActiveUsersTimeline: GroupDailyMetrics;
  /** Returns the daily metrics for events per user */
  groupEventsPerUserTimeline: GroupDailyMetrics;
  /** Returns the events timeline */
  groupEventsTimeline: GroupDailyMetrics;
  /** Returns the daily metrics for experiences seen */
  groupExperiencesSeenTimeline: GroupDailyMetrics;
  /** Returns the page views timeline */
  groupPageViewsTimeline: GroupDailyMetrics;
  groupProfile?: Maybe<Profile>;
  /** List of group profile attributes for the current account. */
  groupProfileAttributes?: Maybe<ProfileAttributeList>;
  groupProfileList?: Maybe<GroupProfileList>;
  /** Returns the screen views timeline */
  groupScreenViewsTimeline: GroupDailyMetrics;
  /** Returns the group seen metrics */
  groupSeenMetrics: GroupSeenMetrics;
  /** Returns the sessions timeline */
  groupSessionsTimeline: GroupDailyMetrics;
  /** Returns the daily metrics for group stickiness */
  groupStickinessTimeline: GroupDailyMetrics;
  /** Returns the group topline metrics */
  groupToplineMetrics: GroupToplineMetrics;
  /** Returns the group usage topline metrics */
  groupUsageToplineMetrics: GroupUsageToplineMetrics;
  hydratedJourneyCanvas: HydratedJourneyCanvas;
  /**
   * Returns the identity (that is, account and user) of the auth token
   * that was provided with this connection.
   */
  identity?: Maybe<Identity>;
  /** Get a single insight by ID */
  insight?: Maybe<Insight>;
  /** Get a paginated list of approved insights for the current account */
  insights: InsightConnection;
  /** Returns a journey */
  journey: Journey;
  /** Get a single journey_canvas by id */
  journeyCanvas: JourneyCanvas;
  /** Provide a list of journey_canvases. The list can be paginated. */
  journeyCanvases: Array<JourneyCanvas>;
  /** Generates a signed Knock JWT for the current user (frontend SDK auth) */
  knockUserToken?: Maybe<KnockUserToken>;
  /** Get all launchpad summary metrics */
  launchpadMetrics: LaunchpadMetrics;
  /** Get all launchpad recent users */
  launchpadRecentUsers: LaunchpadRecentUsers;
  listInvites: Array<Invite>;
  /** Get account metrics for Monthly Active Users (MTU) and Messages */
  mauMetrics: MauMetrics;
  /** Get account metrics for Monthly Tracked Users (MTU) and Messages */
  mtuMessagesMetrics: MtuMessagesMetrics;
  /** Returns the account-level notification settings (per-workflow preferences) */
  notificationSettings?: Maybe<NotificationSettings>;
  /** Returns the list of available notification workflows */
  notificationWorkflows: Array<NotificationWorkflow>;
  /** Get NPS Survey Events (NPS 2.0 model) */
  npsSurveyEvents?: Maybe<Array<Maybe<NpsSurveyEventItem>>>;
  overviewMetricsV2: OverviewMetricsV2;
  /** Get pin summary metrics */
  pinMetrics: PinMetrics;
  presignSegmentCsv: Scalars['String'];
  /** Returns an unordered sample of profile attribute values for the current account. */
  profileAttributeValues?: Maybe<ProfileAttributeValues>;
  /** List of profile attributes for the current account. */
  profileAttributes?: Maybe<Array<Maybe<ProfilePropertyDefinition>>>;
  /** Example of specialized query that only list all published flows */
  publishedFlows: Array<Flow>;
  /** Get a single push_notification by id */
  pushNotification: PushNotification;
  /** Get a single push_notification_template by id */
  pushNotificationTemplate: PushNotificationTemplate;
  /** Provide a list of push_notification_templates. The list can be paginated. */
  pushNotificationTemplates: Array<PushNotificationTemplate>;
  /** Provide a list of push_notifications. The list can be paginated. */
  pushNotifications: Array<PushNotification>;
  /** Returns a single saved view by ID (team views or own personal views only) */
  savedView?: Maybe<SavedView>;
  /** Returns personal + team saved views for the current user, ordered by position */
  savedViews?: Maybe<Array<SavedView>>;
  /** List of schedules */
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  /** List all SDK keys */
  sdkKeys?: Maybe<Array<SdkKey>>;
  /** Get a single segment by id */
  segment?: Maybe<SegmentDetails>;
  /** Returns a boolean indicating whether the segment user count batch job is currently running for the account */
  segmentUserCountsBatchJobInProgress?: Maybe<Scalars['Boolean']>;
  /** Returns metadata about the most recently run segment user count batch job */
  segmentUserCountsBatchJobMetadata?: Maybe<SegmentUserCountsBatchJobMetadata>;
  /** Returns a list of user profiles for users that are in a given segment id */
  segmentUsers?: Maybe<SegmentUsers>;
  /** NOTE: This query is deprecated. Use segments_v2 instead. */
  segments?: Maybe<Array<Segment>>;
  /** Returns a list of paginated segments */
  segmentsV2: SegmentsResponse;
  suggestions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Get a single survey by id. */
  survey?: Maybe<Survey>;
  /** Get the surveys answers and questions */
  surveyAnswers?: Maybe<SurveyAnswer>;
  /** Get a list of surveys. The list can be paginated. */
  surveyEntities?: Maybe<Array<SurveyEntity>>;
  /** Get a single survey by id */
  surveyEntity: SurveyEntity;
  /**
   * Get Survey Events (NPS 2.0 model)
   * @deprecated Use nps_survey_events instead
   */
  surveyEvents?: Maybe<Array<Maybe<NpsSurveyEventItem>>>;
  /** Get a single survey field by id */
  surveyField: SurveyField;
  /** Get a list of survey field types. */
  surveyFieldTypes?: Maybe<Array<SurveyFieldType>>;
  /** Get a list of survey fields. The list can be paginated. */
  surveyFields?: Maybe<Array<SurveyField>>;
  /** Get a list of survey types. */
  surveyTypes?: Maybe<Array<SurveyType>>;
  /** Provide a list of surveys. The list can be paginated. */
  surveys: Array<Survey>;
  tactic?: Maybe<Tactic>;
  tacticsForCampaign?: Maybe<Array<Tactic>>;
  /** Get a single tag by id */
  tag: Tag;
  /** Provide a list of tags */
  tags: Array<Tag>;
  /**
   * Returns the associated trial_status for the account.
   * May return nil as some legacy accounts might not have this structure
   * stored in the database.
   */
  trialStatus?: Maybe<TrialStatus>;
  /** Get the count of unread insights for the current account */
  unreadInsightCount: Scalars['Int'];
  /** Get a single user with its signature by id */
  user: User;
  /**
   * Returns the current user's cadence per workflow for the Personal tab.
   * One row per workflow in the catalog; cadence defaults to IMMEDIATE
   * when no value has been set on the user.
   */
  userNotificationCadences: Array<UserNotificationCadence>;
  /** List of user profile attributes for the current account. */
  userProfileAttributes?: Maybe<ProfileAttributeList>;
  /** Get a single webhook by id */
  webhook: Webhook;
  /** Get the webhook metadata */
  webhookMetadata: WebhookMetadata;
  /** Provide a list of webhooks. */
  webhooks: Array<Webhook>;
  /** Get a single workflow by id */
  workflow: Workflow;
  /** Get count of users who started but haven't finished a workflow */
  workflowActiveUsersCount: WorkflowActiveUsersCount;
  /**
   * Get count of users currently on each task in a workflow.
   * Includes '__end' pseudo-task for users who have exited the workflow.
   * Only works for published workflows.
   */
  workflowCurrentTaskUserCounts: WorkflowCurrentTaskUserCountsResult;
  /**
   * Get paginated list of users currently on a specific task.
   * Use task_id '__start' to get users who entered but haven't completed any task.
   * Use task_id '__end' to get users who have exited the workflow.
   * Only works for published workflows.
   */
  workflowCurrentTaskUsers: WorkflowCurrentTaskUsersResult;
  /** Get email requests for a workflow task */
  workflowEmailRequests?: Maybe<Array<Maybe<WorkflowEmailRequestList>>>;
  workflowEmailTasksPerformance: WorkflowEmailTaskPerformaceResult;
  /** Number of distinct users for a given event */
  workflowEventDistinctUsers: WorkflowEventDistinctUsers;
  workflowEventsPerDay?: Maybe<Array<Maybe<WorkflowEventsPerDay>>>;
  workflowTaskDistinctUserRollup: WorkflowTaskDistinctUserSummary;
  workflowTaskEventList: WorkflowTaskEventList;
  /** Aggregate events per task */
  workflowTaskEventRollup: WorkflowTaskEventSummary;
  /**
   * Aggregate events per day for a given task respecting the funnel logic
   * Currently only supports email and push notification tasks
   */
  workflowTaskEventsPerDay?: Maybe<Array<Maybe<WorkflowTaskEventsPerDay>>>;
  workflowTaskExitFunnels?: Maybe<Array<Maybe<WorkflowTaskExitFunnel>>>;
  /** Aggregate current distinct users in a task */
  workflowTaskRuntimeStats?: Maybe<WorkflowTaskRuntimeStats>;
  workflowUserCount: ConditionUserCount;
  /** Provide a list of workflows. The list can be filtered, paginated and sorted. */
  workflows: Array<WorkflowSummary>;
};


export type RootQueryTypeAccountDomainsArgs = {
  page?: InputMaybe<PageInput>;
};


export type RootQueryTypeAccountEntitlementsArgs = {
  filter?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeAccountUsersArgs = {
  filter?: InputMaybe<AccountUserFilter>;
};


export type RootQueryTypeAgentAccessArgs = {
  agentName: Scalars['String'];
};


export type RootQueryTypeAnnotationNodeArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeAppArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeAppPushConfigArgs = {
  appId: Scalars['String'];
};


export type RootQueryTypeAppPushConfigTestResultArgs = {
  input: TestAppPushConfigInput;
};


export type RootQueryTypeAssistantAccountRuleArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeAssistantSessionArgs = {
  id: Scalars['ID'];
  internal?: Scalars['Boolean'];
};


export type RootQueryTypeAssistantSessionsArgs = {
  filter?: InputMaybe<AssistantSessionFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<AssistantSessionSortOrder>>;
};


export type RootQueryTypeBannerMetricsArgs = {
  endTime: Scalars['DateTime'];
  experienceId: Scalars['String'];
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeCampaignArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  pageInfo?: InputMaybe<PageInput>;
  sort?: InputMaybe<CampaignSortOrder>;
};


export type RootQueryTypeChartArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeChecklistArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeChecklistMetricsArgs = {
  checklistId: Scalars['String'];
};


export type RootQueryTypeChecklistsArgs = {
  filter?: InputMaybe<ChecklistFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<ChecklistSortOrder>>;
};


export type RootQueryTypeConditionsUsersArgs = {
  conditions: Scalars['Json'];
  filter: ProfileFilter;
  page: PageInput;
  sort?: InputMaybe<ProfileListSort>;
};


export type RootQueryTypeContentGraphArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  pageInfo?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ContentSortOrder>>;
};


export type RootQueryTypeDashboardArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeDocSiteIntegrationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeEmailArgs = {
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeEmailSenderArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeEmailSendersArgs = {
  filter?: InputMaybe<EmailSenderFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<EmailSenderSortOrder>>;
};


export type RootQueryTypeEmailSuppressionsArgs = {
  address?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<EmailSuppressionPage>;
  term?: InputMaybe<Scalars['String']>;
  type: SuppressionType;
};


export type RootQueryTypeEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeEmailTemplatesArgs = {
  filter?: InputMaybe<EmailTemplateFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<EmailTemplateSortOrder>>;
};


export type RootQueryTypeEmailsArgs = {
  filter?: InputMaybe<EmailFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<EmailSortOrder>>;
};


export type RootQueryTypeEndUserProfileArgs = {
  endUserId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProfileFilter>;
  page: PageInput;
  sort?: InputMaybe<ProfileSort>;
};


export type RootQueryTypeEndUserProfileListArgs = {
  filter?: InputMaybe<ProfileFilter>;
  groupId?: InputMaybe<Scalars['String']>;
  profilesPage: PageInput;
  sort?: InputMaybe<ProfileListSort>;
};


export type RootQueryTypeEndUserProfileListForEventArgs = {
  filter?: InputMaybe<ProfileForEventFilter>;
  page: PageInput;
  sort?: InputMaybe<ProfileForEventListSort>;
};


export type RootQueryTypeEventNamesArgs = {
  filter?: InputMaybe<EventNameFilter>;
};


export type RootQueryTypeEventsByCategoryArgs = {
  endDate: Scalars['DateTime'];
  interactionType: Scalars['String'];
  refresh?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};


export type RootQueryTypeExperienceArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeExperienceMetricsArgs = {
  endTime: Scalars['DateTime'];
  experienceId: Scalars['String'];
  goalId?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeExperiencesArgs = {
  filter?: InputMaybe<ExperienceFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<ExperienceSortOrder>>;
};


export type RootQueryTypeExperimentV2Args = {
  id: Scalars['String'];
};


export type RootQueryTypeExperimentsV2Args = {
  filter?: InputMaybe<ExperimentFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<ExperimentSortOrder>>;
};


export type RootQueryTypeExplainConditionsArgs = {
  conditions: Scalars['Json'];
};


export type RootQueryTypeExportEmailSuppressionsArgs = {
  emailTo: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type: SuppressionType;
};


export type RootQueryTypeFlowArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeFlowFunnelArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeFlowFunnelResultsArgs = {
  input: FlowFunnelResultsInput;
};


export type RootQueryTypeFlowMetricsArgs = {
  endTime: Scalars['DateTime'];
  flowId: Scalars['String'];
  goalId?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeFlowPerformanceMetricsWithMetaArgs = {
  endTime: Scalars['DateTime'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  prevEndTime: Scalars['DateTime'];
  prevStartTime: Scalars['DateTime'];
  sort: FlowPerformanceSortOrder;
  startTime: Scalars['DateTime'];
  state: FlowState;
};


export type RootQueryTypeFlowPublishedArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeFlowVersionedArgs = {
  id: Scalars['String'];
  version: Scalars['String'];
};


export type RootQueryTypeFlowsArgs = {
  filter?: InputMaybe<FlowFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<FlowSortOrder>>;
};


export type RootQueryTypeFolderArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeFunnelArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeFunnelResultsArgs = {
  input: FunnelResultsInput;
};


export type RootQueryTypeFunnelStepUsersArgs = {
  input: FunnelStepUsersInput;
};


export type RootQueryTypeFunnelsArgs = {
  filter?: FunnelFilter;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<FunnelSortOrder>;
};


export type RootQueryTypeGetEventFunnelArgs = {
  conversionWindowDays?: InputMaybe<Scalars['Int']>;
  entranceEndDate: Scalars['Date'];
  entranceStartDate: Scalars['Date'];
  steps: Array<FunnelStepEventInput>;
};


export type RootQueryTypeGoalArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeGoalsV2Args = {
  filter?: InputMaybe<GoalFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<GoalSortOrder>;
};


export type RootQueryTypeGroupAttributeValuesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  propertyName?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGroupDailyActiveUsersTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupEventsPerUserTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupEventsTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupExperiencesSeenTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupPageViewsTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupProfileArgs = {
  filter?: InputMaybe<ProfileFilter>;
  groupId: Scalars['String'];
  page: PageInput;
  sort?: InputMaybe<ProfileSort>;
};


export type RootQueryTypeGroupProfileAttributesArgs = {
  filter?: InputMaybe<ProfileAttributeFilter>;
  profileAttributesPage: PageInput;
  sort?: InputMaybe<ProfileAttributeSortOrder>;
};


export type RootQueryTypeGroupProfileListArgs = {
  filter?: InputMaybe<ProfileFilter>;
  profilesPage: PageInput;
  sort?: InputMaybe<ProfileListSort>;
};


export type RootQueryTypeGroupScreenViewsTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupSeenMetricsArgs = {
  groupId: Scalars['String'];
};


export type RootQueryTypeGroupSessionsTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupStickinessTimelineArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupToplineMetricsArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeGroupUsageToplineMetricsArgs = {
  groupId: Scalars['String'];
  timeframe: AnalyticsTimeframe;
};


export type RootQueryTypeHydratedJourneyCanvasArgs = {
  id: Scalars['String'];
  options?: InputMaybe<JourneyOptions>;
};


export type RootQueryTypeInsightArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeInsightsArgs = {
  dismissed?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InsightFilter>;
  page?: InputMaybe<Page>;
  pageInfo?: InputMaybe<PageInput>;
  read?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<InsightSortOrder>>;
};


export type RootQueryTypeJourneyArgs = {
  id: Scalars['String'];
  options?: InputMaybe<JourneyOptions>;
  type: Scalars['String'];
};


export type RootQueryTypeJourneyCanvasArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeJourneyCanvasesArgs = {
  filter?: InputMaybe<JourneyCanvasFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<JourneyCanvasSortOrder>>;
};


export type RootQueryTypeLaunchpadMetricsArgs = {
  endDate: Scalars['DateTime'];
  experienceId: Scalars['String'];
  segmentId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};


export type RootQueryTypeLaunchpadRecentUsersArgs = {
  filter?: InputMaybe<LaunchpadRecentUsersFilter>;
  page: PageInput;
  sort?: InputMaybe<ProfileForEventListSort>;
};


export type RootQueryTypeListInvitesArgs = {
  filter?: InputMaybe<InviteFilter>;
};


export type RootQueryTypeMauMetricsArgs = {
  input?: InputMaybe<MetricsInput>;
};


export type RootQueryTypeMtuMessagesMetricsArgs = {
  input?: InputMaybe<MetricsInput>;
};


export type RootQueryTypeNpsSurveyEventsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  experienceId: Scalars['String'];
  propertyNames?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  surveyId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
  userSegmentId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeOverviewMetricsV2Args = {
  input?: InputMaybe<MetricsInputV2>;
};


export type RootQueryTypePinMetricsArgs = {
  endTime: Scalars['DateTime'];
  experienceId: Scalars['String'];
  startTime: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypePresignSegmentCsvArgs = {
  segmentId: Scalars['String'];
};


export type RootQueryTypeProfileAttributeValuesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  propertyName?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeProfileAttributesArgs = {
  filter?: InputMaybe<ProfileAttributeFilter>;
};


export type RootQueryTypePushNotificationArgs = {
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypePushNotificationTemplateArgs = {
  id: Scalars['String'];
};


export type RootQueryTypePushNotificationTemplatesArgs = {
  filter?: InputMaybe<PushNotificationTemplateFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<PushNotificationTemplateSortOrder>>;
};


export type RootQueryTypePushNotificationsArgs = {
  filter?: InputMaybe<PushNotificationFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<PushNotificationSortOrder>>;
};


export type RootQueryTypeSavedViewArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeSavedViewsArgs = {
  type: SavedViewType;
};


export type RootQueryTypeSchedulesArgs = {
  contentId: Scalars['String'];
  from?: InputMaybe<Scalars['DateTime']>;
};


export type RootQueryTypeSegmentArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeSegmentUsersArgs = {
  filter: ProfileFilter;
  page: PageInput;
  segmentId: Scalars['String'];
  sort?: InputMaybe<ProfileListSort>;
};


export type RootQueryTypeSegmentsV2Args = {
  filter?: InputMaybe<SegmentFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<SegmentSortOrder>>;
};


export type RootQueryTypeSuggestionsArgs = {
  attributeName: Scalars['String'];
  term: Scalars['String'];
  type?: InputMaybe<SuggestionType>;
};


export type RootQueryTypeSurveyArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeSurveyAnswersArgs = {
  contentType?: InputMaybe<SurveyContentType>;
  filter?: InputMaybe<SurveyFilter>;
  id: Scalars['String'];
  page?: InputMaybe<Page>;
  propertyNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<Array<SurveyAnswerSortOrder>>;
};


export type RootQueryTypeSurveyEntitiesArgs = {
  filter?: InputMaybe<SurveyEntityFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<SurveyEntitySortOrder>>;
};


export type RootQueryTypeSurveyEntityArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeSurveyEventsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  startTime?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['Int']>;
  userSegmentId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeSurveyFieldArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeSurveyFieldTypesArgs = {
  filter?: InputMaybe<SurveyFieldTypeFilter>;
};


export type RootQueryTypeSurveyFieldsArgs = {
  filter?: InputMaybe<SurveyFieldFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<SurveyFieldSortOrder>>;
};


export type RootQueryTypeSurveysArgs = {
  filter?: InputMaybe<SurveyFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<SurveySortOrder>>;
};


export type RootQueryTypeTacticArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeTacticsForCampaignArgs = {
  campaignId: Scalars['UUID4'];
  filter?: InputMaybe<TacticFilter>;
};


export type RootQueryTypeTagArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeUserArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeUserProfileAttributesArgs = {
  filter?: InputMaybe<ProfileAttributeFilter>;
  profileAttributesPage: PageInput;
  sort?: InputMaybe<ProfileAttributeSortOrder>;
};


export type RootQueryTypeWebhookArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeWorkflowArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeWorkflowActiveUsersCountArgs = {
  workflowId: Scalars['String'];
};


export type RootQueryTypeWorkflowCurrentTaskUserCountsArgs = {
  input: WorkflowCurrentTaskUserCountsInput;
};


export type RootQueryTypeWorkflowCurrentTaskUsersArgs = {
  input: WorkflowCurrentTaskUsersInput;
  page?: InputMaybe<Page>;
  sortOrder?: InputMaybe<SortDirection>;
};


export type RootQueryTypeWorkflowEmailRequestsArgs = {
  input: WorkflowEmailRequestsInput;
  sort?: InputMaybe<WorkflowEmailRequestsSortOrder>;
  term?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeWorkflowEmailTasksPerformanceArgs = {
  metricsFilter: WorkflowEmailTasksMetricsFilter;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<WorkflowEmailTasksPerformanceSortOrder>>;
  tasksFilter?: InputMaybe<WorkflowEmailTasksListFilter>;
};


export type RootQueryTypeWorkflowEventDistinctUsersArgs = {
  input: WorkflowEventDistinctUsersInput;
};


export type RootQueryTypeWorkflowEventsPerDayArgs = {
  input: WorkflowEventsPerDayInput;
};


export type RootQueryTypeWorkflowTaskDistinctUserRollupArgs = {
  input: WorkflowTaskDistinctUserRollupInput;
};


export type RootQueryTypeWorkflowTaskEventListArgs = {
  input: WorkflowTaskEventListInput;
  page?: InputMaybe<Page>;
  sortOrder?: InputMaybe<SortDirection>;
};


export type RootQueryTypeWorkflowTaskEventRollupArgs = {
  input: WorkflowTaskEventRollupInput;
};


export type RootQueryTypeWorkflowTaskEventsPerDayArgs = {
  input: WorkflowTaskEventsPerDayInput;
};


export type RootQueryTypeWorkflowTaskExitFunnelsArgs = {
  input: WorkflowTaskExitFunnelsInput;
};


export type RootQueryTypeWorkflowTaskRuntimeStatsArgs = {
  input: WorkflowTaskRuntimeStatsInput;
};


export type RootQueryTypeWorkflowUserCountArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeWorkflowsArgs = {
  filter?: InputMaybe<WorkflowFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<WorkflowSortOrder>>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Notifies when an assistant session is created or updated for the account */
  assistantSessionChanges?: Maybe<AssistantSessionChange>;
  /** Notifies when a flow under the account gets updated */
  flowChanges?: Maybe<FlowChange>;
  /** Subscribe to updates about the segment user count batch job state */
  segmentUserCountsBatchJobState?: Maybe<SegmentUserCountsBatchJobState>;
  /** Subscribe to the results of the individual segment user count jobs */
  segmentUserCountsJobState?: Maybe<SegmentUserCountsJobState>;
};

/** Represents a complete Rule object */
export type Rule = {
  __typename?: 'Rule';
  conditions?: Maybe<Scalars['Json']>;
  conditionsFlatMap?: Maybe<ConditionsFlatMap>;
  conditionsJson?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  experimentId?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  funnelVersionHash?: Maybe<Scalars['String']>;
  goalConversionWindowDays?: Maybe<Scalars['Int']>;
  goalIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  id?: Maybe<Scalars['String']>;
  insertedAt: Scalars['DateTime'];
  internalId: Scalars['String'];
  migratedFromStepId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextContentId?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  redirectNewTab?: Maybe<Scalars['Boolean']>;
  redirectUrl?: Maybe<Scalars['String']>;
  sortPriority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  testFlowId?: Maybe<Scalars['String']>;
  testVersionOf?: Maybe<Scalars['String']>;
  throttleExempt: Scalars['Boolean'];
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  widgetFilter?: Maybe<Scalars['String']>;
};

/** Rule input object */
export type RuleInput = {
  conditions?: InputMaybe<Scalars['Json']>;
  experimentId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<ContentFrequency>;
  goalConversionWindowDays?: InputMaybe<Scalars['Int']>;
  goalIds?: InputMaybe<Array<Scalars['String']>>;
  nextContentId?: InputMaybe<Scalars['String']>;
  sortPriority?: InputMaybe<Scalars['Float']>;
  throttleExempt?: InputMaybe<Scalars['Boolean']>;
  widgetFilter?: InputMaybe<Scalars['String']>;
};

export type SavedView = {
  __typename?: 'SavedView';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  position: Scalars['Int'];
  scope: SavedViewScope;
  sort?: Maybe<Array<Maybe<Scalars['Json']>>>;
  type: SavedViewType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum SavedViewScope {
  Personal = 'PERSONAL',
  Team = 'TEAM'
}

export enum SavedViewType {
  Campaign = 'CAMPAIGN',
  Experience = 'EXPERIENCE'
}

/** Represents a Schedule object */
export type Schedule = {
  __typename?: 'Schedule';
  contentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Schedule input */
export type ScheduleInput = {
  /** ID of the content to associate the schedule to */
  contentId: Scalars['String'];
  /** Enable or disable the schedule */
  enabled: Scalars['Boolean'];
  /** End date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Represents a SDK Key object. */
export type SdkKey = {
  __typename?: 'SdkKey';
  accountId: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

/** Defines a user segment */
export type Segment = {
  __typename?: 'Segment';
  active: Scalars['Boolean'];
  conditions?: Maybe<Scalars['Json']>;
  conditionsFlatMapJson?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  createdByAppcues?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metaJson?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Returns the count of content that references this segment. A list of content states can
   * be passed as an argument so that only content in the specified states are counted.
   */
  referenceCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /** @deprecated Use user_count_result instead */
  userCount?: Maybe<Scalars['Int']>;
  userCountResult?: Maybe<UserCountResult>;
  /** @deprecated Use user_count_result instead */
  userCountUpdatedAt?: Maybe<Scalars['DateTime']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};


/** Defines a user segment */
export type SegmentReferenceCountArgs = {
  states?: Array<ContentState>;
};

/** Extends :segment to include expensive fields */
export type SegmentDetails = {
  __typename?: 'SegmentDetails';
  active: Scalars['Boolean'];
  conditions?: Maybe<Scalars['Json']>;
  conditionsFlatMapJson?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  createdByAppcues?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metaJson?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Returns the content that references this segment. A list of content states can
   * be passed as an argument. This allows archived flows and experiences to be returned,
   * for example.
   */
  references: References;
  /** @deprecated Segments referenced by this segment are available from the references field */
  segments?: Maybe<Array<Segment>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /**
   * Returns the count of users in the segment. If the `fetch_latest` argument is true,
   * the count is requested from the analytics database. Otherwise, the saved count value is returned.
   */
  userCount?: Maybe<Scalars['Int']>;
  userCountUpdatedAt?: Maybe<Scalars['DateTime']>;
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};


/** Extends :segment to include expensive fields */
export type SegmentDetailsReferencesArgs = {
  states?: Array<ContentState>;
};


/** Extends :segment to include expensive fields */
export type SegmentDetailsUserCountArgs = {
  fetchLatest?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a set of AND conditions that a segment should match */
export type SegmentFilter = {
  /** Filter by active state. When omitted, returns both active and inactive segments */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Optional list of segment ids */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** String used to search a segment by name. The term is used as a substring to match */
  term?: InputMaybe<Scalars['String']>;
};

/** Valid segment sort keys */
export enum SegmentSortKey {
  /** Whether the segment is active or inactive */
  Active = 'ACTIVE',
  /** When the segment was created */
  CreatedAt = 'CREATED_AT',
  /** Segment's name */
  Name = 'NAME',
  /** Last time the segment got updated */
  UpdatedAt = 'UPDATED_AT',
  /** Number of users in the segment */
  UserCount = 'USER_COUNT'
}

/** Combination of a column and a sort direction used when sorting segments */
export type SegmentSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: SegmentSortKey;
};

export type SegmentUserCountsBatchJobMetadata = {
  __typename?: 'SegmentUserCountsBatchJobMetadata';
  batchCompletedAt?: Maybe<Scalars['DateTime']>;
  batchId?: Maybe<Scalars['String']>;
  batchSize?: Maybe<Scalars['Int']>;
  batchStartedAt?: Maybe<Scalars['DateTime']>;
};

export type SegmentUserCountsBatchJobState = {
  __typename?: 'SegmentUserCountsBatchJobState';
  state: JobState;
};

export type SegmentUserCountsJobState = {
  __typename?: 'SegmentUserCountsJobState';
  result?: Maybe<Scalars['Int']>;
  segmentId: Scalars['String'];
  state: JobState;
};

export type SegmentUserProfile = {
  __typename?: 'SegmentUserProfile';
  /** Account the user belongs to. Can be null for anonymous users */
  accountId?: Maybe<Scalars['String']>;
  /** The user profile property values requested in the query */
  profile: Scalars['Json'];
  /** Timestamp of the users' last event */
  timestamp?: Maybe<Scalars['DateTime']>;
  /** User ID */
  userId: Scalars['String'];
};

export type SegmentUsers = {
  __typename?: 'SegmentUsers';
  pageInfo?: Maybe<PageInfo>;
  results: Array<SegmentUserProfile>;
};

/** Defines a list of segments and returns the pagination information */
export type SegmentsResponse = {
  __typename?: 'SegmentsResponse';
  pageInfo: PaginationInfo;
  segments?: Maybe<Array<Segment>>;
};

/** Input for setting the dismissed state of an insight */
export type SetInsightDismissedInput = {
  dismissed: Scalars['Boolean'];
  id: Scalars['ID'];
};

/** Input for setting the read state of an insight */
export type SetInsightReadInput = {
  id: Scalars['ID'];
  read: Scalars['Boolean'];
};

/** Generic sort direction normally used when paginating */
export enum SortDirection {
  /** Ascending sort */
  Asc = 'ASC',
  /** Descending sort */
  Desc = 'DESC'
}

/** Valid suggestion types */
export enum SuggestionType {
  /** Group profile values */
  Group = 'GROUP',
  /** User profile values */
  User = 'USER'
}

/** Valid suppression types */
export enum SuppressionType {
  Bounce = 'BOUNCE',
  Complaint = 'COMPLAINT',
  Unsubscribe = 'UNSUBSCRIBE'
}

/** Represents a Survey object */
export type Survey = {
  __typename?: 'Survey';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  answers?: Maybe<Array<Maybe<UserAnswer>>>;
  labels?: Maybe<Array<Maybe<SurveyLabel>>>;
  totalAnswersCount?: Maybe<Scalars['Int']>;
  totalAnswersInRangeCount?: Maybe<Scalars['Int']>;
};

/** Valid survey answer sort keys */
export enum SurveyAnswerSortKey {
  /** survey timestamp */
  Timestamp = 'TIMESTAMP',
  /** survey user */
  UserId = 'USER_ID'
}

/** Combination of a column and a sort direction used when sorting surveys answers */
export type SurveyAnswerSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key?: SurveyAnswerSortKey;
};

/** Valid survey content types */
export enum SurveyContentType {
  /** survey for experience */
  Experience = 'EXPERIENCE',
  /** survey for flow */
  Flow = 'FLOW'
}

/** Represents a Survey object */
export type SurveyEntity = {
  __typename?: 'SurveyEntity';
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  surveyFields?: Maybe<Array<Maybe<SurveyField>>>;
  surveyType?: Maybe<SurveyType>;
  updatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents a Survey change with a reason */
export type SurveyEntityChange = {
  __typename?: 'SurveyEntityChange';
  reason: ChangeType;
  surveyEntity?: Maybe<SurveyEntity>;
};

/** Represents a set of AND conditions that a survey should match */
export type SurveyEntityFilter = {
  /** Survey type to filter surveys by */
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

/** Valid survey entity sort keys */
export enum SurveyEntitySortKey {
  /** When the survey entity was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** When the survey entity was last updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents how a list of surveys should be sorted */
export type SurveyEntitySortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: SurveyEntitySortKey;
};

/** Represents a SurveyField object */
export type SurveyField = {
  __typename?: 'SurveyField';
  accountId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  survey?: Maybe<SurveyEntity>;
  surveyFieldType?: Maybe<SurveyFieldType>;
  updatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<User>;
  userUpdatedBy?: Maybe<User>;
};

/** Represents a SurveyField change with a reason */
export type SurveyFieldChange = {
  __typename?: 'SurveyFieldChange';
  reason: ChangeType;
  surveyField?: Maybe<SurveyField>;
};

/** Represents a set of AND conditions that a survey field should match */
export type SurveyFieldFilter = {
  /** Field type to filter survey fields by */
  surveyFieldTypeId?: InputMaybe<Scalars['Int']>;
  /** Survey to filter survey fields by */
  surveyId?: InputMaybe<Scalars['ID']>;
};

/** Valid survey field sort keys */
export enum SurveyFieldSortKey {
  /** When the survey field was created */
  CreatedAt = 'CREATED_AT',
  /** Name */
  Name = 'NAME',
  /** When the survey field was last updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents how a list of survey fields should be sorted */
export type SurveyFieldSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: SurveyFieldSortKey;
};

/** Represents a SurveyFieldType object */
export type SurveyFieldType = {
  __typename?: 'SurveyFieldType';
  id: Scalars['Int'];
  name: Scalars['String'];
  surveyType?: Maybe<SurveyType>;
};

/** Represents a set of AND conditions that a survey field type should match */
export type SurveyFieldTypeFilter = {
  /** Survey type to filter survey field types by */
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

/** Represents a set of AND conditions that a survey should match */
export type SurveyFilter = {
  /** Datetime value to stop filtering until */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Datetime value to start filtering from */
  start?: InputMaybe<Scalars['DateTime']>;
  /** Timezone offset integer in minutes for start & end fields */
  timezone?: InputMaybe<Scalars['Int']>;
};

/** Represents a Survey Labels object */
export type SurveyLabel = {
  __typename?: 'SurveyLabel';
  customReportingLabel?: Maybe<Scalars['String']>;
  fieldId?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  stepChildId?: Maybe<Scalars['String']>;
  stepChildNumber?: Maybe<Scalars['String']>;
};

/** Valid survey sort keys */
export enum SurveySortKey {
  /** survey id */
  SurveyId = 'SURVEY_ID'
}

/** Combination of a column and a sort direction used when sorting surveys */
export type SurveySortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: SurveySortKey;
};

/** Represents a SurveyType object */
export type SurveyType = {
  __typename?: 'SurveyType';
  id: Scalars['Int'];
  name: Scalars['String'];
  surveyFieldTypes?: Maybe<Array<Maybe<SurveyFieldType>>>;
};

export type Tactic = {
  __typename?: 'Tactic';
  brief?: Maybe<Scalars['Json']>;
  campaignId: Scalars['UUID4'];
  contents?: Maybe<Array<Content>>;
  contentsCount: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
  /** Screenshot query params from the oldest linked experience/flow */
  screenshotQueryParams?: Maybe<Scalars['String']>;
  /** Derived state: LIVE (any content published), ARCHIVED (all archived), or DRAFT */
  state?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type TacticContent = {
  __typename?: 'TacticContent';
  brief?: Maybe<Scalars['Json']>;
  checklistId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  experienceId?: Maybe<Scalars['String']>;
  flowId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  tacticId: Scalars['UUID4'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type TacticFilter = {
  /** Filter by derived states (DRAFT, LIVE, ARCHIVED). Defaults to [DRAFT, LIVE] */
  states?: InputMaybe<Array<Scalars['String']>>;
};

/** Represents a Tag object */
export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

/** Represents a Tag change containing the reason */
export type TagChange = {
  __typename?: 'TagChange';
  reason: ChangeType;
  tag?: Maybe<Tag>;
};

/** Test app push config input object */
export type TestAppPushConfigInput = {
  apnsBundleId?: InputMaybe<Scalars['String']>;
  apnsKey?: InputMaybe<Scalars['String']>;
  apnsKeyId?: InputMaybe<Scalars['String']>;
  apnsTeamId?: InputMaybe<Scalars['String']>;
  appId?: InputMaybe<Scalars['String']>;
  fcmKey?: InputMaybe<Scalars['String']>;
};

export enum TimeDimension {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Valid period term values */
export enum TimeframeTermValues {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ToplineMetrics = {
  __typename?: 'ToplineMetrics';
  dailyActiveUsers: Scalars['Float'];
  eventsPerUser: Scalars['Float'];
  experiencesSeen: Scalars['Int'];
  stickiness: Scalars['Float'];
  uniqueUsers: Scalars['Int'];
};

/** Represents the status of an account's trial */
export type TrialStatus = {
  __typename?: 'TrialStatus';
  /** Trial's creation time is the same as the account's */
  createdAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['DateTime'];
  id: Scalars['ID'];
  isExpired: Scalars['Boolean'];
  isMobileInstalled: Scalars['Boolean'];
  isWebInstalled: Scalars['Boolean'];
  lengthDays: Scalars['Int'];
};

/**
 * Per-trigger gate for v3 (Key Action) goals. `conditionsJson` is the
 * JSON-encoded condition tree applied to the matched event's attributes.
 */
export type Trigger = {
  __typename?: 'Trigger';
  conditionsJson?: Maybe<Scalars['String']>;
  event: Scalars['String'];
};

/** Trigger configuration for v3 (Key Action) goals. */
export type TriggerConfig = {
  __typename?: 'TriggerConfig';
  mode: TriggerMode;
  resetConditionJson?: Maybe<Scalars['String']>;
  triggers?: Maybe<Array<Trigger>>;
  window?: Maybe<TriggerWindow>;
};

/** Trigger configuration input for v3 (Key Action) goals */
export type TriggerConfigInput = {
  mode: TriggerMode;
  resetCondition?: InputMaybe<Scalars['Json']>;
  triggers?: InputMaybe<Array<TriggerInput>>;
  window?: InputMaybe<TriggerWindowInput>;
};

/** Per-trigger gate input for v3 (Key Action) goals. */
export type TriggerInput = {
  conditions?: InputMaybe<Scalars['Json']>;
  event: Scalars['String'];
};

export enum TriggerMode {
  EveryMatch = 'EVERY_MATCH',
  Once = 'ONCE',
  Windowed = 'WINDOWED'
}

/** Window for `:windowed` trigger mode on v3 goals. */
export type TriggerWindow = {
  __typename?: 'TriggerWindow';
  unit: TriggerWindowUnit;
  value: Scalars['Int'];
};

/** Window input for `:windowed` trigger mode on v3 goals */
export type TriggerWindowInput = {
  unit: TriggerWindowUnit;
  value: Scalars['Int'];
};

export enum TriggerWindowUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Session = 'SESSION'
}

/** The outcome of a workflow unarchive attempt */
export type UnarchiveWorkflowResult = {
  __typename?: 'UnarchiveWorkflowResult';
  archived: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  workflow?: Maybe<Workflow>;
};

/** Input for undoing an insight action */
export type UndoInsightActionInput = {
  id: Scalars['ID'];
};

/** The outcome of a workflow unpublish attempt */
export type UnpublishWorkflowResult = {
  __typename?: 'UnpublishWorkflowResult';
  published: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  workflow?: Maybe<Workflow>;
};

/** Represents the set of attributes that can be updated in an account user record */
export type UpdateAccountUserInput = {
  /** Account user ID */
  accountUserId: Scalars['String'];
  /** Account user role */
  roleId?: InputMaybe<AccountRole>;
  /** User intent */
  userIntent?: InputMaybe<Array<Scalars['String']>>;
  /** User usage intent */
  userUsageIntent?: InputMaybe<Array<Scalars['String']>>;
};

/** Update agent access input object */
export type UpdateAgentAccessInput = {
  agentName: Scalars['String'];
  enabled: Scalars['Boolean'];
};

/** Update annotation node input object */
export type UpdateAnnotationNodeInput = {
  color?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  journeyCanvasId?: InputMaybe<Scalars['String']>;
};

/** Update app input object */
export type UpdateAppInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

/** Update app push config input object */
export type UpdateAppPushConfigInput = {
  apnsBundleId?: InputMaybe<Scalars['String']>;
  apnsKey?: InputMaybe<Scalars['String']>;
  apnsKeyId?: InputMaybe<Scalars['String']>;
  apnsTeamId?: InputMaybe<Scalars['String']>;
  appId: Scalars['String'];
  fcmKey?: InputMaybe<Scalars['String']>;
};

/** Update assistant account rule input object */
export type UpdateAssistantAccountRuleInput = {
  agent?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  overrideSystemRuleId?: InputMaybe<Scalars['ID']>;
  rule?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssistantAccountRuleType>;
};

/** Valid assistant session update fields */
export type UpdateAssistantSessionInput = {
  id: Scalars['String'];
  rating?: InputMaybe<Scalars['Int']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignInput = {
  brief?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateChartInput = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  dimensions?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  metrics?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  selectedEvents?: InputMaybe<Array<ChartEventInput>>;
  timeDimension?: InputMaybe<TimeDimension>;
  type?: InputMaybe<ChartType>;
};

/** Update content graph input object */
export type UpdateContentGraphInput = {
  id: Scalars['String'];
  journeyCanvasId?: InputMaybe<Scalars['String']>;
  seed?: InputMaybe<Scalars['String']>;
  seedType?: InputMaybe<Scalars['String']>;
};

export type UpdateDashboardInput = {
  filter?: InputMaybe<DashboardFilterInput>;
  gridConfig?: InputMaybe<Scalars['Json']>;
  id: Scalars['ID'];
  layout?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  timeDimension?: InputMaybe<DashboardTimeDimensionInput>;
};

/** Update doc site integration input object */
export type UpdateDocSiteIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<DocSiteIntegrationType>;
};

/** Update email config input object */
export type UpdateEmailConfigInput = {
  emailProperty?: InputMaybe<Scalars['String']>;
  physicalAddress?: InputMaybe<Scalars['String']>;
  suppressionConditions?: InputMaybe<Scalars['Json']>;
  throttleEnabled?: Scalars['Boolean'];
  throttleLimit?: InputMaybe<Scalars['Int']>;
  throttleTimespanMs?: InputMaybe<Scalars['Int']>;
  windowConditions?: InputMaybe<Scalars['Json']>;
};

/** Update email input object */
export type UpdateEmailInput = {
  fromId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jsonBody?: InputMaybe<Scalars['Json']>;
  mimeBody?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  previewText?: InputMaybe<Scalars['String']>;
  replyToId?: InputMaybe<Scalars['String']>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  themeId?: InputMaybe<Scalars['String']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Update email sender input object */
export type UpdateEmailSenderInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  forwardingAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  ownerId?: InputMaybe<Scalars['String']>;
};

/** Update email template input object */
export type UpdateEmailTemplateInput = {
  id: Scalars['String'];
  jsonBody?: InputMaybe<Scalars['Json']>;
  mimeBody?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  previewText?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Update experiment input object */
export type UpdateExperimentInput = {
  baselineConversionRate?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  contentId?: InputMaybe<Scalars['String']>;
  controlMinimumSampleSize?: InputMaybe<Scalars['Int']>;
  controlSize?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  estimatedDurationInDays?: InputMaybe<Scalars['Int']>;
  estimatedUsersPerDay?: InputMaybe<Scalars['Int']>;
  exposedMinimumSampleSize?: InputMaybe<Scalars['Int']>;
  finalCalculatedTestValue?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  minimumDetectableEffect?: InputMaybe<Scalars['Int']>;
  minimumDetectableEffectRelative?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pausedAt?: InputMaybe<Scalars['DateTime']>;
  powerLevel?: InputMaybe<Scalars['Int']>;
  requiredSampleSize?: InputMaybe<Scalars['Int']>;
  significanceLevel?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<ExperimentState>;
  testSides?: InputMaybe<ExperimentTestSides>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Flow update input object */
export type UpdateFlowInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  /** Public name of the flow. this is used to be displayed for users */
  publicName?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<RuleInput>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Update folder input object */
export type UpdateFolderInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name: Scalars['String'];
};

/** Input for updating funnel metadata (name and/or conversion window) */
export type UpdateFunnelInput = {
  /** Updated conversion window value */
  conversionWindow?: InputMaybe<Scalars['Int']>;
  /** Updated conversion window unit (second, minute, hour, day) */
  conversionWindowUnit?: InputMaybe<ConversionWindowUnit>;
  /** The funnel ID to update */
  funnelId: Scalars['UUID4'];
  /** Updated funnel name */
  name?: InputMaybe<Scalars['String']>;
};

/** Goal update input object */
export type UpdateGoalInput = {
  conditions?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<TriggerConfigInput>;
};

/** Update journey canvas input object */
export type UpdateJourneyCanvasInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  savedOptions?: InputMaybe<JourneyOptions>;
};

/** Update journey canvas node positions input object */
export type UpdateJourneyCanvasNodePositionsInput = {
  id: Scalars['String'];
  nodePositions: Array<InputMaybe<JourneyCanvasNodePositionsInput>>;
};

/** User profile attribute metadata update input */
export type UpdateProfileAttributeLabelInput = {
  attributeName: Scalars['String'];
  metadata?: InputMaybe<ProfileAttributeMetadata>;
};

/** Update push notification input object */
export type UpdatePushNotificationInput = {
  appIds?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['Json']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  personalizationProperties?: InputMaybe<Array<Scalars['String']>>;
  sourceTemplateId?: InputMaybe<Scalars['String']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

/** Update push notification template input object */
export type UpdatePushNotificationTemplateInput = {
  content?: InputMaybe<Scalars['Json']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateSavedViewInput = {
  filters?: InputMaybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['Json']>>>;
};

/** Segment update input */
export type UpdateSegmentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** Update survey entity input object */
export type UpdateSurveyEntityInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

/** Update survey field input object */
export type UpdateSurveyFieldInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  surveyFieldTypeId?: InputMaybe<Scalars['Int']>;
  surveyId?: InputMaybe<Scalars['ID']>;
};

export type UpdateTacticContentInput = {
  brief?: InputMaybe<Scalars['Json']>;
  contentId: Scalars['String'];
  tacticId: Scalars['UUID4'];
};

export type UpdateTacticInput = {
  brief?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID4'];
  name?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Update tag input object */
export type UpdateTagInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** Webhook input for updating a webhook, following PATCH semantics, send null to clear nullable fields. */
export type UpdateWebhookInput = {
  /**
   * The content ids that the webhook is should trigger on.
   * All content_ids should be of the same experience_type as each other and the same as all event_names supplied"
   */
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /**
   * The content type that the webhook is associated with.
   * If this is supplied, then all content_ids must be of the same content type and all event_names must be applicable to that content type.
   * if this is null, then content_ids must be empty, and there are no restrictions on event_names.
   */
  contentType?: InputMaybe<ContentType>;
  /** A description of the use case for the webhook */
  description?: InputMaybe<Scalars['String']>;
  /** The events that will trigger the webhook */
  eventNames?: InputMaybe<Array<InputMaybe<WebhookEventNameAllowlist>>>;
  /** The webhook id */
  id: Scalars['String'];
  /** The webhook name */
  name?: InputMaybe<Scalars['String']>;
  /** An optional secret */
  signingSecret?: InputMaybe<Scalars['String']>;
  /** ENABLED or DISABLED, an end user cannot set SUSPENDED */
  status?: InputMaybe<UserSettableWebhookStatus>;
  /** The url endpoint the payload will be sent to */
  url?: InputMaybe<Scalars['String']>;
};

/** Input for updating a workflow */
export type UpdateWorkflowInput = {
  entryConditions?: InputMaybe<WorkflowEntryConditionsInput>;
  exitConditions?: InputMaybe<WorkflowExitConditionsInput>;
  frequency?: InputMaybe<WorkflowFrequencyInput>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  requireContinuousSegmentEnrollment?: InputMaybe<Scalars['Boolean']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  timeout?: InputMaybe<WorkflowTimeoutInput>;
};

/** Input for updating an existing workflow task of type branch */
export type UpdateWorkflowTaskBranchInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  conditions?: InputMaybe<Scalars['Json']>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type content */
export type UpdateWorkflowTaskContentInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type delay */
export type UpdateWorkflowTaskDelayInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  duration?: InputMaybe<CreateWorkflowTaskDelayDurationInput>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type email */
export type UpdateWorkflowTaskEmailInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type event */
export type UpdateWorkflowTaskEventInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type multipath branch */
export type UpdateWorkflowTaskMultipathBranchInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  conditions?: InputMaybe<Scalars['Json']>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type multipath */
export type UpdateWorkflowTaskMultipathInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  conditions?: InputMaybe<Scalars['Json']>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type push_notification */
export type UpdateWorkflowTaskPushNotificationInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for updating an existing workflow task of type user_property */
export type UpdateWorkflowTaskUserPropertyInput = {
  /** Branch related fields. When used it expects prev_task_id to be of Branch type */
  branchSide?: InputMaybe<WorkflowBranchSide>;
  entryConditions?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextTaskId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<WorkflowTaskOptionsInput>;
  prevTaskId?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['Json']>;
  successConditions?: InputMaybe<WorkflowTaskSuccessConditionsInput>;
  windowConditions?: InputMaybe<WindowConditionsInput>;
  workflowId: Scalars['String'];
};

/** Input for upserting (creating or updating) a funnel */
export type UpsertFunnelInput = {
  /** Conversion window value in the given unit */
  conversionWindow: Scalars['Int'];
  /** Unit for the conversion window (second, minute, hour, day) */
  conversionWindowUnit?: InputMaybe<ConversionWindowUnit>;
  /** Funnel ID (from the transient funnel call) */
  id: Scalars['UUID4'];
  /** User-facing funnel name */
  name: Scalars['String'];
  /** ID of the rule (must be in DRAFT state) to associate this funnel with */
  ruleId: Scalars['UUID4'];
  /** Ordered list of funnel steps (position in array determines step_index) */
  steps: Array<FunnelStepInput>;
};

export type UsageToplineMetrics = {
  __typename?: 'UsageToplineMetrics';
  events: Scalars['Int'];
  pageViews: Scalars['Int'];
  screenViews: Scalars['Int'];
  sessions: Scalars['Int'];
};

/**
 * An entity that can do things within an Appcues account (or sometimes several,
 * though not at the same time): either a human being, or an API key.
 */
export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crxVersion?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasCrxInstalled?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  insertedAt: Scalars['DateTime'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isInvitedUser?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['String']>;
  lastActiveAccountId?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  provider: Scalars['String'];
  providerId: Scalars['String'];
  signature?: Maybe<Scalars['String']>;
  signedUp?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  tokensLastPurgedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  usagePropertiesJson?: Maybe<Scalars['String']>;
  /**
   * Returns a list of AccountUser objects with the associated Account
   * objects when requested.
   */
  userAccounts?: Maybe<Array<AccountUser>>;
};

/** Represents a Survey Answers object */
export type UserAnswer = {
  __typename?: 'UserAnswer';
  fieldAnswers?: Maybe<Array<Maybe<FieldAnswer>>>;
  sessionId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userProfileAttributes?: Maybe<Scalars['Json']>;
};

export type UserCountResult = {
  __typename?: 'UserCountResult';
  count?: Maybe<Scalars['Int']>;
  status: UserCountStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum UserCountStatus {
  Error = 'ERROR',
  NeverCalculated = 'NEVER_CALCULATED',
  Success = 'SUCCESS'
}

/** A user's cadence setting for a single workflow */
export type UserNotificationCadence = {
  __typename?: 'UserNotificationCadence';
  cadence: Cadence;
  workflowKey: Scalars['String'];
};

/** User profile input */
export type UserProfileInput = {
  /** Full name */
  fullName?: InputMaybe<Scalars['String']>;
  /** Job description */
  job?: InputMaybe<Scalars['String']>;
};

export type UserProfileSettings = {
  __typename?: 'UserProfileSettings';
  accountIdentifier: Scalars['String'];
  emailIdentifier?: Maybe<Scalars['String']>;
  userIdentifier: Scalars['String'];
};

/** Valid webhook statuses that are settable by an end user */
export enum UserSettableWebhookStatus {
  /** User indication that the webhook should NOT trigger */
  Disabled = 'DISABLED',
  /** User indication that the webhook should trigger */
  Enabled = 'ENABLED'
}

export type UserWithAttributes = {
  __typename?: 'UserWithAttributes';
  attributes?: Maybe<Scalars['Json']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

/** Represents an webhook object */
export type Webhook = {
  __typename?: 'Webhook';
  contentIds: Array<Maybe<Scalars['ID']>>;
  /**
   * The content type that the webhook is associated with.
   * All content_ids are associated with the same content type and all event_names must be applicable to that content type.
   * if content_ids is empty, then this field is null.
   */
  contentType?: Maybe<ContentType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  eventNames: Array<Maybe<WebhookEventNameAllowlist>>;
  id: Scalars['String'];
  /** Represents a webhook error object */
  lastErrorDetails?: Maybe<FailedWebhookDetails>;
  name: Scalars['String'];
  signingSecret?: Maybe<Scalars['String']>;
  status: WebhookStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  url: Scalars['String'];
  webhookStats?: Maybe<WebhookStats>;
};

/** Allowlist of sendable webhook events */
export enum WebhookEventNameAllowlist {
  /** Checklist Completed */
  ChecklistCompleted = 'CHECKLIST_COMPLETED',
  /** Checklist Item Completed */
  ChecklistItemCompleted = 'CHECKLIST_ITEM_COMPLETED',
  /** Checklist Shown */
  ChecklistShown = 'CHECKLIST_SHOWN',
  /** Checklist Skipped */
  ChecklistSkipped = 'CHECKLIST_SKIPPED',
  /** Device Unregistered */
  DeviceUnregistered = 'DEVICE_UNREGISTERED',
  /** Email Attempted */
  EmailAttempted = 'EMAIL_ATTEMPTED',
  /** Email Bounced */
  EmailBounced = 'EMAIL_BOUNCED',
  /** Email Clicked */
  EmailClicked = 'EMAIL_CLICKED',
  /** Email Delivered */
  EmailDelivered = 'EMAIL_DELIVERED',
  /** Email Failed */
  EmailFailed = 'EMAIL_FAILED',
  /** Email Marked Spam */
  EmailMarkedSpam = 'EMAIL_MARKED_SPAM',
  /** Email Opened */
  EmailOpened = 'EMAIL_OPENED',
  /** Email Sent */
  EmailSent = 'EMAIL_SENT',
  /** Email Skipped */
  EmailSkipped = 'EMAIL_SKIPPED',
  /** Email Soft Bounced */
  EmailSoftBounced = 'EMAIL_SOFT_BOUNCED',
  /** Email Unsubscribed */
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  /** Banner Dismissed */
  ExperienceDismissed = 'EXPERIENCE_DISMISSED',
  /** Mobile Flow Started */
  ExperienceStarted = 'EXPERIENCE_STARTED',
  /** Web Flow Completed */
  FlowCompleted = 'FLOW_COMPLETED',
  /** Web Flow Skipped */
  FlowSkipped = 'FLOW_SKIPPED',
  /** Web Flow Started */
  FlowStarted = 'FLOW_STARTED',
  /** Web Flow Form Submitted */
  FormSubmitted = 'FORM_SUBMITTED',
  /** NPS Feedback */
  NpsFeedback = 'NPS_FEEDBACK',
  /** NPS Score */
  NpsScore = 'NPS_SCORE',
  /** NPS Survey Started */
  NpsSurveyStarted = 'NPS_SURVEY_STARTED',
  /** Push Failed */
  PushFailed = 'PUSH_FAILED',
  /** Push Opened */
  PushOpened = 'PUSH_OPENED',
  /** Push Sent */
  PushSent = 'PUSH_SENT',
  /** Push Skipped */
  PushSkipped = 'PUSH_SKIPPED',
  /** Web Flow Button Clicked */
  StepInteracted = 'STEP_INTERACTED',
  /** Pin Interacted */
  StepInteraction = 'STEP_INTERACTION',
  /** Pin Seen */
  StepSeen = 'STEP_SEEN',
  /** Workflow Entered */
  WorkflowEntered = 'WORKFLOW_ENTERED',
  /** Workflow Exited */
  WorkflowExited = 'WORKFLOW_EXITED',
  /** Workflow Task Completed */
  WorkflowTaskCompleted = 'WORKFLOW_TASK_COMPLETED',
  /** Workflow Task Started */
  WorkflowTaskStarted = 'WORKFLOW_TASK_STARTED'
}

/** Represents an webhook metadata */
export type WebhookMetadata = {
  __typename?: 'WebhookMetadata';
  contentTypes: Array<Maybe<ContentType>>;
  creationLimit: Scalars['Int'];
  eventNames: Array<Maybe<WebhookEventNameAllowlist>>;
  eventNamesByContentType: Array<Maybe<ContentTypeMap>>;
};

/** Represents a webhook error stats object */
export type WebhookStats = {
  __typename?: 'WebhookStats';
  /** The webhooks error rate in the past one hour */
  errorRate: Scalars['Float'];
  /** The number of failed webhooks sent in the previous hour */
  failedCount: Scalars['Int'];
  /** True when a webhook's error rate exceeds the max rate in the previous hour */
  isOverErrorThreshold: Scalars['Boolean'];
  /** The rate that determines when a webhook is over the error threshold */
  maxRate: Scalars['Float'];
  /** The number of successful webhooks sent in the previous hour */
  successfulCount: Scalars['Int'];
};

/** Valid webhook statuses */
export enum WebhookStatus {
  /** User indication that the webhook should NOT trigger */
  Disabled = 'DISABLED',
  /** User indication that the webhook should trigger */
  Enabled = 'ENABLED',
  /** System indication that the webhook should NOT trigger */
  Suspended = 'SUSPENDED'
}

/** Filter flows that are configured to show on launchpad or not */
export enum WidgetFilter {
  /** Include flows that are not configured to show on launchpads */
  Exclude = 'EXCLUDE',
  /** Include flows that are configured to show on any launchpad regardless if the page matches or not. */
  Include = 'INCLUDE',
  /** Include flows that are configured to show on launchpad and only if the page matches */
  Page = 'PAGE'
}

export type WindowConditions = {
  __typename?: 'WindowConditions';
  timezone?: Maybe<Scalars['String']>;
  useRecipientTimezone: Scalars['Boolean'];
  window: Scalars['Json'];
};

export type WindowConditionsInput = {
  timezone?: InputMaybe<Scalars['String']>;
  useRecipientTimezone: Scalars['Boolean'];
  window: Scalars['Json'];
};

/** Represents a full Workflow object */
export type Workflow = {
  __typename?: 'Workflow';
  accountId: Scalars['String'];
  clonedFrom?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  dirty: Scalars['Boolean'];
  entryConditions: WorkflowEntryConditions;
  exitConditions: WorkflowExitConditions;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  folderId?: Maybe<Scalars['UUID4']>;
  frequency?: Maybe<WorkflowFrequency>;
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  name: Scalars['String'];
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<User>;
  requireContinuousSegmentEnrollment: Scalars['Boolean'];
  state: WorkflowState;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tasks: Array<WorkflowTask>;
  timeout?: Maybe<WorkflowTimeout>;
  transitions: Array<WorkflowTransition>;
  type?: Maybe<Scalars['String']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  version: Scalars['Int'];
};

/** Count of active users in a workflow */
export type WorkflowActiveUsersCount = {
  __typename?: 'WorkflowActiveUsersCount';
  count: Scalars['Int'];
};

export type WorkflowAnalyticsEventInput = {
  attributes?: InputMaybe<Scalars['Json']>;
  name: Scalars['String'];
};

/** Branch options */
export enum WorkflowBranchSide {
  Match = 'MATCH',
  Nomatch = 'NOMATCH'
}

/** Input for getting user counts per task in a workflow */
export type WorkflowCurrentTaskUserCountsInput = {
  workflowId: Scalars['String'];
};

/** Result for workflow current task user counts query */
export type WorkflowCurrentTaskUserCountsResult = {
  __typename?: 'WorkflowCurrentTaskUserCountsResult';
  tasks: Array<WorkflowTaskUserCount>;
};

/** Input for getting paginated users on a specific task */
export type WorkflowCurrentTaskUsersInput = {
  /** Task ID, '__start' for users who entered but haven't completed any task, or '__end' for exited users */
  taskId: Scalars['String'];
  workflowId: Scalars['String'];
};

/** Result for workflow current task users query */
export type WorkflowCurrentTaskUsersResult = {
  __typename?: 'WorkflowCurrentTaskUsersResult';
  page?: Maybe<PaginationInfo>;
  settings?: Maybe<UserProfileSettings>;
  users?: Maybe<Array<Maybe<UserWithAttributes>>>;
};

export type WorkflowEmailRequest = {
  __typename?: 'WorkflowEmailRequest';
  attributes?: Maybe<Scalars['Json']>;
  emailId: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  requestId: Scalars['String'];
  userId: Scalars['String'];
};

export enum WorkflowEmailRequestKey {
  Email = 'EMAIL',
  Reason = 'REASON'
}

/** Email request */
export type WorkflowEmailRequestList = {
  __typename?: 'WorkflowEmailRequestList';
  requests?: Maybe<Array<Maybe<WorkflowEmailRequest>>>;
  settings?: Maybe<UserProfileSettings>;
};

export type WorkflowEmailRequestsInput = {
  workflowId: Scalars['String'];
  workflowTaskId: Scalars['String'];
};

export type WorkflowEmailRequestsSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: WorkflowEmailRequestKey;
};

export enum WorkflowEmailTaskKey {
  /** Created at */
  CreatedAt = 'CREATED_AT',
  /** Email name */
  Name = 'NAME'
}

export type WorkflowEmailTaskPerformace = {
  __typename?: 'WorkflowEmailTaskPerformace';
  createdAt: Scalars['DateTime'];
  emailId: Scalars['String'];
  metrics: WorkflowEmailTaskPerformanceMetrics;
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workflowId: Scalars['String'];
  workflowState: WorkflowState;
  workflowTaskId: Scalars['String'];
};

export type WorkflowEmailTaskPerformaceResult = {
  __typename?: 'WorkflowEmailTaskPerformaceResult';
  pageInfo?: Maybe<PageInfo>;
  results: Array<WorkflowEmailTaskPerformace>;
};

export type WorkflowEmailTaskPerformanceMetrics = {
  __typename?: 'WorkflowEmailTaskPerformanceMetrics';
  clicked: Scalars['Int'];
  delivered: Scalars['Int'];
  opened: Scalars['Int'];
  queued: Scalars['Int'];
  sent: Scalars['Int'];
  unsubscribed: Scalars['Int'];
};

export type WorkflowEmailTasksListFilter = {
  /** Name used in a case insensitive 'countaint'-like search */
  name?: InputMaybe<Scalars['String']>;
  /** Subject used in a case insensitive 'countaint'-like search */
  subject?: InputMaybe<Scalars['String']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

export type WorkflowEmailTasksMetricsFilter = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

export type WorkflowEmailTasksPerformanceSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: WorkflowEmailTaskKey;
};

export type WorkflowEntryConditions = {
  __typename?: 'WorkflowEntryConditions';
  eventAttrs?: Maybe<Scalars['Json']>;
  eventName?: Maybe<Scalars['String']>;
  segments: Array<Scalars['String']>;
  timeMaxDays?: Maybe<Scalars['Int']>;
  timeMinDays?: Maybe<Scalars['Int']>;
  timeProperty?: Maybe<Scalars['String']>;
};

export type WorkflowEntryConditionsInput = {
  eventAttrs?: InputMaybe<Scalars['Json']>;
  eventName?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<Scalars['String']>>;
  timeMaxDays?: InputMaybe<Scalars['Int']>;
  timeMinDays?: InputMaybe<Scalars['Int']>;
  timeProperty?: InputMaybe<Scalars['String']>;
};

export type WorkflowEventDistinctUsers = {
  __typename?: 'WorkflowEventDistinctUsers';
  numDistinctUsers: Scalars['Int'];
  prevNumDistinctUsers: Scalars['Int'];
};

export type WorkflowEventDistinctUsersInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  event: WorkflowAnalyticsEventInput;
  previousEvent?: InputMaybe<WorkflowAnalyticsEventInput>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type WorkflowEventsPerDay = {
  __typename?: 'WorkflowEventsPerDay';
  date: Scalars['Date'];
  distinctUsers: Scalars['Int'];
  name: Scalars['String'];
  taskId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type WorkflowEventsPerDayInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  events: Array<InputMaybe<Scalars['String']>>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type WorkflowExitConditions = {
  __typename?: 'WorkflowExitConditions';
  eventAttrs?: Maybe<Scalars['Json']>;
  eventName?: Maybe<Scalars['String']>;
};

export type WorkflowExitConditionsInput = {
  eventAttrs?: InputMaybe<Scalars['Json']>;
  eventName?: InputMaybe<Scalars['String']>;
};

/** Represents a set of AND conditions that a workflow should match */
export type WorkflowFilter = {
  /** User id to match with the Workflow created_at field */
  creator?: InputMaybe<Scalars['String']>;
  /** List of states to filter by. When empty get the draft ones */
  states?: Array<WorkflowState>;
  /** Tag ids to filter by. */
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  /** String used to search for a Workflow by name */
  term?: InputMaybe<Scalars['String']>;
};

export type WorkflowFrequency = {
  __typename?: 'WorkflowFrequency';
  unit: WorkflowFrequencyUnit;
  value: Scalars['Int'];
};

export type WorkflowFrequencyInput = {
  unit: WorkflowFrequencyUnit;
  value: Scalars['Int'];
};

export enum WorkflowFrequencyUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS'
}

/** Valid workflow sort keys */
export enum WorkflowSortKey {
  /** When the workflow was created */
  CreatedAt = 'CREATED_AT',
  /** workflow name */
  Name = 'NAME',
  /** When the workflow was published */
  PublishedAt = 'PUBLISHED_AT',
  /** Last time the workflow got updated */
  UpdatedAt = 'UPDATED_AT'
}

/** Combination of a column and a sort direction used when sorting workflows */
export type WorkflowSortOrder = {
  direction?: InputMaybe<SortDirection>;
  key: WorkflowSortKey;
};

/** Valid workflow statuses */
export enum WorkflowState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Versioned = 'VERSIONED'
}

/** Represents a summary Workflow object */
export type WorkflowSummary = {
  __typename?: 'WorkflowSummary';
  accountId: Scalars['String'];
  clonedFrom?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions: WorkflowEntryConditions;
  exitConditions: WorkflowExitConditions;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  folderId?: Maybe<Scalars['UUID4']>;
  frequency?: Maybe<WorkflowFrequency>;
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  name: Scalars['String'];
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<User>;
  requireContinuousSegmentEnrollment: Scalars['Boolean'];
  state: WorkflowState;
  tagIds?: Maybe<Array<Scalars['String']>>;
  timeout?: Maybe<WorkflowTimeout>;
  type?: Maybe<Scalars['String']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  unpublishedBy?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  version: Scalars['Int'];
};

export type WorkflowTask = {
  id: Scalars['String'];
  internalId: Scalars['ID'];
};

export type WorkflowTaskBranch = WorkflowTask & {
  __typename?: 'WorkflowTaskBranch';
  branchJoinId?: Maybe<Scalars['String']>;
  conditions: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  matchTransitionId?: Maybe<Scalars['String']>;
  nomatchTransitionId?: Maybe<Scalars['String']>;
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskBranchJoin = WorkflowTask & {
  __typename?: 'WorkflowTaskBranchJoin';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskContent = WorkflowTask & {
  __typename?: 'WorkflowTaskContent';
  content?: Maybe<WorkflowTaskContentReference>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskContentReference = Flow;

export enum WorkflowTaskContentType {
  Flow = 'FLOW'
}

export type WorkflowTaskDelay = WorkflowTask & {
  __typename?: 'WorkflowTaskDelay';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  duration?: Maybe<WorkflowTaskDuration>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  timestamp?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskDistinctUserRollup = {
  __typename?: 'WorkflowTaskDistinctUserRollup';
  distinctUsers: Scalars['Int'];
  email?: Maybe<Email>;
  id: Scalars['String'];
  pushNotification?: Maybe<PushNotification>;
};

export type WorkflowTaskDistinctUserRollupInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type WorkflowTaskDistinctUserSummary = {
  __typename?: 'WorkflowTaskDistinctUserSummary';
  tasks: Array<WorkflowTaskDistinctUserRollup>;
};

export type WorkflowTaskDuration = {
  __typename?: 'WorkflowTaskDuration';
  unit: WorkflowTaskDurationUnit;
  value: Scalars['Int'];
};

export enum WorkflowTaskDurationUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS'
}

export type WorkflowTaskEmail = WorkflowTask & {
  __typename?: 'WorkflowTaskEmail';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  email?: Maybe<Email>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskEvent = WorkflowTask & {
  __typename?: 'WorkflowTaskEvent';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  eventName?: Maybe<Scalars['String']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskEventList = {
  __typename?: 'WorkflowTaskEventList';
  page?: Maybe<PaginationInfo>;
  settings?: Maybe<UserProfileSettings>;
  users?: Maybe<Array<Maybe<UserWithAttributes>>>;
};

export type WorkflowTaskEventListInput = {
  endDate: Scalars['DateTime'];
  event: Scalars['String'];
  startDate: Scalars['DateTime'];
  term?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['String'];
  workflowTaskId?: Scalars['String'];
};

export type WorkflowTaskEventRollupInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
  workflowTaskId: Scalars['String'];
};

export type WorkflowTaskEventSummary = {
  __typename?: 'WorkflowTaskEventSummary';
  events: Array<WorkflowTaskSingleEventRollup>;
  queued?: Maybe<Scalars['Int']>;
};

export type WorkflowTaskEventsPerDay = {
  __typename?: 'WorkflowTaskEventsPerDay';
  date: Scalars['Date'];
  distinctUsers: Scalars['Int'];
  name: Scalars['String'];
};

export type WorkflowTaskEventsPerDayInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['String'];
  workflowTaskId: Scalars['String'];
};

export type WorkflowTaskExitFunnel = {
  __typename?: 'WorkflowTaskExitFunnel';
  completed: Scalars['Int'];
  entered: Scalars['Int'];
  reached: Scalars['Int'];
  task: WorkflowTask;
};

export type WorkflowTaskExitFunnelsInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  workflowId: Scalars['String'];
};

export type WorkflowTaskMultipath = WorkflowTask & {
  __typename?: 'WorkflowTaskMultipath';
  branchJoinId?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskMultipathBranch = WorkflowTask & {
  __typename?: 'WorkflowTaskMultipathBranch';
  conditions?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskOptions = {
  __typename?: 'WorkflowTaskOptions';
  contentStopShow?: Maybe<WorkflowTaskOptionsContentStopShow>;
  overrideEmailThrottle?: Maybe<Scalars['Boolean']>;
  pushNotificationDeviceConditions?: Maybe<Scalars['Json']>;
  pushNotificationLatestDeviceOnly?: Maybe<Scalars['Boolean']>;
};

export type WorkflowTaskOptionsContentStopShow = {
  __typename?: 'WorkflowTaskOptionsContentStopShow';
  afterTimePeriodValues?: Maybe<Scalars['Json']>;
  selectedOption: WorkflowTaskOptionsContentStopShowOption;
};

export type WorkflowTaskOptionsContentStopShowInput = {
  afterTimePeriodValues?: InputMaybe<Scalars['Json']>;
  selectedOption: WorkflowTaskOptionsContentStopShowOption;
};

export enum WorkflowTaskOptionsContentStopShowOption {
  AfterTimePeriod = 'AFTER_TIME_PERIOD',
  FinishWorkflow = 'FINISH_WORKFLOW',
  ReachNextNode = 'REACH_NEXT_NODE'
}

export type WorkflowTaskOptionsInput = {
  contentStopShow?: InputMaybe<WorkflowTaskOptionsContentStopShowInput>;
  overrideEmailThrottle?: InputMaybe<Scalars['Boolean']>;
  pushNotificationDeviceConditions?: InputMaybe<Scalars['Json']>;
  pushNotificationLatestDeviceOnly?: InputMaybe<Scalars['Boolean']>;
};

export type WorkflowTaskPoll = WorkflowTask & {
  __typename?: 'WorkflowTaskPoll';
  conditions?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskPushNotification = WorkflowTask & {
  __typename?: 'WorkflowTaskPushNotification';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  pushNotification?: Maybe<PushNotification>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

/** The outcome of deleting a task from a workflow */
export type WorkflowTaskResult = {
  __typename?: 'WorkflowTaskResult';
  /** An optional message string with details about the result */
  message?: Maybe<Scalars['String']>;
  /** Whether the result succeeded or not */
  success: Scalars['Boolean'];
  task?: Maybe<WorkflowTask>;
  workflow?: Maybe<Workflow>;
};

export type WorkflowTaskRuntimeStats = {
  __typename?: 'WorkflowTaskRuntimeStats';
  currentUsers: Scalars['Int'];
};

export type WorkflowTaskRuntimeStatsInput = {
  taskId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type WorkflowTaskSingleEventRollup = {
  __typename?: 'WorkflowTaskSingleEventRollup';
  distinctUsers: Scalars['Int'];
  name: Scalars['String'];
  prevDistinctUsers: Scalars['Int'];
};

export type WorkflowTaskSuccessConditions = {
  __typename?: 'WorkflowTaskSuccessConditions';
  eventNames?: Maybe<Array<Scalars['String']>>;
  maxWaitUnit?: Maybe<WorkflowFrequencyUnit>;
  maxWaitValue?: Maybe<Scalars['Int']>;
};

export type WorkflowTaskSuccessConditionsInput = {
  eventNames?: InputMaybe<Array<Scalars['String']>>;
  maxWaitUnit?: InputMaybe<WorkflowFrequencyUnit>;
  maxWaitValue?: InputMaybe<Scalars['Int']>;
};

/** Count of users on a workflow task */
export type WorkflowTaskUserCount = {
  __typename?: 'WorkflowTaskUserCount';
  taskId: Scalars['String'];
  taskName?: Maybe<Scalars['String']>;
  taskType?: Maybe<Scalars['String']>;
  userCount: Scalars['Int'];
};

export type WorkflowTaskUserProperty = WorkflowTask & {
  __typename?: 'WorkflowTaskUserProperty';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  properties?: Maybe<Scalars['Json']>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTaskWait = WorkflowTask & {
  __typename?: 'WorkflowTaskWait';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  entryConditions?: Maybe<Scalars['Json']>;
  eventConditions?: Maybe<Scalars['Json']>;
  eventName: Scalars['String'];
  failureConditions?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** The id of the workflow task parent */
  internalId: Scalars['ID'];
  options?: Maybe<WorkflowTaskOptions>;
  successConditions?: Maybe<WorkflowTaskSuccessConditions>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  windowConditions?: Maybe<WindowConditions>;
};

export type WorkflowTimeout = {
  __typename?: 'WorkflowTimeout';
  unit: WorkflowTimeoutUnit;
  value: Scalars['Int'];
};

export type WorkflowTimeoutInput = {
  unit: WorkflowTimeoutUnit;
  value: Scalars['Int'];
};

export enum WorkflowTimeoutUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS'
}

/** A transition in a workflow */
export type WorkflowTransition = {
  __typename?: 'WorkflowTransition';
  /** The conditions that must be met for the transition to be taken */
  conditions?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  /** The task to transition from */
  fromTask?: Maybe<WorkflowTask>;
  id: Scalars['ID'];
  /** The priority of the transition relative to others between the same nodes */
  priority: Scalars['Int'];
  /** The task to transition to */
  toTask?: Maybe<WorkflowTask>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};
